<template lang="pug">
div(ref='pdfWholePage')
    
    //- b-container(v-if='axiosReady')
    //-   | axios getting ready
    b-container().main-container.mt-2.mb-4
      .text-right.my-5
        small.text-muted Version: {{ formVersion }}
        .col-auto.my-2(v-if='draftCreatedBy || draftLastModifiedBy' style='font-size:0.85rem; color:#6c757d;')
                span(v-if='draftCreatedBy') Created by: 
                  strong {{ draftCreatedBy }}
                span.mx-2(v-if='draftCreatedBy && draftLastModifiedBy') |
                span(v-if='draftLastModifiedBy') Last edited by: 
                  strong {{ draftLastModifiedBy }}
      form
         b-overlay(:show="processing || !caregiverClientName || !holidaysLoaded" spinner-variant="primary"
          spinner-type="grow"
          overlay-tag="div"
          :opacity="0.7"
        )
          template(#overlay)
            .text-center.p-4
              b-spinner(variant="primary" type="grow")
              p.mt-3.font-weight-bold(v-if="!holidaysLoaded && holidayRetrying") Retrying to load public holidays...
              p.mt-3.font-weight-bold(v-else-if="!holidaysLoaded") Loading public holidays...
              p.mt-3.font-weight-bold(v-else) Please wait...
          .my-4(v-if="previousAssessment")
            b-card.mb-4( header="Previous Assessment Record" header-bg-variant="success" header-text-variant="white" border-variant="success" class="shadow-sm")
              b-row.mb-2.align-items-center
                b-col(cols="4")
                  b-icon.mx-2(icon="calendar-check-fill" variant="primary" class="mr-2")
                  span.font-weight-bold Assessment Date:
                b-col
                  span {{ previousAssessment ? formatDatePublicHoliday(previousAssessment.crb5c_dateofassessment) : 'N/A' }}
              b-row.mb-2.align-items-center(v-if="this.selectedCipTemplate")
                b-col(cols="4")
                  b-icon.mx-2(icon="award" variant="success" class="mr-2")
                  span.font-weight-bold CIP Subsidy:
                b-col
                  span {{ this.selectedCipTemplate ? this.selectedCipTemplate.description : 'N/A' }}
              b-row.mb-2.align-items-center(v-if='previousAssessment.crb5c_cipphase')
                b-col(cols="4")
                  b-icon.mx-2(icon="file-earmark-text" variant="info" class="mr-2")
                  span.font-weight-bold Current Phase :
                b-col
                  span {{ previousAssessment.crb5c_cipphase }}
              b-row.mb-2.align-items-center
                b-col(cols="4")
                  b-icon.mx-2(icon="file-earmark-text" variant="info" class="mr-2")
                  span.font-weight-bold Pre-admission MOCA Score :
                b-col
                  span {{ previousAssessment.crb5c_mocatotalscore || 'N/A' }}
              //- b-row.mb-2.align-items-center
              //-   b-col(cols="4")
              //-     b-icon(icon="file-earmark-text" variant="info" class="mr-2")
              //-     span.font-weight-bold 14th session MOCA score :
              //-   b-col
              //-     span {{ 'N/A' }}
              //- b-row.mb-2.align-items-center
              //-   b-col(cols="4")
              //-     b-icon(icon="file-earmark-text" variant="info" class="mr-2")
              //-     span.font-weight-bold Subsequent 18th session MOCA score :
              //-   b-col
              //-     span {{ 'N/A' }}
              //- b-row.mb-2.align-items-center
              //-   b-col(cols="4")
              //-     b-icon(icon="file-earmark-text" variant="info" class="mr-2")
              //-     span.font-weight-bold Final 8th session MOCA score :
              //-   b-col
              //-     span {{ 'N/A' }}
          .mb-4
            .row
              .col-auto
                b-button.mx-2(variant='danger' @click='clearLocalStorage') Clear Form
                  b-icon.mx-2(icon="arrow-repeat")
                b-button.mx-2(:variant="draftSaveStatus === 'saved' ? 'success' : draftSaveStatus === 'error' ? 'danger' : 'outline-secondary'" @click='saveDraft' :disabled='formCompleted || !draftAssessmentId || draftSaving')
                  b-spinner.mr-1(v-if='draftSaving' small)
                  b-icon.mx-2(v-else :icon="draftSaveStatus === 'saved' ? 'check2' : draftSaveStatus === 'error' ? 'exclamation-triangle' : 'cloud-arrow-up'")
                  | {{ draftSaving ? 'Saving...' : draftSaveStatus === 'saved' ? 'Saved!' : draftSaveStatus === 'error' ? 'Save Failed' : 'Save Draft' }}
                label Date: 
                  span(style="font-weight: bold;").mx-2 {{ dateofassessment }}
              
                  span
                    b-button.timeEdit(v-b-modal="'modal-time'" v-show="notPDFview") Edit date
          //- div
          //-   button(@click="generatePDF") Generate PDF
          section.p-4.border.mb-4.border-light.rounded.shadow
            .row
              .col-sm-6
                label.common(for="typeof") Type of Dementia:
                v-select(v-model="type" :options="DementiaType")
              .col-sm-6
                label.common(for="stageof") Stage of Dementia:
                v-select(v-model="stageof" :options="DementiaStage")
            .row.mt-3
              .col-sm-6
                label.common(for="score") Latest score on:
                .row.center
                  .col-2
                    b-form-checkbox(type="checkbox" v-model="isAMT" value="AMT") &nbsp;AMT
                    .row.center
                      .col-2(v-if="isAMT") 
                          input.checkbox#score(v-model="amtVal" type="number" min="0" )
                  .col-2
                    b-form-checkbox(type="checkbox" v-model="isMMSE" value="MMSE") &nbsp;MMSE 
                    .row.center 
                      .col-2(v-if="isMMSE")
                        input.checkbox#score(v-model="mmseVal" type="number" min="0")
                  .col-2 
                    b-form-checkbox(type="checkbox" v-model="isMOCA" value="MOCA") &nbsp;MOCA
                    .row.center
                      .col-2(v-if="isMOCA")
                        input.checkbox#score(v-model="mocaVal" type="number" min="0")
              .col-sm-6
                label.common(for="score") Date Done in hospital:
                input.numbers#score(v-model="date" name="score" type="date")

              .col-sm-6.mt-2
                p.common.gap Education Level:
                v-select(v-model="edulev" :options="edulevel").mt-3
                .gap(v-show="edulev")
                  p.common.gap Education Year:
                  div
                    input#un.checkbox_circle(v-model="unyearSelected" name="unbx" type="checkbox" value="un" disabled="true")
                    label.gapped(for="un") ≤ 6 Years
                  div
                    input#ov.checkbox_circle(v-model="ovyearSelected" name="ovbx" type="checkbox" value="ov" disabled="true")
                    label.gapped(for="ov") > 6 Years
          
  
          // General questions (remove restrictions v-show="type && stageof && date && (isAMT || isMOCA || isMMSE)")
          section.p-4.border.my-4.border-light.rounded.shadow()
            label.mb-2(style="font-size: 17px;font-weight: bold;" v-if="!previousAssessment") General:
            b-form-checkbox.mb-2(v-model="checker" value="sacop" name="part2" v-if="!previousAssessment") &nbsp;Shared about Centre's objectives & program
            b-form-checkbox.mb-2(v-model="checker2" name="part2" value="wcv" v-if="!previousAssessment") &nbsp;Watched Centre's video
            b-form-checkbox(v-model="checker3" name="part2" value="pttg" v-if="!previousAssessment") &nbsp;Played Table Top games
            hr
            label.mb-2(style="font-size: 17px;font-weight: bold;") Games & Surveys:
            b-form-checkbox.mb-2(name="the-pnbtg" value="pnbtg" v-model="neeuro" v-if="!previousAssessment") &nbsp;Played NeeuroFIT brain training game
            b-card.my-4(v-show="neeuro"  header-tag="header")
              template(#header)
                h5.font-weight-bold Neeurofit
              b-form-checkbox.mb-2(v-model="atten" name="part2ins" value="att") &nbsp;Attention
              .row.mb-2(v-show="atten")
                .col-sm-6
                  label(for="stageof" ) Game played:
                  v-select(:options="game1" v-model="attentionObj.attentiongame")
                .col-sm-6
                  label(for="stageof" ) Finished Level:
                  v-select(:options="levels" v-model="attentionObj.attentionlevel")
              b-form-checkbox.mb-2(type="checkbox" name="part2ins" v-model="spatial" value="spat") &nbsp;Spatial
              .row.mb-2(v-show="spatial")
                .col-sm-6
                  label(for="stageof") Game Played:
                  v-select(:options="game2" v-model="spatialObj.spatialgame")
                .col-sm-6
                  label(for="stageof") Finished Level:
                  v-select(:options="levels" v-model="spatialObj.spatiallevel")
              b-form-checkbox.mb-2(type="checkbox" name="part2ins" v-model="decision" value="dec") &nbsp;Decision
              .row.mb-2(v-show="decision")
                .col-sm-6
                  label(for="stageof") Game Played:
                  v-select(:options="game3" v-model="decisionObj.decisiongame")
                .col-sm-6
                  label(for="stageof") Finished Level:
                  v-select(:options="levels" v-model="decisionObj.decisionlevel")
              b-form-checkbox.mb-2(type="checkbox" name="part2ins" v-model="memory" value="mem") &nbsp;Memory
              .row.mb-2(v-show="memory")
                .col-sm-6
                  label(for="stageof") Game Played:
                  v-select(:options="game4" v-model="memoryObj.memorygame")
                .col-sm-6
                  label(for="stageof") Finished Level:
                  v-select(:options="levels" v-model="memoryObj.memorylevel")
              b-form-checkbox.mb-2(type="checkbox" name="part2ins" v-model="flexibility" value="flexi") &nbsp;Flexibility
              .row.mb-2(v-show="flexibility")
                .col-sm-6
                  label(for="stageof") Game Played:
                  v-select(:options="game5" v-model="flexibilityObj.flexibilitygame")
                .col-sm-6
                  label(for="stageof") Finished Level:
                  v-select(:options="levels" v-model="flexibilityObj.Flexibilitylevel")
  
            //MOCA form     
            b-form-checkbox.mb-2(v-model="checker4" name="mocaform" type="checkbox" value="mocaform") &nbsp;MOCA form
            b-card.my-4(v-show="checker4"  header-tag="header")
              template(#header)
                .d-flex.align-items-center.justify-content-between
                  h5.font-weight-bold.mb-0 MOCA
                  b-button-group(size="sm")
                    b-button(
                      :variant="mocaLanguage === 'en' ? 'primary' : 'outline-primary'"
                      @click="mocaLanguage = 'en'"
                    ) EN
                    b-button(
                      :variant="mocaLanguage === 'zh' ? 'primary' : 'outline-primary'"
                      @click="mocaLanguage = 'zh'"
                    ) 中文
              //- p.common Version:
              //- div.d-flex
              //-   b-form-checkbox(v-model="language" name="languageVer" type="checkbox" value="0" disabled) &nbsp;Chinese
              //-   b-form-checkbox.mx-4(v-model="language" name="languageVer" type="checkbox" value="1") &nbsp;English
              //- p.common.gap Education Level:
              //- .col-sm-6
              //-   v-select(v-model="edulev" :options="edulevel")
              //-   .gap(v-show="edulev")
              //-     p.common.gap Education Year:
              //-     div
              //-       input#un.checkbox_circle(v-model="unyearSelected" name="unbx" type="checkbox" value="un" disabled="true")
              //-       label.gapped(for="un") ≤ 6 Years
              //-     div
              //-       input#ov.checkbox_circle(v-model="ovyearSelected" name="ovbx" type="checkbox" value="ov" disabled="true")
              //-       label.gapped(for="ov") > 6 Years
              .row
                p.common.gap.mb-4 Visuospatial/Executive
                
                .col-sm-6 
                  .row.mb-4
                    img(@click="pick_answer_naming('1')").image_container_number(:src =" vis1 == '1' ? '/form-images/number_correct.png': '/form-images/number.png'")
                  .row
                    label Alternating Trail Making:
                    v-select(v-model="vis1" :options="['0', '1']" :clearable="false" :class="{'moca-point-selected': parseInt(vis1) >= 1}")
                .col-sm-6 
                  .row.mb-4
                    img(@click="pick_answer_naming('2')").image_container_cube(:src =" vis2 == '1' ? '/form-images/cube_correct.png': '/form-images/cube.png'")
                  .row
                    label Copy Cube:
                    v-select(v-model="vis2" :options="['0', '1']" :clearable="false" :class="{'moca-point-selected': parseInt(vis2) >= 1}") 
  
  
                label.gap Draw Clock (Ten past eleven)
                  span(v-if="vis3.length" style="font-weight:bold; color: #28a745;") &nbsp; [{{ vis3.length }}/3]
                v-select(multiple v-model="vis3" :options="dclock" :clearable="false" :class="{'moca-point-selected': vis3.length >= 1}") 
              .row 
                p.common.gap Naming
                  .row.center_items_row.mb-4
                    .col-auto
                      img(@click="pick_answer_naming('4')").image_container_lion(:src=" vis4 == '1' ? '/form-images/lion_correct.png': '/form-images/lion.png'")
                    .col-auto 
                      img(@click="pick_answer_naming('5')").image_container_elephant(:src=" vis5 == '1' ? '/form-images/elephant_correct.png': '/form-images/elephant.png'")
                    .col-auto
                      img(@click="pick_answer_naming('6')").image_container_camel(:src=" vis6 == '1' ? '/form-images/camel_correct.png': '/form-images/camel.png'")
                .col-sm-6 
                  label Lion:
                  v-select(v-model="vis4" :options="['0', '1']" :clearable="false" :class="{'moca-point-selected': parseInt(vis4) >= 1}")
                .col-sm-6 
                  label Elephant:
                  v-select(v-model="vis5" :options="['0', '1']" :clearable="false" :class="{'moca-point-selected': parseInt(vis5) >= 1}")
                .col-sm-6 
                  label.gap Camel:
                  v-select(v-model="vis6" :options="['0', '1']" :clearable="false" :class="{'moca-point-selected': parseInt(vis6) >= 1}")
                //- p.common.gap Memory[0 Point]
                //- .col-sm-6
                //-   input.numbers(type="text" value="0" disabled)
              .row
                p.common.gap Attention
                .col-sm-6
                  label Repeat Forward order 2 1 8 5 4 :
                  v-select(v-model="vis7" :options="['0', '1']" :clearable="false" :class="{'moca-point-selected': parseInt(vis7) >= 1}")
                .col-sm-6
                  label Repeat Backward order 7 4 2 :
                  v-select(v-model="vis17" :options="['0', '1']" :clearable="false" :class="{'moca-point-selected': parseInt(vis17) >= 1}")
                .col-sm-6.gap
                  label Able to tap with his hand at each number 1: 
                  label.mx-1.text-muted  (62137811976216174511191796112)
                  v-select(v-model="vis8" :options="['0', '1']" :clearable="false" :class="{'moca-point-selected': parseInt(vis8) >= 1}")
                .col-sm-6.gap
                  label Serial 7 subtraction starting at 100: (93,86,79,72,65)
                  ul.my-2
                     li.text-muted 1 Point : 1 correct
                     li.text-muted 2 Points : 2 to 3 correct
                     li.text-muted 3 Points : 4 to 5 correct
                  v-select(v-model="vis9" :options="['0', '1', '2', '3']" :clearable="false" :class="{'moca-point-selected': parseInt(vis9) >= 1}")
              .row
                p.common.gap Language
                .col-sm-6
                  label Repeat First Sentence: 
                  label.mx-2.text-muted {{ mocaLanguage === 'en' ? '(I only know that John will help me today)' : '(我只知道今天阿明会帮我)' }}
                  v-select(v-model="vis10" :options="['0', '1']" :clearable="false" :class="{'moca-point-selected': parseInt(vis10) >= 1}")
                .col-sm-6
                  label Repeat Second Sentence: 
                  label.text-muted {{ mocaLanguage === 'en' ? '(When dogs were in the room, the cat always hid under the bed)' : '(狗在房间的时候，猫都会躲在床下)' }}
                  v-select(v-model="vis11" :options="['0', '1']" :clearable="false" :class="{'moca-point-selected': parseInt(vis11) >= 1}")
                .col-sm-6.gap
                  label Fluency (Specify how many animals): 
                    span(style="font-weight:bold") &nbsp; [ {{ fluencyPoints }} point ]
                  p.text-muted 1 point for 11 or more animals
                  v-select(v-model="vis18" :options="specify" :clearable="false" :class="{'moca-point-selected': parseInt(vis18) >= 11}")
              .row 
                p.common.gap Abstraction
                .col-sm-6 
                  label Similarity between train - bicycle: {{ mocaLanguage === 'en' ? '' : '(火车- 脚踏车)' }}
                  v-select(v-model="vis13" :options="['0', '1']" :clearable="false" :class="{'moca-point-selected': parseInt(vis13) >= 1}")
                .col-sm-6 
                  label Similarity between watch - ruler: {{ mocaLanguage === 'en' ? '' : '(手表-尺)' }}
                  v-select(v-model="vis14" :options="['0', '1']" :clearable="false" :class="{'moca-point-selected': parseInt(vis14) >= 1}")
              p.common.gap Delayed Recall
                span(v-if="delayedrecall > 0" style="font-weight:bold; color: #28a745;") &nbsp; [{{ delayedrecall }}/5]
              v-select(multiple v-model="vis15" :options="mocaLanguage === 'en' ? Delayed : DelayedChinese" :class="{'moca-point-selected': delayedrecall >= 1}")
              p.common.gap Orientation
                span(v-if="vis16.length > 0" style="font-weight:bold; color: #28a745;") &nbsp; [{{ vis16.length }}/6]
              v-select(multiple v-model="vis16" :options="mocaLanguage === 'en' ? ['Date', 'Month', 'Year', 'Day', 'Place', 'Country'] : OrientationChinese" :class="{'moca-point-selected': vis16.length >= 1}")
              p.common.gap Total Score: {{ totalscore }}
            b-form-checkbox.mb-2(v-model="checker5" name="eq5d" type="checkbox" value="eq5d") &nbsp;EQ-5D-5L form
              // input#eq5d.checkbox_circle(v-model="checker5" name="eq5d" type="checkbox" value="eq5d")
              // label.gapped.text-small(for="eq5d") EQ-5D-5L form
            b-card.my-4( v-if="previousAssessment && checker5 " header="Previous EQ-5D-5L Record" header-bg-variant="success" header-text-variant="white" border-variant="success" class="shadow-sm")
              p Previous Score: {{ previousAssessment.crb5c_eqtotalscore || 'N/A' }}
              p Previous Health Scale: {{ previousAssessment.crb5c_eqhealthscale || 'N/A' }}
            b-card.gap(v-show="checker5"  header-tag="header")
              template(#header)
                h5.font-weight-bold EQ-5D-5L
              .row
                .left.col-sm-6
                  .row.mb-3
                    label.col-lg-4 Mobility:
                    v-select.col-lg-8(v-model="eq1" :options="eq5dnumbers" :clearable="false")
                  .row.mb-3
                    label.col-lg-4 Self-Care:
                    v-select.col-lg-8(v-model="eq2" :options="eq5dnumbers" :clearable="false")
                  .row.mb-3
                    label.col-lg-4 Usual Activities:
                    v-select.col-lg-8(v-model="eq3" :options="eq5dnumbers" :clearable="false")
                  .row.mb-3
                    label.col-lg-4 Pain / Discomfort:
                    v-select.col-lg-8(v-model="eq4" :options="eq5dnumbers" :clearable="false")
                  .row.mb-3
                    label.col-lg-4 Anxiety/Depression:
                    v-select.col-lg-8(v-model="eq5" :options="eq5dnumbers" :clearable="false")
                .col-sm-6
                  b-card.mx-auto(header-tag="header")
                    template(#header)
                      h5.font-weight-bold Total Score
                    h5.font-weight-bold.mx-auto {{ eq5dcounter }}/25
                  b-card.mx-auto.mt-3(header-tag="header")
                    template(#header)
                      div.d-flex
                        h5.font-weight-bold Perceived Health Scale:
                        input.numberslider.mx-3.my-auto.w-25(style="font-size:22px;font-weight:bold;" v-model="healthscale" type="number" min="0" max="100" onkeydown="return event.keyCode !== 190") 
                    .row 
                      .col-sm-12
                        input.numbers(v-model="healthscale" type="range" min="0" max="100") 

          //remove restrictions v-show="type && stageof && date && (neeuro || checker || checker2 || checker3 || checker4 || checker5)"
          section.p-4.border.my-4.border-light.rounded.shadow()
            .formed
              label.common(for="comment") Comment/Observation about the client
              textarea#comment.p-2(name="comment" rows="3" type="text" placeholder="Comment about the client" v-model="checking")

          //remove restriction v-show="type && stageof && date && (neeuro || checker || checker2 || checker3 || checker4 || checker5)"
          section.p-4.border.my-4.border-light.rounded.shadow(v-if="cipPreset")
            //- Phase 3 Completion Choice
            b-card.mb-4(v-if="isPhase3Completion" header="Phase 3 Completed - Choose Next Step" header-bg-variant="info" header-text-variant="white" border-variant="info" class="shadow-sm")
              .row
                .col-12
                  p.mb-3 Client have completed all 3 phases of the CIP programme. Pick the next step:
                  
                  .row.mt-4
                    .col-md-6.mb-3
                        b-card.h-100.border-success(bg-variant="light")
                          template(#header)
                            h5.mb-0.text-success
                              b-icon.mx-2(icon="arrow-right-circle-fill")
                              | Switch to FOW
                          p.mb-3 Continue with FOW programme. Select recommended sessions and generate invoice.
                          b-button(variant="success" block size="lg" @click="handleSwitchToFow")
                            | Continue FOW
                    .col-md-6.mb-3
                      b-card.h-100.border-danger(bg-variant="light")
                        template(#header)
                          h5.mb-0.text-danger
                            b-icon.mx-2(icon="check-circle-fill")
                            | Discharge
                        p.mb-3 No more sessions. Submit MOCA score and assessment only.
                        b-button(variant="danger" block size="lg" @click="handleCompleteProgram")
                          | Discharge Client
                    
            .row
              .col(v-if="!isPhase3Completion")
                label.common Current CIP Eligibility (click to switch):
              
             
              
                b-button.mx-3(v-if="cipEligibility" variant="success" @click="chooseCIPtemplate" v-show="notPDFview") {{ selectedCipTemplate.description || 'Choose Template' }}
                label.my-3(v-if="cipEligibility"  variant="success")
                label.my-3(v-else variant="danger")
                  b-icon.mx-3(icon="exclamation-triangle-fill" variant="danger" class="mr-1")
                  | Not Eligible for CIP
              
              //- Override Control Buttons
              .col-12.my-3(v-if="showEligibilityControls && notPDFview")
                .d-flex.flex-wrap.gap-2.align-items-center
                  //- Button 1: Manual CIP Eligibility Override
                  b-button.mr-2(
                    v-if="!cipEligibility && cipPreset && !isPhase3Completion"
                    :variant="manualEligibilityButtonVariant"
                    size="sm"
                    @click="toggleManualCipEligibility"
                  )
                    b-icon.mx-2(icon="check-circle-fill" v-if="manualCipEligibility === true")
                    b-icon.mx-2(icon="exclamation-circle" v-else)
                    | {{ manualEligibilityButtonText }}
                  
                  //- Button 2: Programme Type Override (CIP ↔ FOW)
                  //- b-button.mx-2(
                  //-   :variant="programmeOverrideButtonVariant"
                  //-   size="sm"
                  //-   @click="toggleProgrammeOverride"
                  //- )
                  //-   b-icon.mx-2(icon="arrow-left-right")
                  //-   | {{ programmeOverrideButtonText }}
                  
                  //- Reset All Overrides Button
                  b-button(
                    v-if="manualCipEligibility !== null || programmeOverride !== null"
                    variant="outline-secondary"
                    size="sm"
                    @click="resetAllOverrides"
                  )
                    b-icon.mx-2-1(icon="arrow-counterclockwise")
                    | Reset Overrides
                  
                  //- Override Status Indicators
                  .ml-3(v-if="manualCipEligibility === true || programmeOverride")
                    b-badge.mr-2(variant="warning" v-if="manualCipEligibility === true")
                      b-icon.mr-1(icon="shield-fill-exclamation")
                      | Manual Eligibility Active
                    b-badge(variant="warning" v-if="programmeOverride")
                      b-icon.mr-1(icon="arrow-repeat")
                      | Programme Override: {{ programmeOverride }}

              .row(v-if="selectedCipTemplate.description && cipEligibility")  
                b-row
                  b-col(cols="12" md="6")
                    b-card(shadow class="mb-3")
                      b-form-checkbox.my-2#transport-toggle(
                        v-model="transportInclude"
                        switch
                      )
                        span.mx-1 Transport Included
                        //- b-button.btn-warning.ml-2(
                        //-   v-if="transportInclude"
                        //-   size="sm"
                        //-   @click="addTransport"
                        //- )
                        //-   | + Add transport

                      ul.mt-3.font-italic(v-if="cipEstimatedFee")
                        li.font-weight-bold.text-success
                          | Selected {{ selectedCipTemplate.description }}
                        li.font-weight-bold
                          | For {{ cipPhase }} sessions
                        li
                          | Programme Fee per session:
                          span.font-weight-bold.text-primary.ml-1
                            | ${{ roundUp(selectedCipTemplate.Oop) }}

                        li(v-if="transportInclude")
                          | Transport included (Within 5km):
                          span.font-weight-bold.text-primary.ml-1
                            | ${{ roundUp(selectedCipTemplate.transport).toFixed(2) }}

                        li(v-if="cipAdditionalTransport")
                          | Additional Transport (Beyond 5km):
                          span.font-weight-bold.text-primary.ml-1
                            | ${{ cipAdditionalTransport.toFixed(2) }}
                          span.ml-2.text-primary(v-if="previousPaymentInfo?.additionalTransportFee")
                            b-icon.mx-1(icon="bookmark-check-fill") 
                            | (From previous submission)

                        li(v-if="cipAdditionalTransport")
                          | Programme Fee per session (Total):
                          span.font-weight-bold.text-primary.ml-1
                            | ${{ (roundUp(selectedCipTemplate.Oop) + roundUp(selectedCipTemplate.transport) + cipAdditionalTransport).toFixed(2) }}

                        li(v-if="cipDescription")
                          span
                            | Session from {{ cipDescription }}
                          //- span.mx-2.text-primary(
                          //-   style="cursor:pointer"
                          //-   @click="$bvModal.show('cip-dates-modal')"
                          //- )
                          //-   | Show Dates

                      p.mt-4.font-weight-bold.text-dark.text-background(
                        v-if="cipEstimatedFee"
                      )
                        | Total (GST Included):
                        span.ml-2
                          | ${{ (((cipEstimatedFee + cipAdditionalTransport) * cipPhase) * 1.09).toFixed(2) }}

                      .formed.mt-2( v-if="cipEstimatedFee && cipPhaseChecker() === 1")
                        label.common.gap(for="pre-session-date") Trial date:
                        input.numbers-full#pre-session-date(v-model="preSessionDate" type="date")

                      .formed.my-1( v-if="cipEstimatedFee")
                        label.common.gap(for="admission") CIP Admission date:
                        input.numbers-full#admission(v-model="cipAdm" type="date" :class="{'invalid': !cipAdm}")


                      .mt-5.mb-3.dates_list.p-1(v-if="cipSessionDates.sessions.length")
                        p.font-weight-bold {{cipSessionDates.sessions.length ? 'Selected dates:' : ""}} 
                        ul
                          li(v-for="(date, index) in cipSessionDates.sessions" :key="index") 
                            b-icon.mx-2(icon="calendar-check-fill" variant="success" class="mr-2")
                            span {{ date }}
                      .my-3.dates_list.p-1(v-if="cipSessionDates.skipped.length")
                        p.font-weight-bold Skipped dates (Holidays):
                        ul
                          li(v-for="(date, index) in cipSessionDates.skipped" :key="index")
                            b-icon.mx-2(icon="calendar-x-fill" variant="danger" class="mr-2")
                            span {{ date }}


                  b-col(cols="12" md="6")
                    b-card(shadow class="mb-3")
                      b-form-group(label="Start Postal Code")
                        b-form-input(
                          v-model="transport.startPostalCode"
                          type="number"
                          placeholder="Enter postal code"
                        )

                      b-form-group(label="Destination Postal Code")
                        b-form-input(
                          v-model="transport.destinationPostalCode"
                          type="number"
                          placeholder="Enter postal code"
                        )

                      iframe.mt-3(
                        v-show="notPDFview"
                        id="iframe"
                        height="350"
                        style="width:100%; border-radius:8px;"
                        :src="transport.iframeSrc"
                      )

                      b-form-group.mt-4(label="Additional Fee ($)")
                        b-form-input(
                          v-model.number="cipAdditionalTransport"
                          type="number"
                          placeholder="Amount"
                        )
                        small.text-primary(v-if="previousPaymentInfo?.additionalTransportFee")
                          b-icon.mx-1(icon="bookmark-check-fill") 
                          | From previous submission



            //- .centerCheckbox
            //-   b-form-checkbox(v-model="subsidy" v-b-toggle.subsidy_box type="checkbox" :value="`${true}`") &nbsp;Subsidy included
            b-collapse.mt-3#subsidy_box(v-model="subsidy")
              b-card
                section
                    .formed
                      .formed
                        b-form-checkbox.mb-2(v-model="subs1" name="subsidy1" type="checkbox" value="dsg1" disabled) &nbsp;DSG
                        .row.my-2(v-show="subs1")
                            .col-md-2 
                              input.numbers#means(name="means" type="number" min="20" v-model="subs1val")
                            .col-md-2 
                              b-form-select.numbers(v-model="dsgsubsidy" :options="subsidyoptions")
                            .col-md-2
                              label.common subsidy
                              //- checknationality 
                        b-form-checkbox.mb-2( v-model="subs2" name="subsidy2" type="checkbox" value="dsg2" disabled) &nbsp;Toteboard
                        .row.my-2(v-show="subs2")
                          .col-md-2 
                            label.common Means Test Result
                          .col-md-2 
                            v-select(v-model="subsidyAmount" :options="clientdata.crb5c_citizenship == 0 ?  toteboardSG : toteboardPR")
                          .col-md-2
                            label.common % subsidy
                        b-form-checkbox.mb-2(v-model="subs3" name="subsidy3" type="checkbox" value="dsg3" disabled) &nbsp;Others
                        .formed.my-2(v-show="subs3")
                          label.common(for="others") Specify: 
                          input.numbers-half#others(name="others" type="text")
                      //- .formed.gapbot(v-show="subs1 || subs2 || subs3 ")
                      //-     label.common(for="subsid" style="justify-content:end") Amount Subsidized:
                      //-     .row(style="justify-content:end")
                      //-       input.small-input-width#subsid(name="subsid" type="number" min="0")
                //- hr
                b-row(v-if="subs2")
                  b-col.col-12
                    b-row.align-items-center
                      b-col.col-12.my-3
                        input.checkbox_circle(id="transport-checkbox" v-model="transport.isIncluded" name="transport-checkbox" type="checkbox")
                        label.long.gapped(for="transport-checkbox")
                          | Transport Included ${{  (transport.fixedFee * (1 - ((subsidyAmount ?? 0) / 100))).toFixed(2) }}
                    b-collapse(id="transport-included-section" v-model="transport.isIncluded")
                      b-row.my-2
                        b-col.col-12
                          b-row.align-items-center
                            b-col.col-2
                              label
                                | Start Postal Code:
                            b-col.col-2
                              b-form-input(v-model="transport.startPostalCode" type="number" placeholder="Enter postal code")
                      b-row
                        b-col.col-12
                          b-row.align-items-center
                            b-col.col-2
                              label
                                | Destination Postal Code:
                            b-col.col-2
                              b-form-input(v-model="transport.destinationPostalCode" type="number" placeholder="Enter postal code" disabled)
                      b-row.my-4
                        b-col.col-3
                          b-button( v-show="notPDFview" style="background-color: rgb(118, 80, 137); color: #fff; font-weight: bold; border-radius: 0.625rem" @click="checkDistanceTransport")
                            | Check distance
                      b-row.my-2
                        b-col.col-12
                          iframe( v-show="notPDFview" style="width: 100%;" id="iframe" height="500" width="500" :src="transport.iframeSrc")
                      b-row.my-4
                        b-col.col-12
                          b-row.align-items-center
                            b-col.col-2
                              label
                                | Additional Fee: $
                            b-col.col-2
                              b-form-input(v-model="transport.amountToBePaid" type="number" placeholder="Amount")
  
          //remove restriction v-show="type && stageof && date && (neeuro || checker || checker2 || checker3 || checker4 || checker5)"
          section.p-4.border.my-4.border-light.rounded.shadow(ref="fowSessionSection" v-show="!isPhase3Completion || phase3CompletionChoice === 'switch-to-fow'")
            .formed
              .row
                .col-sm-3.align-self-center.col-auto
                  label.common(for="session") Session Recommended: 
                .col.col-auto(style="text-align: right;")   
                  b-btn#add-btn.btn-warning.mx-3(@click="addmethod(0)" v-show="notPDFview") Available Sessions 
                //- .col.col-auto(style="text-align: right;")   
                //-   b-btn#add-btn.mx-2.btn-warning(@click="addmethod(1)" v-show="notPDFview") + Create New Session 
                //- .col.col-auto(style="text-align: right;")   
                //-   b-btn#add-btn.mx-2.btn-dark(@click="AutoMatchingSession()") + (Test) Automation
                  //- b-btn#add-btn(@click="addfile") + Add file 
              
              div.my-4(v-if="!recommended_session_pick.length" )
                b-card(style="text-align: center;padding: 40px;")
                  b-icon.large_icon(icon="box-seam")
                  p.gap(style="justify-content: center;") No Session Selected, click add session to begin.

              <!-- div.my-4.rounded.border(v-if="recommended_session_pick.length") -->
                <!-- .row -->
                  <!-- p.p-3(v-for="(rec_ses, index) in recommended_session_pick" :key="index")
                    | {{index+1+'.'}} {{rec_ses.crb5c_session_id}}
                    b-icon.delete_icon(icon="x-circle-fill" @click="removePickedSession(index)") -->
              b-table.my-4(:fields="sessionTableFields" :items="recommended_session_pick" v-if="recommended_session_pick.length" striped bordered responsive)
                template(#cell(session_name)="data")
                  p {{data.item.crb5c_session_id}}
                template(#cell(session_type)="data")
                  p {{sessionTypeCheck(data.item.crb5c_sessiontype)}}
                template(#cell(session_duration)="data")
                  p {{sessionDurationCheck(data.item.crb5c_duration)}}
                template(#cell(actions)="data")
                  b-button(variant="danger" @click="removePickedSession(data.index)") Remove

              div.my-4.p-3.border(v-if="sessions.length" style="border-radius: 0.5rem;" )
                .row
                  p.p-3(v-for="(ses, index) in sessions" :key="index") 
                    | {{index+1+'.'}} {{ses.name}} [{{ses.type}}] - {{ ses.day }} {{ ses.time }} ( {{ ses.location }} ) 
                    b-icon.delete_icon(icon="x-circle-fill" @click="removeSession(index)")

              .formed.mt-3( v-show="(this.sessions.length || this.recommended_session_pick.length) && !cipEstimatedFee" )
                label.common.gap(for="admission") Admission date:
                input.numbers-half#admission(v-model="adm" name="admission" type="date" :class="{'invalid': !adm}")
                
                div(v-if="fowSessionDates.sessions.length")
                  hr.my-4
                  h4.my-4 Upcoming Sessions:
                  p.my-4(v-if="fowSessionDates.sessions.length") Sessions for the month:
                  ul
                    li(v-for="(date, index) in fowSessionDates.sessions" :key="index")  
                      b-icon.mx-2(icon="calendar-check-fill" variant="success" class="mr-2")
                      span {{ date }}
                      

                  p.my-4(v-if="fowSessionDates.skipped.length") Skipped (Public/DSG Holiday):
                  ul
                    li(v-for="(date, index) in fowSessionDates.skipped" :key="index")  
                      b-icon.mx-2(icon="calendar2-x" variant="danger" class="mr-2")
                      span {{ date }}

                


              //- b-modal#confrimationModal.modal_confimration(size="lg" title="Sign here" scrollable centered hide-footer)
              //-     input(type="file" @change="uploadFile")
              //-     b-btn(@click="confirmUpload") Submit

              b-modal(id="modal-time" hide-footer hide-header)
                p.my-4 Pick a time
                b-form-datepicker(id="datepicker" v-model="edit_time" class="mb-2")
                div(style="text-align:center; margin-top: 30px; margin-bottom: 20px;")
                  b-button(@click="editTime") Change date
                            
              b-modal#automatedMatchingModal.modal_confimration(size="lg"  scrollable centered hide-footer hide-header no-close-on-esc no-close-on-backdrop)
                div(v-if="loadingAutomated")
                  b-row.mt-5 
                    Icon.icon-loader(icon="line-md:cog-filled-loop")
                  b-row.my-5.text-center
                    h6 Please wait while the sessions are being automated
                div(v-else)
                  //- div.mx-3(style="text-align: right; font-size: 3vh") 
                  //-   b-button.btn-transparent(@click="closeModal('automatedMatchingModal')")
                  //-     Icon(icon="ic:twotone-close" ) 
                  b-row.mt-2.justify-content-center
                    lord-icon(src="https://cdn.lordicon.com/gqjpawbc.json" trigger="loop" delay="500"  colors="primary:#121331,secondary:#4f1091" state="in-reveal" style="width:350px;height:350px")
                  b-row.my-5.text-center
                    h6 Completed, you can now close this page.
                  b-row.justify-content-center.m-2
                    b-button.mx-3(style="background: #917093;font-size: 16px;" @click="printCoverPage") Print Cover Page
                    b-button.m-3(variant="danger" style="font-size: 16px;" @click="closeTab()") Close Tab
              
              b-modal#assessmentOnlySubmission(size="lg"  scrollable centered hide-footer hide-header no-close-on-esc no-close-on-backdrop)
                div(v-if="submitOnlyAssessment")
                  b-row.mt-5 
                    Icon.icon-loader(icon="line-md:loading-twotone-loop")
                  b-row.my-5.text-center
                    h6 Please wait, assessment is being finalized and submitting
                div(v-else)
                  //- div.mx-3(style="text-align: right; font-size: 3vh") 
                  //-   b-button.btn-transparent(@click="closeModal('automatedMatchingModal')")
                  //-     Icon(icon="ic:twotone-close" ) 
                  b-row.mt-4.justify-content-center
                    lord-icon(src="https://cdn.lordicon.com/gqjpawbc.json" trigger="loop" delay="1200"  colors="primary:#121331,secondary:#4f1091" state="in-reveal" style="width:350px;height:350px")
                  b-row.my-5.text-center
                    h6 Submitted successfully, can close this page.
                  b-row.justify-content-center.m-4
                    b-button.mx-3(style="background: #917093;font-size: 16px;" @click="printCoverPage") Print Cover Page
                    b-button.m-3(variant="danger" style="font-size: 16px;" @click="closeTab()") Close Tab
                    
              b-modal#assessmentSubmission.modal_confimration(size="lg"  scrollable centered hide-footer hide-header no-close-on-esc no-close-on-backdrop)
                div(v-if="loadingSubmission")
                  b-row.mt-5 
                    Icon.icon-loader(icon="line-md:loading-twotone-loop")
                  b-row.my-5.text-center
                    h6 Please wait, assessment is being finalized and submitting
                div(v-else)
                  //- div.mx-3(style="text-align: right; font-size: 3vh") 
                  //-   b-button.btn-transparent(@click="closeModal('automatedMatchingModal')")
                  //-     Icon(icon="ic:twotone-close" ) 
                  b-row.mt-4.justify-content-center
                    lord-icon(src="https://cdn.lordicon.com/wzwygmng.json" trigger="loop" delay="1200"  colors="primary:#121331,secondary:#4f1091" state="in-reveal" style="width:350px;height:350px")
                  b-row.my-5.text-center
                    h6 Submitted successfully, session automation will begin in 5 seconds.
                  //- b-row.justify-content-center.mb-4
                  //-   b-button.mx-3(style="background: #917093;font-size: 16px;" @click="printCoverPage") Print Cover Page
                  //-   b-button.m-3(variant="danger" style="font-size: 16px;" @click="closeTab()") Close Tab

                
              b-modal#chooseCIPTemplate(size="lg" :title="`Subsidy Template (${checknationality ? 'Singapore Citizen' : 'Permanent Resident'})`" scrollable no-close-on-esc no-close-on-backdrop hide-header-close)
                .mx-3
                  b-badge.mb-2(:variant="isCip2Client ? 'success' : 'secondary'") {{ cipPricingSetLabel }}
                  h5.my-4  Total (GST Included): ${{ (((cipEstimatedFee + cipAdditionalTransport) * cipPhase) * 1.09 ).toFixed(2) }}
                  ul.mb-4(v-if="cipEstimatedFee" class="font-weight-light font-italic")
                    li Selected {{selectedCipTemplate.description}}
                    li For {{ cipPhase }} session(s)
                    li(v-if="transportInclude") Transport included {{cipAdditionalTransport ? `+ $${cipAdditionalTransport}` : ''}}
                    li(v-if="cipDescription")
                      span Session from {{ cipDescription }}
                      span.mx-3.text-primary(style="cursor: pointer;" @click="$bvModal.show('cip-dates-modal')") Show Dates

                  b-button.my-3(
                      v-if="!showTemplateList"
                      variant="primary"
                      @click="showTemplateList = true"
                    ) {{selectedCipTemplate.description ? 'Change Template' : 'Select Template'}}

                  .div(v-if="showTemplateList")
                    b-form-checkbox.my-3#transport-toggle(v-model="transportInclude" switch) 
                        span.mx-1 Transport Included 
                        b-button(@click="$bvModal.show('cip-add-distance')") Check transport fee

                    .div-scroll-cards( style="max-height: 300px; overflow-y: auto;")
                      b-card-group(deck)
                        b-card.cip-template-card(
                          v-for="(template, index) in formattedTemplates"
                          :key="template.crb5c_fow_feeid"
                          @click="pickTemplate(template)"
                          class="mb-3"
                          style="cursor: pointer;"
                        )
                          .d-flex.flex-column
                            h5.font-weight-bold.mb-2 {{ template.description }}
                            .d-flex.justify-content-between.text-muted
                              small Programme Fee:
                              span.font-weight-bold.text-regular ${{ roundUp(template.amt).toFixed(2) }}
                            .d-flex.justify-content-between.text-muted
                              small After Subsidy:
                              span.font-weight-bold.text-regular ${{ roundUp(template.amt - template.subsidy_amt).toFixed(2) }}
                            .d-flex.justify-content-between.text-muted(v-if="template.transport")
                              small Transport Cost:
                              span.font-weight-bold.text-regular ${{ roundUp(template.transport).toFixed(2) }} {{cipAdditionalTransport ? `+ $${cipAdditionalTransport}` : ''}}
                            .d-flex.justify-content-between
                              small OoP (before GST):
                              span.font-weight-bold.text-dark ${{ roundUp(template.Oop).toFixed(2) }}

              b-modal#cip-add-distance(size="lg" title="Add Distance" hide-footer)
                        b-row.my-2
                          b-col.col-12
                            b-row.align-items-center
                              b-col.col-2
                                label
                                  | Start Postal Code:
                              b-col.col-2
                                b-form-input(v-model="transport.startPostalCode" type="number" placeholder="Enter postal code")
                        b-row
                          b-col.col-12
                            b-row.align-items-center
                              b-col.col-2
                                label
                                  | Destination Postal Code:
                              b-col.col-2
                                b-form-input(v-model="transport.destinationPostalCode" type="number" placeholder="Enter postal code")
                        b-row.my-4
                          b-col.col-3
                            b-button( v-show="notPDFview" style="background-color: rgb(118, 80, 137); color: #fff; font-weight: bold; border-radius: 0.625rem" @click="checkDistanceTransport")
                              | Check distance
                        b-row.my-2
                          b-col.col-12
                            iframe( v-show="notPDFview" style="width: 100%;" id="iframe" height="500" width="500" :src="transport.iframeSrc")
                        b-row.my-4
                          b-col.col-12
                            b-row.align-items-center
                              b-col.col-2
                                label
                                  | Additional Fee: $
                              b-col.col-2
                                b-form-input(v-model.number="cipAdditionalTransport" type="number" placeholder="Amount")
    
              b-modal#skip-payment-modal(title="Skip to Payment" hide-footer)
                .mx-3.my-3
                  p You are about to skip to payment (Client not joining or indecisive)
                  p.font-weight-bold Would you like to collect the one-time assessment fee ($50)?
                  .d-flex.justify-content-center.mt-4
                    b-button.mx-2(variant="success" @click="confirmSkipToPayment(true)" style="width: 200px") 
                      | Yes, Include Fee
                    b-button.mx-2(variant="outline-secondary" @click="confirmSkipToPayment(false)" style="width: 200px") 
                      | No, Skip Fee
                    b-button.mx-2(variant="danger" @click="$bvModal.hide('skip-payment-modal')" style="width: 120px") 
                      | Cancel

              b-modal#cip-dates-modal(title="CIP Session Dates" hide-footer)
                  .mx-3
                    .my-1
                      p Selected dates:
                      ul
                        li(v-for="(date, index) in cipSessionDates.sessions" :key="index") 
                          b-icon.mx-2(icon="calendar-check-fill" variant="success" class="mr-2")
                          span {{ date }}
                    .my-3(v-if="cipSessionDates.skipped.length")
                      p Skipped dates (Holidays):
                      ul
                        li(v-for="(date, index) in cipSessionDates.skipped" :key="index")
                          b-icon.mx-2(icon="calendar-x-fill" variant="danger" class="mr-2")
                          span {{ date }}

              b-modal#addAdHocModal.modal_confimration(size="lg" title="Ad-hoc Fee" scrollable centered hide-footer)
                  .d-flex.flex-column
                    b-form-group.mb-3(label="Remark:")
                      b-form-input(type="text" v-model="adHocItems.remark")
                    b-form-group.mb-3(label="Amount ($): ")
                      b-form-input(type="number" v-model="adHocItems.total" value="")
                    b-form-checkbox.mb-2(v-model="adHocItems.isRecurring"  type="checkbox") &nbsp;Recurring (Monthly)
                    b-form-checkbox.mb-2(v-model="adHocItems.isIncludeInFee"  type="checkbox") &nbsp;Include in current fee
                    .d-flex.justify-content-center.mt-3
                      b-button(@click="adHocFee" variant="primary" :disabled="!adHocItems.remark || !adHocItems.total || (!adHocItems.isRecurring && !adHocItems.isIncludeInFee)" style="width:50%") Add Fee

              b-modal#paymentConfirmation(size="xl" scrollable centered hide-footer)

                //- ── No Invoice: Assessment Completed ──────────────────────────
                div(v-if="!invoices.length")
                  .px-4.pt-4.pb-3
                    .text-center.mb-4
                      .d-flex.align-items-center.justify-content-center.rounded-circle.bg-success.mb-3.mx-auto(style="width:72px;height:72px")
                        b-icon(icon="check-lg" variant="white" font-scale="2")
                      h4.font-weight-bold.text-success.mb-1 Assessment Completed
                      p.text-muted.mb-0 No payment invoice generated for this assessment.
                    b-card.border-0.shadow-sm.mb-4(body-class="p-4")
                      .d-flex.flex-wrap.justify-content-center(style="gap:10px")
                        b-btn.px-4(@click="submitassessment" style="background:#917093;border-color:#917093;min-width:140px")
                          b-icon.mx-2(icon="check2-circle")
                          | Complete
                        b-btn.px-4(variant="outline-secondary" @click="printCoverPage" style="min-width:140px")
                          b-icon.mx-2(icon="printer")
                          | Cover Page
                        b-btn.px-4(variant="outline-secondary" @click="printPopup" style="min-width:140px")
                          b-icon.mx-2(icon="file-earmark-pdf")
                          | Assessment PDF
                        b-btn.px-4(variant="outline-secondary" @click="printFullPDF" style="min-width:140px")
                          b-icon.mxx-2(icon="files")
                          | Full PDF
                    b-card.border-warning.shadow-sm.mb-3(v-if="refundableDeposit > 0" body-class="p-0")
                      .d-flex.align-items-center.px-4.py-3.border-bottom
                        b-icon.mx-2(icon="wallet2" variant="warning" font-scale="1.3")
                        span.font-weight-bold Refundable Deposit Collection
                      div.px-4.py-3
                        p.text-muted.mb-3 Collect the refundable deposit without an invoice using the PayNow QR below.
                        b-form-group.mb-3(label-cols="4" label="Deposit Amount ($):" label-class="font-weight-bold pt-1")
                          b-input-group(prepend="$" style="max-width:200px")
                            b-form-input(type="number" v-model.number="depositOnlyAmount" min="0")
                        div(v-if="depositOnlyAmount > 0")
                          .alert.alert-info.py-2.mb-3
                            small.d-block.text-muted.mb-1 Payment Reference:
                            span.font-weight-bold.text-primary {{ depositOnlyRef }}
                          .d-flex.justify-content-center.mb-3
                            .background-container.my-2
                              .qr-code-container
                                vueQrcode(:value="depositOnlyPaynowString" :options="{ width: 250, height: 250}")
                              .paynow-logo-container.my-1.justify-self-center.align-self-center.justify-content-center
                                .logo-background.d-flex.align-items-center.justify-content-center
                                  img(src="/form-images/paynow_logo.png" alt='paynow' style="max-width:100px; height:auto;")
                          b-btn.d-block.mx-auto(
                            :variant="depositRecordCreated ? 'success' : 'primary'"
                            :disabled="depositRecordCreated"
                            @click="saveDepositRecord"
                          )
                            b-icon.mx-2(:icon="depositRecordCreated ? 'check-circle-fill' : 'cloud-upload'")
                            | {{ depositRecordCreated ? 'Deposit Record Saved' : 'Pay Deposit Later' }}

                //- ── Has Invoices: Payment Flow ────────────────────────────────
                div(v-else)
                  .px-4.pt-4.pb-2
                    .d-flex.align-items-center.mb-1
                      b-icon.mx-2(icon="credit-card" variant="primary" font-scale="1.3")
                      h4.font-weight-bold.mb-0 Payment Instructions
                    //- p.text-muted.mb-0 Please complete payment before proceeding.
                  b-card.mx-4.mb-3.border-0.bg-light.shadow-sm(body-class="px-4 py-3")
                    .d-flex.align-items-center.justify-content-between.flex-wrap
                      div
                        p.text-muted.mb-0.small Total (GST Included)
                        div.font-weight-bold(style="font-size:2rem;color:#50276B") ${{ toPayAmount.toFixed(2) }}
                      div(v-if="refundableFeeTotal")
                        b-form-checkbox.common(v-model="depositPaid")
                          span.mx-1 Include Deposit (${{ refundableDeposit.toFixed(2) }})
                  b-card.mx-4.mb-3.border-warning.shadow-sm(v-if="refundableFeeTotal && !depositPaid" body-class="px-4 py-3")
                    .d-flex.align-items-center.justify-content-between.flex-wrap(style="gap:12px")
                      div
                        .d-flex.align-items-center.mb-1
                          b-icon.mx-2(icon="wallet2" variant="warning" font-scale="1.2")
                          span.font-weight-bold Deposit not collected with this payment
                        p.text-muted.small.mb-0
                          | ${{ refundableDeposit.toFixed(2) }} — save a record so the client can pay via the mobile app later.
                      b-btn(
                        :variant="invoiceDepositRecordCreated ? 'success' : 'outline-warning'"
                        :disabled="invoiceDepositRecordCreated"
                        @click="saveInvoiceDepositRecord"
                      )
                        b-icon.mx-2(:icon="invoiceDepositRecordCreated ? 'check-circle-fill' : 'bookmark-plus'")
                        | {{ invoiceDepositRecordCreated ? 'Deposit Record Saved' : 'Save Deposit for Later' }}
                  .px-4.my-4
                    label.font-weight-bold.common.my-3.d-block Mode of Payment:
                    .payment-method-grid
                      label.payment-method-tile(for="cash" :class="{ 'payment-method-tile--selected': modeofpayment == 'cash' }")
                        input#cash(v-model="modeofpayment" name="payment" type="radio" value="cash" style="display:none")
                        .payment-method-tile__icon
                          img(src="/form-images/money.png" alt="Cash" style="width:48px;height:48px;object-fit:contain")
                        .payment-method-tile__label Cash
                      label.payment-method-tile(for="paynow" :class="{ 'payment-method-tile--selected': modeofpayment == 'paynow' }")
                        input#paynow(v-model="modeofpayment" name="payment" type="radio" value="paynow" style="display:none")
                        .payment-method-tile__icon
                          img(src="/form-images/paynow_logo.png" alt="PayNow" style="width:90px;height:48px;object-fit:contain")
                        .payment-method-tile__label PayNow
                  b-card.mx-4.mb-3.border-0.shadow-sm.text-center.py-4(v-if="modeofpayment == 'cash'")
                    b-icon(icon="cash-stack" font-scale="2.5" variant="success")
                    //- h5.font-weight-bold.mt-2 Please collect the cash payment before continuing.
                  b-card.mx-4.mb-3.border-0.shadow-sm(v-if="modeofpayment == 'paynow' || modeofpayment == 'e-bank'" body-class="px-4 py-3")
                    .alert.alert-danger.py-2.mb-3
                      b-icon.mx-2(icon="exclamation-triangle-fill")
                      | IMPORTANT: Use invoice number as payment reference.
                    small.text-muted.d-block.mb-1 Payment Reference:
                    h5.text-danger.font-weight-bold.mb-3
                      u {{ invoicesList }}
                    .d-flex.justify-content-center
                      .background-container.my-2
                        .qr-code-container
                          vueQrcode(:value="paynowString" :options="{ width: 250, height: 250}")
                        .paynow-logo-container.my-1
                          .logo-background.d-flex.align-items-center.justify-content-center
                            img(src="/form-images/paynow_logo.png" alt='paynow' style="max-width:100px; height:auto;")
                  b-card.mx-4.mb-3.border-0.shadow-sm(v-if="modeofpayment == 'cheque'" body-class="px-4 py-3")
                    p.mb-1 All cheques should be crossed and made payable to
                      b.text-danger  Dementia Singapore Ltd - Acc 1
                    p Kindly indicate the client name and invoice number at the back of the cheque.
                  b-card.mx-4.mb-4.border-0.bg-light(v-if="modeofpayment" body-class="py-3 px-4")
                    .d-flex.flex-wrap.justify-content-center(style="gap:10px")
                      b-btn.px-4(@click="submitassessment" style="background:#917093;border-color:#917093;min-width:140px")
                        b-icon.mx-2(icon="check2-circle")
                        | Complete
                      b-btn.px-4(variant="outline-secondary" @click="printCoverPage" style="min-width:140px")
                        b-icon.mx-2(icon="printer")
                        | Cover Page
                      b-btn.px-4(variant="outline-secondary" @click="printPopup" style="min-width:140px")
                        b-icon.mx-2(icon="file-earmark-pdf")
                        | Assessment PDF
                      b-btn.px-4(variant="outline-secondary" @click="printFullPDF" style="min-width:140px")
                        b-icon.mx-2(icon="files")
                        | Full PDF


              b-modal#pick-session(size="lg" title="Add Session" scrollable centered hide-footer) 
                div
                  b-form-checkbox-group(v-model="pick_sessions")
                    b-form-checkbox.mb-2( :value="session" required v-for="session in filteredChoice" :key='session.crb5c_fow_session_scheduleid' :id="session.crb5c_fow_session_scheduleid") &nbsp;{{ session.crb5c_session_id }}
                  div.text-center.my-2
                    b-button.my-3.px-4( size="md" variant="success" :disabled="isAddButtonDisabled" @click="addNewPickSession") Add
                  
              //------- add new session modal -start
              b-modal#add-session(size="md" title="Add Session" scrollable centered)
                b-card.p-3(no-body)

                  b-form-group.mb-2(label="Session Name:")
                    b-form-input.input-border-light.rounded(v-model="newSessionTitle" size="sm" type="text")  

                  div.d-flex.mb-2
                    b-form-group(label="Session Type:")
                      b-form-select.p-1.input-border-light.rounded(v-model="newSessionType" :options="sessionType")
                    b-form-group.mx-auto(label="Report Type: ")
                      b-form-select.p-1.input-border-light.rounded(v-model="newDementiaType" :options="dementiaLvl")

                  div.d-flex.mb-2
                    b-form-group(label="Duration: ")
                      b-form-select.p-1.rounded.w-100.input-border-light(v-model="newDuration" :options="durationSession")
                    
                b-card.my-3.p-3(no-body)
                  b-form-group
                    div.d-flex
                      label.mr-2 Type:
                      b-form-radio.mx-2( v-model="typeses" name="typeSes" value="Group") &nbsp;Group 
                      b-form-radio.mx-2( v-model="typeses" name="typeSes" value="Individual") &nbsp;Individual
                b-card.p-3(no-body )
                  div.d-flex
                    b-form-group
                      label.mr-2.font-weight-bold Day:
                        b-form-radio( v-model="day" name="daySes" value=1) &nbsp;Monday 
                        b-form-radio( v-model="day" name="daySes" value=2) &nbsp;Tuesday
                        b-form-radio( v-model="day" name="daySes" value=3) &nbsp;Wednesday
                        b-form-radio( v-model="day" name="daySes" value=4) &nbsp;Thursday
                        b-form-radio( v-model="day" name="daySes" value=5) &nbsp;Friday
                    b-form-group.mx-auto(v-if="day && typeses==='Group'")
                      label.mr-2.font-weight-bold Time:
                        b-form-radio( v-model="time" name="timeSes" value="09:30") &nbsp;9:30 AM
                        b-form-radio( v-model="time" name="timeSes" value="14:00") &nbsp;2:00 PM
                    b-form-group.mx-auto.w-auto(label="Time:" v-if="day && typeses==='Individual'")
                      b-form-timepicker.numbers#timeSession(v-model="time" name="timeSession" type="time" locale="en")
                  b-form-group(label="Location:" v-show="typeses==='Individual'")
                    b-form-radio( v-model="location" name="location" type="radio" value="Center") &nbsp;Center 
                    b-form-radio( v-model="location" name="location" type="radio" value="Video-Call") &nbsp;Video Call (Zoom)
                    b-form-radio( v-model="location" name="location" type="radio" value="Residence") &nbsp;Residence
                template(#modal-footer="{ok}")
                  b-btn.btn-success(v-show="location" size="md" @click="addNew") Add
              // add new session modal -end  
          section.p-4.border.my-4.border-light.rounded.shadow(v-show="this.sessions.length || this.recommended_session_pick.length && !cipEstimatedFee")
            label.common Applicable Sessions (excluding GST):
            .formed
              .formed(v-for="(programme, index)  in filteredProgrammeInfos " :key="index")
                input.checkbox_circle(v-model="applicableFeeTotal" type="checkbox" :value="programme" :id="programme.crb5c_fowprogrammeid")
                label.gapped.text-small(:for="programme.crb5c_fowprogrammeid") {{programme.crb5c_programmename}} 
                  label ${{ programme.crb5c_price }}
                  //- label(v-else) ${{ fees4val  }}  
                  //-   span(v-if="transport.isIncluded") (with transport fee: ${{ transportTotalView.toFixed(2) }})
              .formed
              //- .border.border-1.m-4(v-show="isCipSelected" style="border-radius: 0.5rem;")
              //-     b-row.p-3.mx-4
              //-       b-col.col-6(style="border-right-style: ridge;")
              //-         b-row
              //-           b-col
              //-             b-row.my-4 
              //-               label(style="font-size:16px;font-weight:bold;color:#6f6f6f;text-decoration-line: underline;") CIP Date picker
              //-             b-row
              //-               b-col
              //-                 label.common.gap(for="admission") 1st Session date: [{{ firstSesDay(this.firSession) }}]
              //-                   span(v-show="this.firSession").mx-3
              //-                     b-form-checkbox(switch v-model="firstSesFormat" value=0) 
              //-                       span.mx-1 {{ is1stAM }}
              //-             b-row
              //-               b-col
              //-                 input.numbers-half#admission(v-model="firSession" name="admission" type="date")
              //-             b-row
              //-               b-col
              //-                 label.common.gap(for="admission") 2nd Session date: [{{ secondSesDay(this.secSession) }}]
              //-                   span(v-show="this.secSession").mx-3
              //-                     b-form-checkbox(switch v-model="secondSesFormat" value=0)
              //-                       span.mx-1 {{ is2ndAM }}
              //-             b-row
              //-               b-col
              //-                 input.numbers-half#admission(v-model="secSession" name="admission" type="date")
              //-             b-row
              //-               //- b-col
              //-               //-   b-btn.gap(@click="CIPtotal" v-show="notPDFview") Calculate
              //-             b-row.my-4
              //-               b-col.d-flex.justify-content-start.align-items-start(v-show="totalforCIP" style="font-size: 20px;")
              //-                 label(style="font-size:14px") Total of {{ CIPdays }} Session (s) for this month
              //-                 //- b-row.flex 
              //-                 //-   .col-auto
              //-                 //-     input.numbers-half.col-auto( type="number" v-model="CIPdays")
              //-                 //-   .col-auto 
              //-                 //-     span Session (s)
              //-                 //-   b-col
              //-                 //-     label.mx-2 
                              
              //-       b-col.col-6

              //-         b-row.mx-4
              //-           b-col
              //-             b-row.my-4 
              //-               label(style="font-size:16px;font-weight:bold;color:#6f6f6f;text-decoration-line: underline;") Holidays and Off days
              //-             b-row
              //-               b-col
              //-                 label.common.gap Public & DSG Holiday:
              //-                 p(v-if="listPublicHolidayCurrentMonth" v-for="publicHoliday in listPublicHolidayCurrentMonth" :key="publicHoliday._id")
              //-                   | {{ formatDatePublicHoliday(publicHoliday.date) }} - {{ publicHoliday.holiday }}
              //-                 p(v-if="!listPublicHolidayCurrentMonth")
              //-                   | No Public Holiday for this month
              //-         b-row.mx-4.mb-5
              //-           b-col
              //-             b-row
              //-               b-col.col-auto.align-self-center
              //-                 label.common.gap(for="dsgOffday") DSG Off day:
              //-               b-col.col-auto.gap
              //-                 b-button(@click="addDSGOffday" v-show="notPDFview")
              //-                   | +
              //-             b-row
              //-               b-col
              //-                 input.numbers-half#admission(v-model="dsgOffDay.date" name="dsgOffday" type="date")
                          
                      
              //-             b-row(v-if="dsgOffDay.listDay.length !== 0")
              //-               b-col
              //-                 b-row.mb-2.align-items-center(v-for="holiday in dsgOffDay.listDay" :key="holiday.id")
              //-                   b-col
              //-                     p.my-auto
              //-                       | {{ formatDSFOffDayContent(holiday.date) }}
              //-                   b-col
              //-                     b-button(variant="danger" @click="removeDSGOffDay(holiday.id)")
              //-                       | Remove
                    
                              
                              
              
  
                  //- b-card
                  //-   label.common.gap(for="admission") 1st Session date:
                  //-   input.numbers-half#admission(v-model="firSession" name="admission" type="date")
  
                  //-   label.common.gap(for="admission") 2nd Session date:
                  //-   input.numbers-half#admission(v-model="secSession" name="admission" type="date")
  
                  //-   b-btn.mt-3(@click="CIPtotal") Calculate
            
                  //-   div(style="text-align: right;width: 100%;font-size: 20px;")
                  //-     label(v-show="totalforCIP") ${{totalforCIP}} for {{ CIPdays }} session
            
          section.p-4.border.my-4.border-light.rounded.shadow(v-show="((this.sessions.length || this.recommended_session_pick.length) && !cipEligibility) " style="margin-top:50px")
            label.common NeeuroFit Subscription (Optional):
            b-form-checkbox(v-model="neeurofitFeeTotal" type="checkbox" :value="neeuroFitFees") &nbsp;Centre-based NeeuroFIT 6 months subcription $240

          
          section.p-4.border.my-4.border-light.rounded.shadow(v-show="this.sessions.length || this.recommended_session_pick.length")
              .d-flex.align-items-center
                label Additional fee:
                b-button.mx-3(v-b-modal.addAdHocModal variant="warning" v-show="notPDFview") Ad-hoc fee
              .formed.gap()
                b-form-checkbox(v-model="additionalFeeTotal" type="checkbox" :value="additionalFees.one_time.price") &nbsp;One-time Assessment $50
              //- .formed.gap(v-show="subs1")
              //-   input#one_time_other.checkbox_circle( v-model="additionalFeeTotal"  type="checkbox" :value="oneTimeOtherValue" :disabled="!oneTimeOtherValue")
              //-   label.gapped.text-small(for="one_time_other") One-time Assessment $
              //-     input.mx-2(type="number" v-model="one_time_other_value")
              .formed.gap(v-show="subs1")
                input#one_time_waived(v-model="additionalFeeTotal" type="checkbox" :value="additionalFees.one_time_waived.price")
                label.gapped.text-small(for="one_time_waived") One-time Assessment
                  strike.mx-2 $50 
                    label.mx-2 [Waived]
              .formed.gap(v-if="!cipEligibility")
                b-form-checkbox(v-model="refundableFeeTotal" type="checkbox" :value="refundableDeposit") &nbsp;Refundable One-Month Deposit (4 X applicable fee) ${{ refundableDeposit }}

              b-table.my-4(:fields="adHocFeeTableFields" :items="adHocFeeTotal" v-if="adHocFeeTotal.length" striped bordered responsive)
                template(#cell(remark)="data")
                  p {{data.item.remark}}
                template(#cell(total)="data")
                  p {{data.item.total}}
                template(#cell(isRecurring)="data")
                  p  {{ data.item.isRecurring ? 'Yes' : 'No' }}
                template(#cell(isIncludeInFee)="data")
                  p  {{ data.item.isIncludeInFee ? 'Yes' : 'No' }}
                template(#cell(action)="data")
                  b-button(variant="danger" @click="deleteAdHoc(data.index)") Remove
                //Payment type
                      //-"
                      //- .row
                      //-   .col
                      //-     .row 
                      //-       .col-sm-8
                      //-         | Fee
                      //-       .col-sm-2
                      //-         | Amount
                      //-     .row.mt-5 
                      //-       .col-sm-8
                      //-         label.common(v-if="totalOfNeeurofit !== 0") {{ isNeeuroFit }}
                      //-       .col-sm
                      //-         label.common(v-if="totalOfNeeurofit !== 0") {{ totalOfNeeurofit }} (with GST : {{ totalOfNeeurofit*1.08.toFixed(2) }})
                      //-   .col
          section.mt-5  
            b-button.btn-warning(@click="skipToPayment" v-if="previousAssessment?.crb5c_cipphase !== 3") Client Not Joining / Skip to Payment
              b-icon.mx-3(icon="box-arrow-in-right" variant="danger" class="mr-1")
          section.p-4.border.my-4.border-light.rounded.shadow(v-if="viewamtcollectNoGST")
            div.d-flex.justify-content-between
              div
                  div.mb-3(v-if="cipEstimatedFee")
                    label.common CIP Fee (before GST)
                    ul.mt-2.ml-3.text-lg
                      li
                        span.font-weight-bold Programme Fee: 
                        | ${{ (roundUp(selectedCipTemplate.Oop)).toFixed(2) }} x {{ cipPhase }} = 
                        span.text-primary.font-weight-bold ${{ displayAmount(selectedCipTemplate.Oop) }}
                      
                      li(v-if="transportInclude")
                        span.font-weight-bold Transport Fee (within 5km): 
                        | ${{ (roundUp(selectedCipTemplate.transport)).toFixed(2) }} x {{ cipPhase }} = 
                        span.text-primary.font-weight-bold ${{ displayAmount(selectedCipTemplate.transport) }}

                      li(v-if="cipAdditionalTransport")
                        span.font-weight-bold Additional Transport (beyond 5km): 
                        | ${{ cipAdditionalTransport }} x {{ cipPhase }} = 
                        span.text-primary.font-weight-bold ${{ (cipAdditionalTransport * cipPhase).toFixed(2) }}
                      //- label {{selectedCipTemplate.description}}  ( ${{ (cipEstimatedFee * cipPhase).toFixed(2) }} ) {{ transportInclude ? 'Transport included' : '' }}

                    
                  div 
                    label.common(v-if="selectedProgrammeSummary.length") Fee (before GST):
                
                    div(v-if="fowSessionDates.sessions.length && this.totalOfApplicable !== 0 && !this.isAdmissionNextMonth")
                      span.font-weight-bold Programme Fee: 
                      | ${{ totalOfApplicable }} x {{ fowSessionDates.sessions.length }} = 
                      span.text-primary.font-weight-bold ${{ displayFowAmount((totalOfApplicable*fowSessionDates.sessions.length)) }}
                    div(v-for="(programme, index) in selectedProgrammeSummary" :key="index")
                        label {{programme.name}} 
                        |  &nbsp; ( {{typeof programme.cost === 'number' ? '$' :''}}{{ programme.cost }}  {{ programme.quantity > 1 ? "X " +programme.quantity : '' }} )
                    div.my-2(v-if="isAdmissionNextMonth")  
                      span.text-muted (Programme fee will be calculated in the next invoice)
                
                  

              div.d-flex.flex-column.align-items-end
                label.common.mb-4 Amount to be Collected :
                label.mb-2(for="collect" style="font-size:20px") Total : ${{ viewamtcollectNoGST.toFixed(2)}}
                label.mb-2(for="collect" style="font-size:20px") 9% GST: ${{ (viewamtcollect - viewamtcollectNoGST ).toFixed(2)}}
                label.common(for="collect" style="font-size:30px") Total + GST: ${{ viewamtcollect.toFixed(2)}}

          section(v-if="!viewServiceForm" v-show="this.sessions.length || this.recommended_session_pick.length || cipEstimatedFee")
            div.justify-content-left.align-items-left
                b-button.px-4.py-2(variant="success" @click="navigateToServiceForm" v-if="!viewServiceForm && !previousAssessment") Continue to Agreement 
                    span
                      b-icon.mx-3(icon="file-earmark-lock2")
                b-button.px-4.py-2.mx-4( v-show="notPDFview" v-if="viewamtcollect" variant="primary" @click="paymentSubmission" ) Continue to Payment
                    span
                      b-icon.mx-3(icon="cash-stack")
                

          
          div( ref='pdfFormView' v-if="viewServiceForm")
            //- section.m-4
            //-   h2.my-3 Terms & Conditions
            //-       iframe.mt-3(
            //-       v-if="termsAndConditionUrl"
            //-       :src="termsAndConditionUrl"
            //-       width="100%"
            //-       height="600px"
            //-       style="width:100%; height:600px; border:none; outline:none; box-shadow:none;"
            //-     )  
            section.p-4.border.my-4.border-light.rounded.shadow(v)
              h2.my-3 Service Agreement Form 
              .row.mt-5
                  .col-sm.text-left
                    p NRIC Name of Client:
                  .col-sm
                    | {{ clientdata.crb5c_no }}
              .row.mt-3
                  .col-sm.text-left
                    p NRIC No. of Client:
                  .col-sm
                    | {{ clientdata.crb5c_nricno}}
              .row.mt-3
                  .col-sm.text-left
                    p Services Provided:
                  .col-sm
                    p {{ cipEligibility ? "CIP Programme" : "Family of Wisdom (Enrichment) Programme" }}
              .row.mt-3
                  .col-sm.text-left
                    p Date of Commencement:
                  .col-sm
                    | {{ adm }}
                    
              hr
              section(v-if="!cipEligibility").mt-3
                  h5.my-4.font-weight-bold Part I
                  .px-3.pb-4.text-justify(style="line-height: 2em")
                    p
                      | I,
                      v-select.w-25.mx-2.d-inline-block(
                        :options="caregiverDetails"
                        v-model="caregiverPicked"
                        label="crb5c_name"
                        taggable
                        :class="{'invalid': !caregiverPicked}"
                      )
                      | , consent to allow Dementia Singapore Ltd, and/or its authorised representatives to collect, use, process, or disclose the personal data (including name, NRIC, and medical records) about my

                      input.form-control.w-25.mx-2.d-inline-block(
                        type="text"
                        v-model="clientReationship"
                        placeholder="Spouse / Sibling / Children / Caregiver / Guardian"
                        :class="{'invalid': !clientReationship}"
                      )
                      |  (relationship),

                      input.form-control.w-50.mx-2.d-inline-block(
                        type="text"
                        v-model="caregiverClientName"
                        placeholder="Client Name"
                        :class="{'invalid': !caregiverClientName}"
                      )
                      |  (NRIC Name of client), for the purpose of:

                    ol.mt-3
                      li Assessing our profiles and needs to develop and implement intervention plans;
                      li Referring me to another agency that may be better able to support me than Dementia Singapore Ltd;
                      li Sharing of data provided to Dementia Singapore Ltd (e.g. personal data and medical data) with other authorised representatives or service providers that may benefit my loved one with dementia / myself / my family member(s), for service improvement and continuity of care.

                    p.mt-3
                      | I trust that the Centre will undertake the necessary measures to keep this information safe and confidential in accordance with the PDPA guidelines.


              //- .row(style="text-align:justify;line-height:5vh")
              //-   .d-flex.flex-wrap
              //-     span.m-2 I,
              //-     v-select.w-25.d-inline.m-2(:options="caregiverDetails" v-model="caregiverPicked" label="crb5c_name" taggable)
                  //- b-form-select.w-25.d-inline.m-2(v-model="caregiverPicked" :options="caregiverDetails" value-field="crb5c_fow_caregiverid" text-field="crb5c_name")
                  //- span.m-2 consent to allow Dementia Singapore Ltd (NRIC Name), and/or its authorised representatives to collect,
                  //- span.m-2 use, process or disclose the personal data (including name, NRIC and medical records) about my
                  //- input.form-control.w-25.d-inline.m-2(type="text" v-model="clientReationship" placeholder="Spouse / Sibling / Children / Caregiver / Guardian")
                  //- span.m-2 (relationship) of
                  //- input.form-control.w-50.d-inline.m-2(type="text" v-model="caregiverClientName" placeholder="Client Name")
                  //- span.m-2 (NRIC Name of client), 
                  //- span.m-2 for the purpose of:
                  //- input.form-control.w-25.d-inline.m-2(type="text" v-model="caregiverClientIc" placeholder="Caregiver IC")
                  //- span.m-2 (NRIC No.).
              
              section(v-if="!cipEligibility")
                    h5.my-4.font-weight-bold Part II
                    .px-3.pb-4.text-justify(style="line-height: 2em")
                      p
                        | I understand a one-time registration fee of $50 + GST (i.e. $54.50) is collected on the day of assessment,
                        | as well as a one-month refundable deposit equivalent to the number of sessions intended to attend within
                        | one month (i.e. $340), will need to be paid upon admission. This will be refunded when the service is
                        | terminated with one-month notice given and if there are no outstanding dues.

                      p
                        | Program fees are charged at $85 per session before GST, based on the number of intended sessions in the month. 
                        | There will be no refund or replacement for missed sessions unless client provides a valid medical certificate or is hospitalized.

                      p 
                        | For doctor’s appointments in the following month, caregiver must inform the Centre in advance, no later than the last Monday of the month, and subsequently provide a medical certificate after the appointment. 
                        | Only when both advance notice and supporting documentation are received will the Centre waive the fee for that session in the following month’s advance fee collection.

                      p 
                        | Invoices will be released by the second working day of each month, and all payments must be made within 14 days from the date 
                        | the invoice is released through the Caregiver Mobile App.
                      p 
                        | For example: If the client has a doctor’s appointment on 12 March, the caregiver must notify the Centre by the last Monday of February. 
                        | After the appointment, a medical certificate must be submitted. Failure to provide either advance notice or the medical certificate will
                        | result in the session being charged in full.

                      p
                        | I understand that my loved one can be discharged from the Centre under the following conditions, as determined
                        | by the Centre Manager:

                      ul
                        li If my loved one has defaulted attendance for more than two months without official notice.
                        li If my loved one has been assessed by the Dementia Practitioner that continued attendance is no longer beneficial.
                        li If my loved one has developed unstable medical conditions requiring close monitoring, which cannot be safely managed at Family of Wisdom.
                        li If my loved one has unmanageable behavioural issues or uncontrolled mental illness that is overly disruptive or prohibits participation in group activities.

                      p
                        | I am responsible for settling any outstanding payments in full before my loved one is discharged from the Centre.

                      p
                        | I understand that I am required to provide one-month notice to withdraw my loved one from the Centre.
                        | Failing which, the one-month deposit will be forfeited. Exceptions may be granted if the client is hospitalized
                        | and is too sickly to return to the Centre.


              section.my-3(v-if="cipEligibility")
                h5.my-4.font-weight-bold.text-uppercase Part I

                .px-3.pb-4.text-justify(style="line-height: 2em")
                  p.d-flex.flex-wrap
                  | I,
                  v-select.w-25.mx-2.d-inline-block(
                    :options="caregiverDetails"
                    v-model="caregiverPicked"
                    label="crb5c_name"
                    taggable
                    :class="{'invalid': !caregiverPicked}"
                  )
                  | , consent to allow Dementia Singapore Ltd, and/or its authorised representatives to collect, use, process, or disclose the personal data (including name, NRIC and medical records) about my

                  input.form-control.w-25.mx-2.d-inline-block(
                    type="text"
                    v-model="clientReationship"
                    placeholder="Spouse / Sibling / Children / Caregiver / Guardian"
                    :class="{'invalid': !clientReationship}"
                  )
                  |  (relationship),

                  input.form-control.w-50.mx-2.d-inline-block(
                    type="text"
                    v-model="caregiverClientName"
                    placeholder="Client Name"
                    :class="{'invalid': !caregiverClientName}"
                    
                  )
                  | , for the purpose of:
                  
                  ol.mt-3
                    li Assessing our profiles and needs to develop and implement intervention plans;
                    li Referring me to another agency that may be better able to support me than Dementia Singapore Ltd as part of intervention work; and
                    li Sharing of data provided to Dementia Singapore Ltd (e.g. personal data and medical data) with other authorised representatives or Service Providers that may benefit my loved one with dementia / myself / my family member(s), for service improvement, and continuity of care.

                  p.mt-3
                    | I trust that the Centre will undertake the necessary measures to keep this information safe and confidential in accordance with PDPA guidelines.

              section(v-if="cipEligibility")
                h5.my-4.font-weight-bold.text-uppercase Part II

                .px-3.pb-4.text-justify(style="line-height: 2em")
                  p
                    | I understand a one-time registration fee of $50 + GST (i.e. $54.50) is collected on the day of assessment.

                  p.mt-3
                    | I understand that there are altogether 3 fee collections:

                  ul
                    li For the first 14 sessions
                    li For the next 18 sessions
                    li For the last 8 sessions

                  p.mt-3
                    | I understand that any unused session(s) will be refunded to me at the end of the program day.

                  p.mt-3
                    | I am agreeable to make payment before the start of each fee collection phase.
                                  

              hr  
              section.mt-3(style="text-align:left;")
                //- p I hereby declare that I have understood and agree to abide by the:
                //- ul
                //-     li Service Agreement
                //- p of Family of Wisdom (Bendemeer)
                .row.mt-3
                  .col 
                    .row.mt-3.mx-1
                          VueSignatureCanvas.gap.sig-canvas(ref="caregiverSignature" )
                    div.d-flex.justify-content-between
                      h5
                        u.text-center Caregiver Sign Here
                      b-button(v-show="notPDFview" variant="danger" @click="clearCanvas('caregiverSignature')") Clear
                  .col 
                    .row.mt-3.mx-1
                          VueSignatureCanvas.gap.sig-canvas(ref="staffSignature" )
                    div.d-flex.justify-content-between.align-items-center
                      h5
                        u.text-center Staff Sign Here 
                      b-button(v-show="notPDFview" variant="danger" @click="clearCanvas('staffSignature')") Clear
                hr
                .row.mt-2
                  .col-sm
                      p Contact Number:
                  .col-sm
                      input.form-control(type="tel" v-model="serviceAgreementContact")
                .row.mt-2
                  .col-sm
                      p Email:
                  .col-sm
                      input.form-control(type="email" v-model="serviceAgreementEmail")
                .row.mt-3
                  .col-sm 
                      p Date:
                  .col-sm
                      input.form-control(type="date" v-model="serviceAgreementDate")
                div.mt-5.d-flex.align-items-center.justify-content-between
                  b-button.px-5.py-2( v-show="notPDFview" v-if="viewamtcollect" variant="success" @click="paymentSubmission" ) Continue to Payment
                  b-button.px-5.py-2( v-show="notPDFview" v-if="viewamtcollect" variant="danger" @click="skipPayment" ) Skip Payment
                  //- b-form-checkbox.mx-3.common(v-model="skipInvoice") 
                  //-         span.mx-1 Skip Invoice
                
                //- .row(v-if="imagesSign")
                //-   img(:src="'data:image/jpeg;base64,' + imagesSign[0].crb5c_caregiversignature")
              //- input.numbers#collect(v-model="amtcollect " name="collect" type="text" readonly="readonly") 
        
      section(v-if="modeofpayment")
        //- b-row.justify-content-center
        //-     VueSignatureCanvas.gap(ref="handWrite" :canvasProps="{class: 'sig-canvas'}")
        //- b-row.justify-content-center
        //-     b-btn.gap.confimrationBtn#getImagebtn(@click="getImage()") Submit 
        //- b-row
        //-   .col-sm-2
        //-     img.signatureView(:src="signatureImg")
      //- Submit button 

</template>
  
  <script>
  
  import dayjs from "dayjs";
  // import html2canvas from 'html2canvas';
  import * as html2pdf from 'html2pdf.js';
  import {Icon} from '@iconify/vue2';
  import PaynowQR from 'paynowqr'
  import VueQrcode from '@chenfengyuan/vue-qrcode';
  import utc from "dayjs/plugin/utc";
  import timezone from "dayjs/plugin/timezone"; // dependent on utc plugin
  import isToday from "dayjs/plugin/isToday";
  import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
  import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
  import advancedFormat from "dayjs/plugin/advancedFormat";
  import axios from 'axios';
  import VueSignatureCanvas from 'vue-signature-canvas';
  import { createInvoice} from "@/utils/generateInvoiceNumber.mjs";
  import { 
    // mapState, 
    mapMutations, 
  } from "vuex";

  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.extend(isToday);
  dayjs.extend(isSameOrBefore);
  dayjs.extend(isSameOrAfter)
  dayjs.extend(isSameOrBefore)
  dayjs.extend(advancedFormat)
    
  const defaultTimezone = "Asia/Singapore";
  dayjs.tz.setDefault(defaultTimezone);
  import "vue-select/dist/vue-select.css";
  import vSelect from "vue-select";
import generatePDF from "@/utils/generatePDF";
  const FORM_VERSION = '3.1';
  // import colors from "././scss/colors.scss";
  export default {
    // Deselect,
    // OpenIndicator,
    
    components: { 
      vSelect,
      VueQrcode,
      // PaynowQR,
      // VueQrcode,
      Icon,
      VueSignatureCanvas,
    },
    // emits: ["newresource"],
    data() {
      return {
        formVersion: FORM_VERSION,
        previousPaymentInfo: null,
        clientPostCode: '',
        allHolidays: [],
        holidaysLoaded: false,
        holidayRetrying: false,
        previousAssessment: null,
        submitOnlyAssessment: false,
        notJoining: false,
        processing: false,
        termsAndConditionUrl: '/terms-condition/fow-terms.pdf',
        cipPreset: null,
        cipAdditionalTransport: 0,
        cipAdm: '',
        showTemplateList: false,
        cipPhase: 14,
        cipTemplates: [],
        transportInclude: false,
        // cipEstimatedFee: 0,
        selectedFowTemplate: [],
        selectedCipTemplate: [],
        transportTemplates: [],
        formCompleted: false,
        totalToCollect: 0,
        neeuroFitAuto: false,
        notPDFview: true,
        edit_time: null,
        dateofassessment: '',
        invoices: [],
        // CIPdays: 0,
        CIPprice: 0,
        caregiverNamePrefilled: '',
        pdfFullPage: '',
        pdfAgreement: '',
        clientReationship: '',
        caregiverPicked: null,
        caregiverDetails: [],
        adHocFeeTableFields:[
          {key:'remark', label:'Remarks'},
          {key:'total', label:'Amount'},
          {key:'isRecurring', label:'Recurring (Monthly)'},
          {key:'isIncludeInFee', label:'Include in Fee'},
          {key:'action', label:'Action'}
        ],
        sessionTableFields:[
          {key:"session_name", label:"Name"},
          {key:"session_duration", label:"Duration"},
          {key:"session_type", label:"Type"},

          {key:"actions", label:"Actions"}
        ],
        language:null,
        loadingSubmission: false,
        loadingAutomated: false,
        newDuration: 180,
        newDementiaType: null,
        newSessionType: null,
        newSessionTitle: '',
        viewServiceForm: false,
        caregiverName: '',
        caregiverRelationship: '',
        caregiverClientName: '',
        caregiverClientIc: '',
        serviceAgreementContact: '',
        serviceAgreementEmail: '',
        serviceAgreementName: '',
        serviceAgreementDate: '',
        imagesSign: [],
        isNeeuroFit: 'NeeuroFIT 6 months subcription',
        adHocItems:{
          remark : '',
          total: null,
          isRecurring: false,
          isIncludeInFee: false,
        },
        dementiaLvl: [
          {text: 'Mild', value: 0 },
          {text: 'Moderate', value: 1 },
          {text: 'Individual', value: 3 }
        ],
        durationSession: [
          {text: '1 hour', value: 60 },
          {text: '1 hour 30 minute', value: 90 },
          {text: '2 hours', value: 120 },
          {text: '3 hour', value: 180 },
        ],
        sessionType: [
          {text: 'Group HQ (Centre) Based', value: 0},
          {text: 'One-to-one HQ (Centre) Based', value: 1},
          {text: 'Home Based', value: 2},
          {text: 'Virtual / Online / Zoom', value: 3},
        ],
        adHocFeeTotal: [],
        pick_sessions: [],
        schedule_info: [],
        recommended_session_pick: [],
        GST: 1.09,
        neeuroFitFees: 240,
        applicableFeeTotal: [],
        additionalFeeTotal: [],
        refundableFeeTotal: null,
        redundableFeeTotal: null,
        neeurofitFeeTotal: null,
        one_time_other_value: null,
        additionalFees: {
          one_time :{
            price: 50,
          },
          one_time_waived :{
            price: 0,
          },
        },
        filterTypeValues: [],
        programmeInfos: [],
        filesToUpload: [],
        assessment_files: [],
        name: 'FirstSignatureCanvas',
        signatureImg: '',
        listPublicHolidayCurrentMonth: null,
        dsgOffDay: {
          date: null,
          startDate: null,
          endDate: null,
          listDay: [],
        },
        attentionObj: {
          attentiongame: null,
          attentionlevel: null,
        },
        spatialObj: {
          spatialgame: null,
          spatiallevel: null,
        },
        decisionObj: {
          decisiongame: null,
          decisionlevel: null,
        },
        memoryObj: {
          memorygame: null,
          memorylevel: null,
        },
        flexibilityObj:{
          flexibilitygame: null,
          Flexibilitylevel: null,
        },
        subs1val: null,
        dsgsubsidy: null,
        isCIP: 0,
        depositPaid: true,
        // skipInvoice: false,
        showDepositQRSection: false,
        depositOnlyAmount: 0,
        depositRecordCreated: false,
        invoiceDepositRecordCreated: false,
        draftAssessmentId: null,
        draftCreatedBy: null,
        draftLastModifiedBy: null,
        draftSaving: false,
        draftSaveStatus: null, // null | 'saved' | 'error'
        autoSaveStatus: null,  // null | 'saving' | 'saved' | 'error'
        firstSesFormat: 0,
        secondSesFormat: 0,
        // Manual override flags (independent controls)
        manualCipEligibility: null, // null = auto, true = force eligible, false = force not eligible
        programmeOverride: null, // null = auto, 'CIP' = force CIP, 'FOW' = force FOW
        phase3CompletionChoice: null, // null = not chosen, 'complete' = complete program, 'switch-to-fow' = switch to FOW
        totalforCIP: 0,
        CIPdays: '',
        isAMT: false,
        isMOCA: false,
        isMMSE: false,
        mmseVal: null,
        amtVal: null,
        mocaVal: null,
        gstval: 1.09,
        checkCenter:false,
        checkResidence:false,
        checkZoom:false,
        gotIndividualFee:false,
        gotGroupFee:false,
        modeofpayment: null,
        healthscale: 0,
        totalscoreMoca: null,
        totalscoreEq: null,
        normcost: 65 ,
        clientdata: [],
        neeuro: false,
        atten: false,
        spatial: false,
        decision: false,
        memory: false,
        flexibility: false,
        checker: false,
        checker2: false,
        checker3: false,
        checker4: false,
        checker5: false,
        subsidy: false,
        no: null,
        checking: "",
        sessions: [],
        // latestscore: "",
        adm: "",
        preSessionDate: "",
        // latest: "0",
        type: "",
        stageof: "",
        date: null,
        edulev: "",
        gp: false,
        ind: false,
        subsidyAmount: null,
        firSession: null,
        secSession: null,
        subs1: false,
        subs2: false,
        subs3: false,
        subs4: false,
        // amtcollect: 0,
        // amtcollectGst: 0,
        totalGST:[] ,
        totalNoGST: [],
        // fees1: [],
        // fees2: false,
        // fees3: false,
        // fees4: false,
        // fees5: false,
        // fees6: false,
        // fees7: false,
        // fees8: false,
        // fees9: false,
        // fees10: false,
        // fees11: false,
        // fees12: false,
        // fees13: false,
        cn: false,
        en: false,
        referenceid: null,
        unyearSelected: false,
        ovyearSelected: false,
        un: false,
        ov: false,
        typeses: false,
        day: false,
        time: false,
        location: false,
        unpoint: 0,
        vis1: [0],
        vis2: [0],
        vis3: [],
        vis4: [0],
        vis5: [0],
        vis6: [0],
        vis7: [0],
        vis8: [0],
        vis9: [0],
        vis10: [0],
        vis11: [0],
        vis12: [0],
        vis13: [0],
        vis14: [0],
        vis15: [],
        vis16: [],
        vis17: [0],
        vis18: [],
        eq1: 0,
        eq2: 0,
        eq3: 0,
        eq4: 0,
        eq5: 0,
        subsidyoptions:[
          "%",
          "$"
        ],
        DementiaType: [
          "Alzheimer’s Disease",
          "Vascular Dementia",
          "Mixed Dementia",
          "Lewy Body Dementia",
          "Parkinson Dementia",
          "Fronto-temporal Dementia",
          "Others",
        ],
        DementiaStage: [
          "Mild",
          "Mild to Moderate",
          "Moderate",
          "Moderate to Severe",
          "Severe",
        ],
        levels: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
        game1: [
          "Psychic Cyclist",
          "Mindcopter",
          "Sushi Recall",
          "Sitting Ducks",
          "Multitask Master",
        ],
        game2: ["Whats’s this Word ?", "Dot Connect", "Stargazer", "Space 360"],
        game3: [
          "Junction Control",
          "Pyramid Solitaire",
          "Supreme Shopper",
          "Flower Garden",
        ],
        game4: [
          "Farmhouse Friends",
          "Who’s Who?",
          "Pyramid Solitaire",
          "Sushi Recall",
          "Sitting Ducks",
        ],
        game5: ["Multitask Master", "Junction Control"],
        edulevel: [
          "No Education",
          "Primary",
          "Secondary",
          "Pre-University",
          "Diploma",
          "Associate Degree",
          "Bachelor’s Degree",
          "Master’s Degree",
          "Doctorate Degree",
        ],
        dclock: ["Contour(1 point)", "Numbers(1 point)", "Hands(1 point)"],
        specify: [
          "0",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "more than 11",
        ],
        mocaLanguage: 'en',
        Delayed: [
          "Cannot Recall(0 point)",
          "Face(1 point)",
          "Silk(1 point)",
          "Church(1 point)",
          "Rose(1 point)",
          "Red(1 point)",
        ],
        DelayedChinese: [
          "Cannot Recall(0 point)",
          "Face(脸)(1 point)",
          "Silk(丝绸)(1 point)",
          "Church(教堂)(1 point)",
          "Rose(菊花)(1 point)",
          "Red(红色)(1 point)",
        ],
        OrientationChinese: [
          'Date (日)',
          'Month (月)',
          'Year (年)',
          'Day (星期)',
          'Place (地点)',
          'Country (国家)',
        ],
        eq5dnumbers: ['0', '1', '2', '3', '4', '5'],
        toteboardPR: ['15','30','40','50','55'],
        toteboardSG: ['30','50','60','75','80'],
        transport: {
          isIncluded: false,
          startPostalCode: '',
          destinationPostalCode: '339914',
          amountToBePaid: null,
          fixedFee: 49,
          iframeSrc: 'https://maps.google.com/maps?saddr=Singapore&ie=UTF8&output=embed&mode=driving',
        },
      };
    },
    compatConfig: { MODE: 3 },
    async mounted() {
      window.addEventListener('beforeunload', this.handleExit);
      const component = this;
      this.$root.$on('getFormData', function(){
        component.getdatainform();
      });
      await this.loadDraftFromCloud();
      
      let today = dayjs().format('YYYY-MM-DD')
      this.serviceAgreementDate = today;
      
      this.dateofassessment = dayjs().format("YYYY-MM-DD");
      this.$store.commit('assessment_date',this.dateofassessment);

      await this.filterFees(); 

      this.previousAssessment = await this.getPreviousAssessment();
      if (this.previousAssessment) {
        this.checkPreviousAssessment();
      }
    },
    beforeUnmount(){
      window.removeEventListener('beforeunload', this.handleExit);
      if (this._holidayRetryTimer) clearInterval(this._holidayRetryTimer);
    },
    methods: {
      checkTransportClient(clientPostCode){
        if (clientPostCode && clientPostCode.length >= 3) {
          this.transport.startPostalCode = this.clientPostCode || '' ;
          this.checkDistanceTransport();
          }
      },
      getTransportInfo(invoice) {
        if (!invoice) return null;

        const text = invoice.replace(/<[^>]*>/g, ' ');

        const result = {
          hasTransport: false,
          transportFee: null,
          hasAdditionalTransport: false,
          additionalTransportFee: null
        };

        const transportMatch = text.match(
          /Transport fee per session.*?\$([\d.]+)/i
        );

        if (transportMatch) {
          result.hasTransport = true;
          result.transportFee = Number(transportMatch[1]);
          this.transportInclude = true;
        }

        const additionalMatch = text.match(
          /Additional Transport Fee.*?\$([\d.]+)/i
        );

        if (additionalMatch) {
          result.hasAdditionalTransport = true;
          result.additionalTransportFee = Number(additionalMatch[1]);
          this.cipAdditionalTransport = result.additionalTransportFee;
        }

        return result;
      },
      addTransport(){
        this.transport.startPostalCode = this.clientPostCode || '' ;
        this.$bvModal.show('cip-add-distance');
      },
      displayFowAmount(val){
        return val
      },
      getPhaseEndDate(){
        if (!this.cipEligibility || !this.cipSessionDates) return null;
        const sessions = this.cipSessionDates.sessions;
        if (!sessions.length) return null;
        return dayjs(sessions[sessions.length - 1], "ddd, DD MMM YYYY");
      },
      getPhaseTimeline(){
        if (!this.cipEligibility || !this.cipSessionDates) return null;
        const dates = this.groupCipSessionsByMonth(this.cipSessionDates.sessions);
        return JSON.stringify(dates);
      },
      getFowTimeline(){
        if (this.cipEligibility || !this.fowSessionDates) return null;
        const dates = this.groupFowSessionsByMonth(this.fowSessionDates.sessions);
        return JSON.stringify(dates);
      },
      cipPhaseChecker(){
        // Check Phase 3 completion choices first
        if(this.phase3CompletionChoice === 'complete'){
          return 4; // Completed program
        }
        if(this.phase3CompletionChoice === 'switch-to-fow'){
          return 5; // Switched to FOW
        }
        
        // Regular phase progression
        if(this.cipEligibility && !this.previousAssessment?.crb5c_cipphase){
          return 1;
        }else if(this.cipEligibility && this.previousAssessment?.crb5c_cipphase === 1){
          return 2;
        }else if(this.cipEligibility && this.previousAssessment?.crb5c_cipphase === 2){
          return 3;
        }else{
          return null;
        }
      },
      checkPreviousAssessment(){
        if (this.previousAssessment) {
          console.log('Client has previous assessment');
          this.type = this.previousAssessment.crb5c_typeofdementia;
          this.stageof = this.previousAssessment.crb5c_stageofdementia;
          this.isAMT = this.previousAssessment.crb5c_amtscore ? true : false;
          this.amtVal = this.previousAssessment.crb5c_amtscore;
          this.isMOCA = this.previousAssessment.crb5c_mocascore ? true : false;
          this.mocaVal = this.previousAssessment.crb5c_mocascore;
          this.isMMSE = this.previousAssessment.crb5c_mmsescore ? true : false;
          this.mmseVal = this.previousAssessment.crb5c_mmsescore;
          this.date = this.previousAssessment.crb5c_datedone;
          this.previousPaymentInfo = this.getTransportInfo(this.previousAssessment.crb5c_InvoiceLookup.crb5c_description);
        }

        if(this.previousAssessment?.crb5c_cipphase){
          let phase = this.previousAssessment?.crb5c_cipphase;
          switch (phase) {
            case 1:
              this.cipPhase = 18
              break;
            case 2: 
              this.cipPhase = 8
              break;
            case 3:
              // Phase 3 - no more CIP sessions, user will choose completion or FOW
              this.cipPhase = 0;
              break;
            default:
              break;
          }
          }
      },
      async getPreviousAssessment(){
         let client_id = this.$store.state.assessment_client_id;
         let {data} = await axios.get(`/api/assessment?client_id=${client_id}`);
         return data.assessment[0] || null;
      },
      handleExit(event){
        if (!this.formCompleted) {
          const alertMessage = "You are about to leave? Unsaved changes will be lost.";
          event.returnValue = alertMessage;
          return alertMessage;
        }
      },
    ...mapMutations(['assessmentDataChange']),
    async chooseCIPtemplate(){
      // let fees = await this.getSubsidyandFee();
      // this.cipTemplates = fees.filter(item => item.crb5c_transportfee === false);
      // this.transportTemplates = fees.filter(item => item.crb5c_transportfee === true);
      // console.log('cip templates',this.cipTemplates);
      // console.log('transport templates',this.transportTemplates);
      this.$bvModal.show('chooseCIPTemplate');
    },
    skipToPayment(){
      // Show modal to ask if user wants to include one-time assessment fee
      this.$bvModal.show('skip-payment-modal');
    },
    async confirmSkipToPayment(includeAssessmentFee){
      this.notJoining = true;
      await this.clearPayment(includeAssessmentFee);
      this.$bvModal.hide('skip-payment-modal');
      this.paymentSubmission();
    },
    clearPayment(includeAssessmentFee = false){
      this.refundableFeeTotal = null;
      this.neeurofitFeeTotal = null;
      this.additionalFeeTotal = [];
      this.applicableFeeTotal = [];
      this.cipAdditionalTransport = 0;
      // Only add the one-time assessment fee if user chose to include it
      if (includeAssessmentFee) {
        this.additionalFeeTotal.push(this.additionalFees.one_time.price);
      }
    },
    async updateCIPSessions() {
      // console.log('updating cip sessions');
      const data = await this.getSessionScheduleinform();

      if (!data || !data.length) {
          console.error("Session schedule data is null or empty");
          return;
        }
      this.schedule_info = data;
      this.schedule_info.sort((a, b) => a.crb5c_day - b.crb5c_day);

      const cipSessions = [
        "610c6561-1d61-f011-bec1-002248eba87a",
        "413249eb-381a-ee11-8f6d-002248ecdc58",
      ];

      await this.$nextTick();

      const filtered = this.schedule_info.filter(item =>
        cipSessions.includes(item.crb5c_fow_session_scheduleid?.trim()) &&
        !this.recommended_session_pick.some(existing => 
          existing.crb5c_fow_session_scheduleid === item.crb5c_fow_session_scheduleid
        )
      );
      
      // console.log('filtered cip sessions', filtered);
      // console.log('schedule_info length', this.schedule_info.length);
      
      if (filtered.length > 0) {
        this.recommended_session_pick = [...this.recommended_session_pick, ...filtered];
      } else {
        console.warn('No CIP sessions found in schedule_info');
      }
    },
    groupCipSessionsByMonth(dates) {
      const grouped = {};
      dates.forEach(dateStr => {
        const date = dayjs(dateStr, 'ddd, DD MMM YYYY');
        const monthKey = date.format('MMMM YYYY');
        if (!grouped[monthKey]) {
          grouped[monthKey] = [];
        }
        grouped[monthKey].push(dateStr);
      });
      // console.log('grouped',grouped)
      return grouped;
    },
    groupFowSessionsByMonth(dates) {
      const grouped = {};
      dates.forEach(dateStr => {
        const date = dayjs(dateStr, 'ddd, DD MMM YYYY');
        const monthKey = date.format('MMMM YYYY');
        if (!grouped[monthKey]) {
          grouped[monthKey] = [];
        }
        grouped[monthKey].push(dateStr);
      });
      // console.log('fowGrouped',grouped)
      return grouped;
    },
    pickTemplate(template){
      this.selectedCipTemplate = template;
      // console.log('selectedCipTemplate',this.selectedCipTemplate);
      this.showTemplateList = false;
    },
    displayAmount(val){
      let cost = (Number(val) || 0) / 100;
      return (cost * this.cipPhase).toFixed(2)
    },
    roundUp(val){
      return (Number(val) || 0) / 100;
    },
    applyTemplate(){
      this.$bvModal.hide('chooseCIPTemplate');
    },
    printPopup(){
      const data = {
          // general details
          name: 'Assessment Form',
          clientName: this.$store.state.assessment_client_name,
          clientId: this.$store.state.assessment_client_id,
          clientNRIC: this.clientdata.crb5c_nricno,
          caregiverName: this.caregiverPicked,
          caregiverRelationship: this.clientReationship,
          dateofassessment: this.$store.state.assessment_date,
          admissiondate: this.adm,

          // assessment details
          typeofdementia: this.type,
          stageofdementia: this.stageof,
          latestscore: this.latestscore,
          latestscorevalue: (this.latestscore == 'MOCA') ? this.totalscoreMoca : this.latest,
          datedone: this.date,
          sharedcentreobjectivesprogramme: this.checker,
          watchedcentrevideo: this.checker2,
          playedtabletopgame: this.checker3,
           mocascore: (this.isMOCA) ? this.mocaVal : 0,
          amtscore: (this.isAMT) ? this.amtVal : 0,
          mmsescore: (this.isMMSE) ? this.mmseVal : 0,

          // visual-spatial & game details
          playedneeurofitgame: this.neeuro,
          eq5d5lform: this.checker5,
          isMocaForm: this.checker4,

          // score of neurofit
          attentiongame: this.attentionObj.attentiongame,
          attentionlevel: this.attentionObj.attentionlevel,
          spatialgame: this.spatialObj.spatialgame,
          spatiallevel: this.spatialObj.spatiallevel,
          decisiongame: this.decisionObj.decisiongame,
          decisionlevel: this.decisionObj.decisionlevel,
          memorygame: this.memoryObj.memorygame,
          memorylevel: this.memoryObj.memorylevel,
          flexibilitygame: this.flexibilityObj.flexibilitygame,
          Flexibilitylevel: this.flexibilityObj.Flexibilitylevel,

          //moca form
          educationlevel: this.edulev,
          educationYear: this.unyearSelected ? '≤ 6 Years' : ' > 6 Years',
          trailMaking: this.vis1,
          uploadedImageTrailMaking: this.imageForVis1,
          copyCube: this.vis2,
          uploadedImageCopyCube: this.imageForVis2,
          drawClock: this.vis3,
          uploadedImageDrawClock: this.imageForVis3,
          nameLion: this.vis4,
          nameElephant: this.vis5,
          nameCamel: this.vis6,
          attentionGame: {
            repeatForward: this.vis7,
            repeatBackward: this.vis17,
            ableToTap: this.vis8,
            serial7Subtraction: this.vis9,
          },
          languageGame: {
            repeatFirstSentence: this.vis10,
            repeatSecondSentence: this.vis11,
            fluency: this.vis18,
          },
          abstractionGame: {
            similarityTrainBicycle: this.vis13,
            similarityWatchRuler: this.vis14,
          },
          delayedRecall: this.vis15,
          orientation: this.vis16,

          // eq5d5l score
          eqmobility: this.eq1,
          eqselfcare: this.eq2,
          equsualactivities: this.eq3,
          eqpaindiscomfort: this.eq4,
          eqanxietydepression: this.eq5,
          eqhealthscale: this.healthscale,
          
          // comments 
          commentsaboutclient: this.checking,
        //service agreement
          serviceAgreement: this.pdfAgreement,
          // signature
          staffSignature: this.staffSignatureImg,
          caregiverSignature: this.caregiverSignatureImg,
          
        };

        generatePDF(data);
    },
    getSessionSchedulerNames() {
      if (!Array.isArray(this.recommended_session_pick) || !this.recommended_session_pick.length) {
        return 'N/A';
      }

      const names = [...new Set(
        this.recommended_session_pick
          .map((session) => session.crb5c_session_id || session.crb5c_name)
          .filter(Boolean)
      )];

      return names.length ? names.join(', ') : 'N/A';
    },
    getSessionJoiningSummary() {
      const schedulerNames = this.getSessionSchedulerNames();

      if (this.cipEligibility && this.selectedCipTemplate?.description) {
        return `CIP : ${this.selectedCipTemplate.description} (${this.cipPhase || 0} sessions)`;
      }

      if (schedulerNames !== 'N/A') {
        return 'FOW';
      }

      return 'FOW';
    },
    toMoney(value) {
      return Number(value || 0).toFixed(2);
    },
    buildCoverPageData() {
      const enrolledDate = this.cipAdm || this.adm || 'N/A';
      const sessionJoining = this.getSessionJoiningSummary();
      const sessionSchedulerNames = this.getSessionSchedulerNames();
      const assessmentFeeWithoutGst = this.additionalFeeTotal.includes(this.additionalFees.one_time.price)
        ? Number(this.additionalFees.one_time.price)
        : 0;

      const cipProgrammeFeePerSession = this.cipEligibility
        ? this.roundUp(this.selectedCipTemplate?.Oop)
        : 0;
      const cipPhaseCount = this.cipEligibility ? (this.cipPhase || 0) : 0;
      const cipProgrammeFeeTotal = cipProgrammeFeePerSession * cipPhaseCount;

      const transportWithin5kmPerSession = this.cipEligibility && this.transportInclude
        ? this.roundUp(this.selectedCipTemplate?.transport)
        : 0;
      const transportWithin5kmTotal = transportWithin5kmPerSession * cipPhaseCount;

      const extraTransportPerSession = this.cipEligibility
        ? Number(this.cipAdditionalTransport || 0)
        : 0;
      const extraTransportTotal = extraTransportPerSession * cipPhaseCount;

      const fowSessionCount = !this.cipEligibility && !this.isAdmissionNextMonth
        ? (this.fowSessionDates?.sessions?.length || 0)
        : 0;
      const fowProgrammeFeePerSession = !this.cipEligibility
        ? Number(this.totalOfApplicable || 0)
        : 0;
      const fowProgrammeFeeTotal = fowProgrammeFeePerSession * fowSessionCount;

      const rows = [];

      if (assessmentFeeWithoutGst > 0) {
        rows.push({
          item: 'Assessment Fee',
          detail: 'One-time Assessment',
          amount: this.toMoney(assessmentFeeWithoutGst),
        });
      }

      if (this.cipEligibility) {
        rows.push({
          item: 'CIP Programme Fee',
          detail: `$${this.toMoney(cipProgrammeFeePerSession)} x ${cipPhaseCount} session(s)`,
          amount: this.toMoney(cipProgrammeFeeTotal),
        });
        rows.push({
          item: 'Transport Fee (within 5km) ',
          detail: `$${this.toMoney(transportWithin5kmPerSession)} x ${cipPhaseCount} session(s)`,
          amount: this.toMoney(transportWithin5kmTotal),
        });
        rows.push({
          item: 'Additional Transport (beyond 5km)',
          detail: `$${this.toMoney(extraTransportPerSession)} x ${cipPhaseCount} session(s)`,
          amount: this.toMoney(extraTransportTotal),
        });
      } else {
        if (fowSessionCount > 0 && fowProgrammeFeePerSession > 0) {
          rows.push({
            item: 'Programme Fee ',
            detail: `$${this.toMoney(fowProgrammeFeePerSession)} x ${fowSessionCount} session(s)`,
            amount: this.toMoney(fowProgrammeFeeTotal),
          });
        }
        if (this.isAdmissionNextMonth) {
          rows.push({
            item: 'Advance Session',
            detail: 'Programme fee will be calculated in the next invoice',
            amount: '0.00',
          });
        }
        (this.selectedProgrammeSummary || [])
          .filter((p) => p.name !== 'One-time Assessment')
          .forEach((programme) => {
            const rawCost = programme.cost;
            const isNumericCost = typeof rawCost === 'number'
              || (!Number.isNaN(Number(rawCost)) && rawCost !== 'Included');
            const displayCost = rawCost === 'Included'
              ? 'Included'
              : (isNumericCost ? `$${this.toMoney(rawCost)}` : String(rawCost));
            const qtyText = programme.quantity > 1 ? ` x ${programme.quantity}` : '';
            const amountStr = rawCost === 'Included'
              ? 'Included'
              : (isNumericCost ? this.toMoney(rawCost) : String(rawCost));
            rows.push({
              item: `${programme.name}`,
              detail: `${displayCost}${qtyText}`,
              amount: amountStr,
            });
          });
      }

      const totalPaidWithGst = this.toPayAmount || 0;
      const totalPaidWithoutGst = this.depositPaid
        ? (this.viewamtcollectNoGST || 0)
        : ((this.viewamtcollectNoGST || 0) - (this.refundableFeeTotal ? this.refundableDeposit : 0));

      const cipPhase = this.cipPhaseChecker();
      let title;
      if (!this.cipEligibility) {
        title = 'Payment for New FOW Client';
      } else if (cipPhase === 1) {
        title = 'Payment for CIP Phase One';
      } else if (cipPhase === 2) {
        title = 'Payment for CIP Phase Two';
      } else if (cipPhase === 3) {
        title = 'Payment for CIP Phase Three';
      } else {
        title = 'Payment for CIP Programme';
      }

      return {
        title,
        clientName: this.caregiverClientName || this.$store.state.assessment_client_name || 'N/A',
        sessionStartDate: enrolledDate,
        preSessionDate: (this.cipEligibility && this.cipPhaseChecker() === 1) ? (this.preSessionDate || '') : '',
        programme: sessionJoining || 'N/A',
        sessionEnrolled: sessionSchedulerNames,
        notJoining: this.notJoining || false,
        modeOfPayment: this.modeofpayment || 'Skipped',
        paymentDate: this.modeofpayment ? dayjs().format('DD MMM YYYY') : null,
        rows,
        totalWithGst: this.toMoney(totalPaidWithGst),
        totalWithoutGst: this.toMoney(totalPaidWithoutGst),
        assessmentDoneDate: dayjs().format('DD MMM YYYY'),
        assessmentData: {
          clientName: this.caregiverClientName || this.$store.state.assessment_client_name || 'N/A',
          clientNRIC: this.clientdata?.crb5c_nricno || 'N/A',
          caregiverName: this.caregiverPicked?.crb5c_name || 'N/A',
          caregiverRelationship: this.clientReationship || 'N/A',
          dateofassessment: this.$store.state.assessment_date || 'N/A',
          admissiondate: this.adm || 'N/A',
          typeofdementia: this.type || 'N/A',
          stageofdementia: this.stageof || 'N/A',
          amtscore: this.isAMT ? this.amtVal : 0,
          mocascore: this.isMOCA ? this.mocaVal : 0,
          mmsescore: this.isMMSE ? this.mmseVal : 0,
          datedone: this.date || 'N/A',
          educationlevel: this.edulev || 'N/A',
          educationYear: this.unyearSelected ? '≤ 6 Years' : '> 6 Years',
          trailMaking: this.vis1 || 'N/A',
          copyCube: this.vis2 || 'N/A',
          drawClock: this.vis3 || 'N/A',
          nameLion: this.vis4 || 'N/A',
          nameElephant: this.vis5 || 'N/A',
          nameCamel: this.vis6 || 'N/A',
          attentionGame: {
            repeatForward: this.vis7 || 'N/A',
            repeatBackward: this.vis17 || 'N/A',
            ableToTap: this.vis8 || 'N/A',
            serial7Subtraction: this.vis9 || 'N/A',
          },
          languageGame: {
            repeatFirstSentence: this.vis10 || 'N/A',
            repeatSecondSentence: this.vis11 || 'N/A',
            fluency: this.vis18 || 'N/A',
          },
          abstractionGame: {
            similarityTrainBicycle: this.vis13 || 'N/A',
            similarityWatchRuler: this.vis14 || 'N/A',
          },
          delayedRecall: this.vis15 || 'N/A',
          orientation: this.vis16 || 'N/A',
          eqmobility: this.eq1 || 'N/A',
          eqselfcare: this.eq2 || 'N/A',
          equsualactivities: this.eq3 || 'N/A',
          eqpaindiscomfort: this.eq4 || 'N/A',
          eqanxietydepression: this.eq5 || 'N/A',
          eqhealthscale: this.healthscale || 'N/A',
          commentsaboutclient: this.checking || '',
        },
      };
    },
    buildCoverPageBodyHtml(d) {
      const rowsHtml = d.rows.map((row) => {
        const amountDisplay = !Number.isNaN(parseFloat(row.amount))
          ? `$${row.amount}`
          : row.amount;
        return `
                <tr>
                  <td>${row.item}</td>
                  <td>${row.detail}</td>
                  <td>${amountDisplay}</td>
                </tr>`;
      }).join('');

      const preSessionHtml = d.preSessionDate
        ? `<p><strong>Trial Date:</strong> ${d.preSessionDate}</p>`
        : '';

      let paymentInfoHtml;
      if (d.notJoining) {
        paymentInfoHtml = `<p><strong>Status:</strong> Client Not Joining</p>`;
      } else if (d.modeOfPayment === 'Skipped') {
        paymentInfoHtml = `<p><strong>Mode of Payment:</strong> Skipped</p>`;
      } else {
        paymentInfoHtml = `<p><strong>Mode of Payment:</strong> ${d.modeOfPayment}</p>
           <p><strong>Date of Payment:</strong> ${d.paymentDate || 'N/A'}</p>`;
      }

      const hasFee = d.rows && d.rows.length > 0;
      const paymentBreakdownHtml = (d.notJoining && !hasFee) ? '' : `
            <div class="section-title">Payment Breakdown</div>
            <table>
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Details</th>
                  <th>Amount (SGD)</th>
                </tr>
              </thead>
              <tbody>
                ${rowsHtml}
              </tbody>
            </table>
            <p class="total">Total Paid / Payable (Without GST): $${d.totalWithoutGst}</p>
            <p class="total">Total Paid / Payable (With GST): $${d.totalWithGst}</p>
      `;

      return `
            <h2>${d.title}</h2>
            <div class="meta">
              <p><strong>Client Name:</strong> ${d.clientName}</p>
              ${preSessionHtml}
              <p><strong>Session Start Date:</strong> ${d.sessionStartDate}</p>
              <p><strong>Programme:</strong> ${d.programme}</p>
              <p><strong>Session Enrolled:</strong> ${d.sessionEnrolled}</p>
              ${paymentInfoHtml}
            </div>
            ${paymentBreakdownHtml}
            <p class="note">Assessment Done Date: ${d.assessmentDoneDate}</p>
      `;
    },
    printCoverPage() {
      const d = this.buildCoverPageData();
      const bodyHtml = this.buildCoverPageBodyHtml(d);

      const html = `
        <html>
          <head>
            <title>${d.title}</title>
            <style>
              body { font-family: Arial, sans-serif; padding: 32px; color: #222; }
              h2 { margin: 0 0 24px 0; color: #555; font-size: 18px; }
              .meta { margin-bottom: 20px; }
              .meta p { margin: 4px 0; }
              table { width: 100%; border-collapse: collapse; margin-top: 12px; }
              th, td { border: 1px solid #ddd; padding: 10px; text-align: left; vertical-align: top; }
              th { background: #f6f6f6; }
              .section-title { margin-top: 20px; font-weight: bold; }
              .total { font-weight: bold; font-size: 18px; margin-top: 16px; }
              .note { margin-top: 18px; color: #666; font-size: 13px; }
            </style>
          </head>
          <body>
            ${bodyHtml}
          </body>
        </html>
      `;

      const printWindow = window.open('', '_blank');
      if (!printWindow) {
        alert('Unable to open print window. Please allow pop-ups and try again.');
        return;
      }

      printWindow.document.open();
      printWindow.document.write(html);
      printWindow.document.close();

      printWindow.onload = () => {
        printWindow.focus();
        printWindow.print();
      };
    },
    printFullPDF() {
      const coverPageData = this.buildCoverPageData();
      const coverPageBodyHtml = this.buildCoverPageBodyHtml(coverPageData);

      const data = {
          name: 'Assessment Form',
          clientName: this.$store.state.assessment_client_name,
          clientId: this.$store.state.assessment_client_id,
          clientNRIC: this.clientdata.crb5c_nricno,
          caregiverName: this.caregiverPicked,
          caregiverRelationship: this.clientReationship,
          dateofassessment: this.$store.state.assessment_date,
          admissiondate: this.adm,
          typeofdementia: this.type,
          stageofdementia: this.stageof,
          latestscore: this.latestscore,
          latestscorevalue: (this.latestscore == 'MOCA') ? this.totalscoreMoca : this.latest,
          datedone: this.date,
          sharedcentreobjectivesprogramme: this.checker,
          watchedcentrevideo: this.checker2,
          playedtabletopgame: this.checker3,
          mocascore: (this.isMOCA) ? this.mocaVal : 0,
          amtscore: (this.isAMT) ? this.amtVal : 0,
          mmsescore: (this.isMMSE) ? this.mmseVal : 0,
          playedneeurofitgame: this.neeuro,
          eq5d5lform: this.checker5,
          isMocaForm: this.checker4,
          attentiongame: this.attentionObj.attentiongame,
          attentionlevel: this.attentionObj.attentionlevel,
          spatialgame: this.spatialObj.spatialgame,
          spatiallevel: this.spatialObj.spatiallevel,
          decisiongame: this.decisionObj.decisiongame,
          decisionlevel: this.decisionObj.decisionlevel,
          memorygame: this.memoryObj.memorygame,
          memorylevel: this.memoryObj.memorylevel,
          flexibilitygame: this.flexibilityObj.flexibilitygame,
          Flexibilitylevel: this.flexibilityObj.Flexibilitylevel,
          educationlevel: this.edulev,
          educationYear: this.unyearSelected ? '≤ 6 Years' : ' > 6 Years',
          trailMaking: this.vis1,
          uploadedImageTrailMaking: this.imageForVis1,
          copyCube: this.vis2,
          uploadedImageCopyCube: this.imageForVis2,
          drawClock: this.vis3,
          uploadedImageDrawClock: this.imageForVis3,
          nameLion: this.vis4,
          nameElephant: this.vis5,
          nameCamel: this.vis6,
          attentionGame: {
            repeatForward: this.vis7,
            repeatBackward: this.vis17,
            ableToTap: this.vis8,
            serial7Subtraction: this.vis9,
          },
          languageGame: {
            repeatFirstSentence: this.vis10,
            repeatSecondSentence: this.vis11,
            fluency: this.vis18,
          },
          abstractionGame: {
            similarityTrainBicycle: this.vis13,
            similarityWatchRuler: this.vis14,
          },
          delayedRecall: this.vis15,
          orientation: this.vis16,
          eqmobility: this.eq1,
          eqselfcare: this.eq2,
          equsualactivities: this.eq3,
          eqpaindiscomfort: this.eq4,
          eqanxietydepression: this.eq5,
          eqhealthscale: this.healthscale,
          commentsaboutclient: this.checking,
          serviceAgreement: this.pdfAgreement,
          staffSignature: this.staffSignatureImg,
          caregiverSignature: this.caregiverSignatureImg,
      };

      generatePDF(data, coverPageBodyHtml);
    },
    async cleanupStrayDrafts(){
      // Delete any draft rows for this client other than the one just finalised.
      // Non-fatal: a failure here must never block the submission flow.
      try {
        const clientId = this.$store.state.assessment_client_id;
        if (!clientId || !this.$store.state?.axios?.get) return;
        const params = new URLSearchParams({
          $filter: `crb5c_clientid eq ${clientId} and crb5c_isdraft eq true`,
          $select: 'crb5c_fowassessmentformid',
        });
        const { data } = await this.$store.state.axios.get(
          `/crb5c_fowassessmentforms?${params.toString()}`);
        for (const row of data.value ?? []) {
          if (row.crb5c_fowassessmentformid !== this.draftAssessmentId) {
            await this.$store.state.axios.delete(
              `/crb5c_fowassessmentforms(${row.crb5c_fowassessmentformid})`);
          }
        }
      } catch (e) {
        console.warn('Could not clean up stray draft rows', e);
      }
    },
    async loadDraftFromCloud(){
      const clientId = this.$store.state.assessment_client_id;
      if (!clientId) return;
      let assessmentData;
      try {
        const { data } = await axios.get(`/api/draft?client_id=${clientId}`);
        if (data.draftId) {
          this.draftAssessmentId = data.draftId;
          this.draftCreatedBy = data.createdBy ?? null;
          this.draftLastModifiedBy = data.lastModifiedBy ?? null;
          if (!data.draft) return; // draft row exists but no form data yet
          assessmentData = data.draft;
        } else {
          // No draft row exists yet — find-or-create on the server. If another
          // staff created one concurrently, the server returns that row instead.
          const clientName = this.$store.state.assessment_client_name ?? '';
          const staffName = this.$store.state.msalAccount?.[0]?.name ?? '';
          const { data: created } = await axios.post(
            `/api/draft?client_id=${clientId}&client_name=${encodeURIComponent(clientName)}&staff_name=${encodeURIComponent(staffName)}`
          );
          this.draftAssessmentId = created.draftId;
          this.draftCreatedBy = created.createdBy ?? null;
          this.draftLastModifiedBy = created.lastModifiedBy ?? null;
          if (!created.draft) return;
          assessmentData = created.draft;
        }
      } catch (e) {
        console.warn('Could not load/create draft from cloud, skipping prefill', e);
        return;
      }

      this.type = assessmentData.typeOfDementia;
      this.stageof = assessmentData.stageOfDementia;
      this.isAMT = assessmentData.isAMT;
      this.amtVal = assessmentData.amtVal;
      this.isMOCA = assessmentData.isMOCA;
      this.mocaVal = assessmentData.mocaVal;
      this.isMMSE = assessmentData.isMMSE;
      this.mmseVal = assessmentData.mmseVal;
      this.date = assessmentData.dateDoneInHospital;

      // general
      this.checker = assessmentData.generalCheckerOne;
      this.checker2 = assessmentData.generalCheckerTwo;
      this.checker3 = assessmentData.generalCheckerThree;
      // general

      // games & survey
      // neeurofit
      this.neeuro = assessmentData.isNeeuroFitBrainTrainingGame;
      this.atten = assessmentData.atten;
      this.attentionObj = assessmentData.attentionObj ?? {...this.attentionObj};
      this.spatial = assessmentData.spatial;
      this.spatialObj = assessmentData.spatialObj ?? {...this.spatialObj};
      this.decision = assessmentData.decision;
      this.decisionObj = assessmentData.decisionObj ?? {...this.decisionObj};
      this.memory = assessmentData.memory;
      this.memoryObj = assessmentData.memoryObj ?? {...this.memoryObj};
      this.flexibility = assessmentData.flexibility;
      this.flexibilityObj = assessmentData.flexibilityObj ?? {...this.flexibilityObj};
      // neeurofit
      // MOCA form
      this.checker4 = assessmentData.isMocaForm;
      this.language = assessmentData.language;
      this.edulev = assessmentData.edulev;
      this.unyearSelected = assessmentData.unyearSelected;
      this.ovyearSelected = assessmentData.ovyearSelected;
      this.vis1 = assessmentData.vis1 ?? this.vis1;
      this.vis2 = assessmentData.vis2 ?? this.vis2;
      this.vis3 = assessmentData.vis3 ?? this.vis3;
      this.vis4 = assessmentData.vis4 ?? this.vis4;
      this.vis5 = assessmentData.vis5 ?? this.vis5;
      this.vis6 = assessmentData.vis6 ?? this.vis6;
      this.vis7 = assessmentData.vis7 ?? this.vis7;
      this.vis8 = assessmentData.vis8 ?? this.vis8;
      this.vis9 = assessmentData.vis9 ?? this.vis9;
      this.vis10 = assessmentData.vis10 ?? this.vis10;
      this.vis11 = assessmentData.vis11 ?? this.vis11;
      this.vis18 = assessmentData.vis18 ?? this.vis18;
      this.vis13 = assessmentData.vis13 ?? this.vis13;
      this.vis14 = assessmentData.vis14 ?? this.vis14;
      this.vis15 = assessmentData.vis15 ?? this.vis15;
      this.vis16 = assessmentData.vis16 ?? this.vis16;
      this.vis17 = assessmentData.vis17 ?? this.vis17;
      // MOCA form
      // EQ5D5L form
      this.checker5 = assessmentData.isEQ5D5Lform;
      this.eq1 = assessmentData.eq1 ?? this.eq1;
      this.eq2 = assessmentData.eq2 ?? this.eq2;
      this.eq3 = assessmentData.eq3 ?? this.eq3;
      this.eq4 = assessmentData.eq4 ?? this.eq4;
      this.eq5 = assessmentData.eq5 ?? this.eq5;
      this.healthscale = assessmentData.healthscale;
      // EQ5D5L form
      // games & survey

      this.checking = assessmentData.checking;

      //-- fee & payment
      //-- DSG
      this.subsidy = assessmentData.subsidy;
      this.subs1 = assessmentData.subs1 ?? this.subs1;
      this.subs1val = assessmentData.subs1val ?? this.subs1val;
      this.dsgsubsidy = assessmentData.dsgsubsidy ?? this.dsgsubsidy;
      //-- DSG
      //-- Toteboard
      this.subs2 = assessmentData.subs2 ?? this.subs2;
      this.subsidyAmount = assessmentData.subsidyAmount ?? this.subsidyAmount;
      //-- Toteboard
      this.transport = assessmentData.transport ?? this.transport;
      //-- fee & payment

      // TODO: set data here
      this.recommended_session_pick = assessmentData.recommended_session_pick ?? this.recommended_session_pick;
      this.applicableFeeTotal = assessmentData.applicableFeeTotal ?? this.applicableFeeTotal;
      this.firSession = assessmentData.firSession ?? this.firSession;
      this.secSession = assessmentData.secSession ?? this.secSession;
      this.dsgOffDay = assessmentData.dsgOffDay ?? this.dsgOffDay;
      this.adHocFeeTotal = assessmentData.adHocFeeTotal ?? this.adHocFeeTotal;

      //cip save
      this.transportInclude = assessmentData.transportInclude ?? this.transportInclude;
      this.cipAdditionalTransport = assessmentData.cipAdditionalTransport ?? this.cipAdditionalTransport;
      
      // Override flags
      // this.manualCipEligibility = assessmentData.manualCipEligibility ?? this.manualCipEligibility;
      // this.programmeOverride = assessmentData.programmeOverride ?? this.programmeOverride;

      // //---- Service Agreement Form
      // this.clientReationship = assessmentData.clientReationship ?? this.clientReationship;
      // this.caregiverClientName = assessmentData.caregiverClientName ?? this.caregiverClientName;
      // this.caregiverClientIc = assessmentData.caregiverClientIc ?? this.caregiverClientIc;
      // this.serviceAgreementContact = assessmentData.serviceAgreementContact ?? this.serviceAgreementContact;
      // this.serviceAgreementDate = assessmentData.serviceAgreementDate ?? this.serviceAgreementDate;
      // //---- Service Agreement Form

    },
    async clearLocalStorage(){
      const confirmed = confirm('Are you sure you want to clear the form? All entered data for this client will be permanently deleted.');
      if (!confirmed) return;
      if (this.draftAssessmentId) {
        try {
          await axios.delete(`/api/draft?draft_id=${this.draftAssessmentId}`);
        } catch (e) {
          console.warn('Could not delete cloud draft', e);
        }
      }
      localStorage.removeItem("invoice");
      location.reload();
    },
    // async generateInvoice(){
    //   const invoiceJson = {
    //     sessions: this.selectedProgrammeSummary.map(item => ({
    //       id: item.crb5c_fow_session_scheduleid,
    //       name: item.crb5c_session_id,
    //       time: item.crb5c_time,
    //       day: item.crb5c_day,
    //       type: item.crb5c_sessiontype,
    //       hrs: item.crb5c_time_hrs
    //     }))
    //   };
    //   return  JSON.stringify(sessionJson)
    //   },
    getRecSessions(val){
      const sessionJson = {
        sessions: val.map(item => ({
          id: item.crb5c_fow_session_scheduleid,
          name: item.crb5c_session_id,
          time: item.crb5c_time,
          day: item.crb5c_day,
          type: item.crb5c_sessiontype,
          hrs: item.crb5c_time_hrs
        }))
      };
      return  JSON.stringify(sessionJson)
    },
    async generateEmail(){
      if(this.previousAssessment){
        return;
      }
      const response = await axios.post('/api/sendEmail', {
          cr_email: this.serviceAgreementEmail,
          cr_name: this.serviceAgreementName,
          staff_email: this.$store.state.msalAccount[0].username,
          staff_name: this.$store.state.msalAccount[0].name,
        });
      console.log('Email Generated:',response.data.message);
      
    },
    getApplicable(val){
      const applcableJson = {
        applicable: val.map(item => ({
          id: item.crb5c_fowprogrammeid,
          name: item.crb5c_programmename,
          cost: item.crb5c_price,
          type: item.crb5c_type
        }))
      };
      return  JSON.stringify(applcableJson)
    },
    async getFeeInfo(val, isCip = false){
      if (isCip) {
        // console.log('sessions based on groups',this.groupCipSessionsByMonth(this.cipSessionDates));
        const groupedSessions = this.groupCipSessionsByMonth(this.cipSessionDates.sessions);
        const monthSessionList = Object.keys(groupedSessions)
          .sort((a, b) => dayjs(a, 'MMMM YYYY').toDate() - dayjs(b, 'MMMM YYYY').toDate())
          .map(month => {
            const sessionCount = groupedSessions[month].length;
            const dates = groupedSessions[month]
              .map(dateStr => dayjs(dateStr, 'ddd, DD MMM YYYY').format('DD/MM'))
              .join(', ');
            return `<li><strong>${month}</strong> (${dates}) : ${sessionCount} session${sessionCount > 1 ? 's' : ''}</li>`;
          })
          .join('');
        const admissionDate = dayjs(this.cipAdm);
        const isStartDateThisMonth = admissionDate.isValid() &&
          admissionDate.month() === dayjs().month() &&
          admissionDate.year() === dayjs().year();
        // Advance = sessions NOT in the current invoice month (future sessions the client pre-pays)
        // If start is this month: advance = total - sessions this month (e.g. 14 - 3 = 11)
        // If start is next month or later: advance = all sessions (client pays everything upfront now)
        const advSessionCount = isStartDateThisMonth
          ? this.cipPhase - this.sessionsThisMonth
          : this.cipPhase;
        const feeJson = {
          fee: [val].map(item => ({
            name: `
              <p>${item.description} ${this.cipDescription}</p>
              <ul>
                <li>Program fee per session: $${this.roundUp(item.Oop).toFixed(2)}</li>
                ${this.transportInclude ? `<li>Transport fee per session (within 5km): $${this.roundUp(item.transport).toFixed(2)}</li>` : ''}
                ${this.cipAdditionalTransport ? `<li>Additional Transport Fee (beyond 5km): $${this.cipAdditionalTransport.toFixed(2)}</li>` : ''}
                ${monthSessionList}
              </ul>`,
            cost: this.transportInclude ? this.roundUp( item.Oop + item.transport) + this.cipAdditionalTransport : this.roundUp(item.Oop),
            gst: true,
            date: dayjs(),
            qty: this.cipPhase,
            adv: advSessionCount,
            client_id: this.$store.state.assessment_client_id,
            fee_type: 0,
          }))
        };
      return  JSON.stringify(feeJson)

      }else if(val.type === 'fow' && !isCip){
        const feeJson = {
        fee: [{
          name: val.description,
          cost: val.cost,
          gst: true,
          date: dayjs(),
          qty: val.qty,
          client_id: this.$store.state.assessment_client_id,
          fee_type: 0,
        }]
      };
      return  JSON.stringify(feeJson)

      }else
      {
      const feeJson = {
        fee: val.map(item => ({
          name: item.name,
          cost: item.cost,
          gst: item.noGst ? false : true,
          date: dayjs(),
          client_id: this.$store.state.assessment_client_id,
          fee_type: item.type ? item.type : 0,
        }))
      };
      return  JSON.stringify(feeJson)
    }
    },
    async skipPayment(){
      let result = confirm('You are about to skip payment and submit assessment!')
      if (!result) {
        return;
      }
      this.submitassessment();
    },
    async paymentSubmission(){
      if (!this.notJoining && (!this.serviceAgreementEmail || !this.serviceAgreementName) && !this.previousAssessment) {
        alert('Fill up the caregiver name and email!')
        return;
      }

      if (!this.notJoining && this.cipEligibility && !this.cipAdm) {
        alert('Fill up CIP Admission date!')
        return;
      }

      this.processing = true;

      let cipResponse = null;
      let programmeResponse = null;
      let fowResponse = null;


      const existing_inv = JSON.parse(localStorage.getItem("invoice")|| "[]");
      if(existing_inv?.length){
        // console.log('Invoices generated:',existing_inv)
        this.invoices = existing_inv;
        this.modeofpayment = "paynow"
        this.processing = false;
        this.$bvModal.show("paymentConfirmation");
        return;
      }

      // Handle Phase 3 completion - no invoices needed
      if (this.phase3CompletionChoice === 'complete') {
        console.log('Phase 3 completed - no invoice generation');
        this.invoices = [];
        this.modeofpayment = "paynow"
        this.processing = false;
        this.$bvModal.show("paymentConfirmation");
        return;
      }
      
      
      // Handle the case when client is not joining
      if (this.notJoining) {
        // Only create invoice for additional fees if they exist
        if (this.selectedProgrammeSummary?.length) {
          const programmeData = JSON.parse(await this.getFeeInfo(this.selectedProgrammeSummary));
          console.log('Generating one-time invoice')
          programmeResponse = await createInvoice(programmeData.fee, "FOW");
        }
        this.invoices = [...(programmeResponse || [])];
      } else if (this.cipEstimatedFee) {
        // CIP path
        const cipData = JSON.parse(await this.getFeeInfo(this.selectedCipTemplate, true));
        console.log('Generating CIP invoices')
        cipResponse = await createInvoice(cipData.fee, "CIP");
        // console.log("CIP invoice created:", cipResponse);

        if (this.selectedProgrammeSummary?.length) {
          const programmeData = JSON.parse(await this.getFeeInfo(this.selectedProgrammeSummary));
          programmeResponse = await createInvoice(programmeData.fee, "FOW");
          // console.log("Programme invoice created:", programmeResponse);
        }
        this.invoices = [...(cipResponse || []), ...(programmeResponse || [])];
        
      } else {
        if (this.totalOfApplicable > 0 && !this.isAdmissionNextMonth) {
          this.selectedFowTemplate = {
            type : 'fow',
            cost: this.totalOfApplicable,
            description: this.fowDescription,
            qty : this.fowSessionDates.sessions.length || 0,
          }
          const fowData = JSON.parse(await this.getFeeInfo(this.selectedFowTemplate, ));
          fowResponse = await createInvoice(fowData.fee, "FOW");
        }
        
        const programmeData = JSON.parse(await this.getFeeInfo(this.selectedProgrammeSummary));
        console.log('Generating FOW invoices')
        programmeResponse = await createInvoice(programmeData.fee, "FOW");
        // console.log("FOW invoice created:", programmeResponse);
        
        this.invoices = [...(fowResponse || []), ...(programmeResponse || [])];
      }
      
      this.modeofpayment = "paynow"
      this.processing = false;

      // const inv = (Array.isArray(this.invoices) ? this.invoices : [this.invoices])
      //   .map(inv => inv?.crb5c_fowinvoiceid)
      //   .filter(Boolean);

      console.log('Invoices generated:',this.invoices)
      localStorage.setItem("invoice", JSON.stringify(this.invoices));
      console.log('pay amount',this.toPayAmount)
      this.invoiceDepositRecordCreated = false;
      this.depositRecordCreated = false;
      if (!this.invoices.length && this.refundableDeposit > 0) {
        this.depositOnlyAmount = this.refundableDeposit;
        this.showDepositQRSection = true;
      } else {
        this.showDepositQRSection = false;
      }
      this.$bvModal.show("paymentConfirmation");

      // let invoiceData = null;
      // if (this.cipEstimatedFee) {
      //     const cipData = JSON.parse(await this.getFeeInfo(this.selectedCipTemplate, true));
      //     cipResponse = await createInvoice(cipData.fee, "CIP");
      //     console.log("CIP invoice created:", cipResponse);
      //     if (this.selectedProgrammeSummary?.length) {
      //     const programmeData = JSON.parse(await this.getFeeInfo(this.selectedProgrammeSummary));
      //     programmeResponse = await createInvoice(programmeData.fee, "FOW");
      //     console.log("Programme invoice created:", programmeResponse);
      //   }
      // }else{
      //     let data = await this.getFeeInfo(this.selectedProgrammeSummary);
      //     invoiceData = JSON.parse(data)
      // }
      // // let data = await this.getFeeInfo(this.selectedProgrammeSummary);
      // // let invoiceData = JSON.parse(data)
      // console.log('invoice data',invoiceData)
      // const inv = localStorage.getItem("invoice");
      // if(!this.invoices.length && !inv){ 
      // if (this.cipEstimatedFee) {
      //   let response = await createInvoice(invoiceData.fee, "CIP")
      //   this.invoices = response;
      //   console.log('CIP Invoice created',this.invoices);
      // }else{
      //   let response = await createInvoice(invoiceData.fee)
      //   this.invoices = response;
      //   console.log('FOW Invoice created',this.invoices);
      // }
      // let response = await createInvoice(invoiceData.fee)
      // this.invoices = response;
      // console.log('Invoice created',this.invoices);
      // }else{
      //   this.invoices = JSON.parse(inv);
      // }
      // this.totalToCollect = this.viewamtcollect.toFixed(2);
    },
    sessionTypeCheck(val){
      switch (val) {
        case 0: return "Group HQ (Centre) Based";
        case 1: return "One-to-one (Centre) Based";
        case 2: return "Home Based";
        case 3: return "Virtual/Online/Zoom";
        case 4: return "Group HQ (Centre) Based (M-S)";
        default: return "null";
      }
    },
    sessionDurationCheck(val){
      let hours = Math.floor(val / 60);
      let minutes = val % 60;
      if (hours > 0) {
        return hours + ' Hour(s) ' + (minutes > 0 ? minutes + ' Minute(s)' : '');
      } else {
        return minutes + ' Minute(s)';
      }
    },
    editTime(){
      this.dateofassessment = dayjs(this.edit_time).format("YYYY-MM-DD");
      this.$store.commit('assessment_date',this.dateofassessment);
      this.$bvModal.hide('modal-time');
    },
    pdfToBase64(pdfBlob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(pdfBlob);
        reader.onloadend = () => {
          resolve(reader.result.split(',')[1]);
        };

        reader.onerror = error => reject(error);
      });
    },
      closeModal(modal_name){
        this.$bvModal.hide(modal_name);
      },
      closeTab(){
        window.close();
        // If window.close() was blocked (tab opened by the user, not a script),
        // fall back to replacing the page with a completion message.
        setTimeout(() => {
          document.open();
          document.write(`
            <html>
              <head><title>Assessment Complete</title>
                <style>
                  body { display:flex; flex-direction:column; align-items:center; justify-content:center;
                         height:100vh; margin:0; font-family:sans-serif; background:#f8f9fa; color:#333; }
                  h2 { color:#50276B; }
                  p { color:#666; }
                </style>
              </head>
              <body>
                <h2>&#10003; Assessment Submitted</h2>
                <p>You may now close this tab.</p>
              </body>
            </html>
          `);
          document.close();
        }, 300);
      },
      async associateTable(data){
        let isLocal = location.host.includes("localhost");
        let url;
        let pl;

        if(isLocal){
           url = `https://orga7b5e99e.crm5.dynamics.com/api/data/v9.2/crb5c_fow_customers(${this.$store.state.assessment_client_id})/crb5c_FOW_Customer_session_schedule_crb5c/$ref`;
           pl ={
            "@odata.id": `https://orga7b5e99e.crm5.dynamics.com/api/data/v9.2/crb5c_fow_session_schedules(${data.crb5c_fow_session_scheduleid})`,
          }
        }
        else{
           url = `https://dsg-fow.crm5.dynamics.com/api/data/v9.2/crb5c_fow_customers(${this.$store.state.assessment_client_id})/crb5c_FOW_Customer_session_schedule_crb5c/$ref`;
           pl ={
            "@odata.id": `https://dsg-fow.crm5.dynamics.com/api/data/v9.2/crb5c_fow_session_schedules(${data.crb5c_fow_session_scheduleid})`,
          }

        }

        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.$store.state.accessToken}` 
        };

        await axios.post(url, pl, { headers })

        // console.log('Associating assessment result',x)

        // let params = new URLSearchParams({
        //     $select: "crb5c_time_hrs,crb5c_time_mins,crb5c_day,crb5c_duration,crb5c_session_id,crb5c_allowadhoccheckin,crb5c_fow_session_scheduleid,crb5c_sessionreporttype,crb5c_sessiontype,crb5c_gender,crb5c_language,crb5c_transportincluded,crb5c_isactive",
        //     $expand:"ownerid,crb5c_FOW_Customer_session_schedule_crb5c($select=crb5c_fow_customerid,crb5c_defaultroom;$top=1000),crb5c_parent_activity_bridge($select=crb5c_name,crb5c_activityid,crb5c_activitytype)",
        //     $filter:`crb5c_fow_session_scheduleid eq ${data.crb5c_fow_session_scheduleid}`,
        //     $top:1000
        // })
        // let {data:{value:schedules}} = await this.$store.state.axios.get(`/crb5c_fow_session_schedules?${params}`);
        // console.log('entities',schedules)
    },
      async AutoMatchingSession(){

        this.loadingAutomated = true;
        this.$bvModal.show("automatedMatchingModal");
        
        let payloadAssessment = {
            crb5c_admissiondate: this.adm
        }

        const { data } = await this.$store.state.axios.patch(`/crb5c_fow_customers(${this.$store.state.assessment_client_id})`,payloadAssessment);
        console.log('Auto Matching Session for:',data.crb5c_no)

        if (this.sessions.length) {

          for (let session of this.sessions){
              // console.log('Creating new Session')
              // console.log('time value',session.time )
              let [hours, minutes] = '';
              hours = session.time.split(':')[0];
              minutes = session.time.split(':')[1];
              
              let payloadSession  = {
              crb5c_session_id: session.name,
              crb5c_sessiontype: session.sessionType,
              crb5c_sessionreporttype: session.dementiaLevel,
              crb5c_time_hrs: hours,
              crb5c_time_mins: minutes,
              crb5c_duration: session.duration,
              crb5c_day: parseInt(session.day),
              crb5c_isactive: true,
              }

              const { data } = await this.$store.state.axios.post(`/crb5c_fow_session_schedules`,payloadSession);
              // console.log('afterpost',data)

              await this.associateTable(data)
          }
        }
        if(this.recommended_session_pick.length){
          for (let rec of this.recommended_session_pick){
            await this.associateTable(rec)
            }
          }
          
          await new Promise(r => setTimeout(r, 5000));
          this.loadingAutomated = false;
          
                            
      },
      navigateToServiceForm(){
        if (this.cipEligibility) {
          this.termsAndConditionUrl = '/terms-condition/cip-terms.pdf'
        }
        if (!this.adm) {
          alert('Please fill up the admission date before proceeding!') 
          return
        }
        // this.getFeeInfo(this.selectedProgrammeSummary);
        // if (!this.adm) {
        //   alert('Please fill up the admission date before proceeding!') 
        //   return
        // }

        // this.AutoMatchingSession();
        // console.log("applicableFeeTotal", this.applicableFeeTotal)
        this.viewServiceForm = true;
      },
      clearadhoc(){
        this.adHocItems = {
          remark : '',
          total: null,
          isRecurring: false,
          isIncludeInFee: false,
        }
      },
      deleteAdHoc(val){
        this.adHocFeeTotal = this.adHocFeeTotal.filter((_, index) => index !== val)
      },
      async adHocFee(){
        this.adHocFeeTotal.push(this.adHocItems);
        this.$bvModal.hide("addAdHocModal");
        this.clearadhoc()
      },
      openDepositQR() {
        if (this.showDepositQRSection) {
          this.showDepositQRSection = false;
          return;
        }
        this.depositOnlyAmount = this.refundableDeposit || 0;
        this.depositRecordCreated = false;
        this.showDepositQRSection = true;
      },
      async _postDepositRecord(onSuccess) {
        // Check for an existing unpaid deposit with the same ref before creating
        try {
          const ref = this.depositOnlyRef;
          const params = new URLSearchParams({
            $filter: `crb5c_ref eq '${ref}'`,
            $select: 'crb5c_ref,crb5c_dateofpayment',
          });
          const { data } = await this.$store.state.axios.get(`/crb5c_fowdeposits?${params.toString()}`);
          const existing = data?.value || [];
          const unpaid = existing.find(r => !r.crb5c_dateofpayment);
          if (unpaid) {
            this.$bvToast.toast(
              `Client already has an existing unpaid deposit record (${ref}). No new record created.`,
              { title: 'Duplicate Deposit', variant: 'warning', autoHideDelay: 12000 }
            );
            onSuccess(); // still mark UI as "handled" so button disables
            return;
          }
          // All existing records are paid (or none exist) — safe to create
          const depositAmt = this.depositOnlyAmount > 0 ? this.depositOnlyAmount : this.refundableDeposit;
          const payload = {
            crb5c_ref: ref,
            crb5c_amount: Math.round(depositAmt * 100),
            'crb5c_Client@odata.bind': `/crb5c_fow_customers(${this.$store.state.assessment_client_id})`,
          };
          await this.$store.state.axios.post('/crb5c_fowdeposits', payload);
          onSuccess();
        } catch (err) {
          console.error('Failed to save deposit record', err);
          this.$bvToast.toast('Failed to save deposit record. Please try again.', {
            title: 'Error', variant: 'danger', autoHideDelay: 5000,
          });
        }
      },
      async saveDepositRecord() {
        await this._postDepositRecord(() => {
          this.depositRecordCreated = true;
          this.$bvToast.toast('Deposit record saved successfully.', {
            title: 'Success', variant: 'success', autoHideDelay: 10000,
          });
        });
      },
      async saveInvoiceDepositRecord() {
        await this._postDepositRecord(() => {
          this.invoiceDepositRecordCreated = true;
          this.$bvToast.toast('Deposit record saved. Client can pay later via the mobile app.', {
            title: 'Deposit Saved', variant: 'success', autoHideDelay: 10000,
          });
        });
      },
      async addNewPickSession(){
        this.recommended_session_pick.push(...this.pick_sessions);
        await this.filterFees();
        this.$bvModal.hide("pick-session");
        this.pick_sessions = [];
      },
      createBase64Image(val){
         this.filesToUpload = [];
        const reader = new FileReader();
        reader.onload = (event) => {
            this.filesToUpload.push(event.target.result) 
        }
        reader.readAsDataURL(val);
    },
      uploadFile(event) {
        this.assessment_files = event.target.files[0];
      },
      async confirmUpload(){
        // console.log('assessment_files',this.assessment_files)
        // await this.createBase64Image(this.assessment_files);
      //   console.log('files',this.filesToUpload)
      //   console.log('object',object)
        
      //   const payload = {
      //     crb5c_name: 'Document test',
      //     crb5c_image: object,
      //  };

      //   const { data } = this.$store.state.axios.post(
      //     `/crb5c_fowdocuments`,payload);
      //   console.log(data)
        
        let image_id = 'bc356540-ae74-ee11-8179-000d3a85d02d'

        let paramObj = {
          $filter: `crb5c_fowdocumentid eq '${image_id}'`,
        };
        let params = new URLSearchParams(paramObj);
        let { data: data2 } = await this.$store.state.axios.get(
          `crb5c_fowdocuments/?${params.toString()}`
        );
        let val = data2.value[0];
        console.log('Uploaded',val.crb5c_image);
      },
      addfile(){
        this.$bvModal.show("confrimationModal");
      },
      async removePickedSession(id){
        if(this.recommended_session_pick.length < 2 && this.cipEligibility && this.cipAdm){
          alert('Leave at-least one session selected or clear the admission date.')
          return;
        }

        if(this.recommended_session_pick.length < 2 && !this.cipEligibility && this.adm){
          alert('Leave at-least one session selected or clear the admission date.')
          return;
        }
        // if (this.applicableFeeTotal.length) {
        //   alert('Un-check any "Applicable Sessions" before removing session')
        //   return;
        // }
        this.recommended_session_pick = this.recommended_session_pick.filter((_, index) => index !== id)
        await this.filterFees();
      },
      async removeSession(id){
        this.gotIndividualFee = false
        this.gotGroupFee = false
        this.checkCenter=false
        this.checkResidence=false
        this.checkZoom=false
        this.sessions = this.sessions.filter((_, index) => index !== id);
        await this.filterFees();

      },
      // getImage(){
      //   this.signatureImg = this.$refs.handWrite.toDataURL();
      //   this.submitassessment();
      // },
      firstSesDay(date){
        return date ? dayjs(this.firSession).format('dddd') : 'None';
      },
      secondSesDay(date){
        return date ? dayjs(this.secSession).format('dddd') : 'None';
      },
      checkdsgsubsidy(val){
        if((val) && this.subs1 && this.subs1val && this.dsgsubsidy == '$'){
            return this.subs1val;
          }
        if ((val) && this.subs1 && this.subs1val && this.dsgsubsidy == '%') {
            return (val) * this.subs1val/100;
          }
        else{
          return 0;
        }
      },
      async getSGPublicHoliday(){
        // Check cache first - cache for 24 hours
        const CACHE_KEY = 'sg_public_holidays';
        const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
        
        try {
          const cached = localStorage.getItem(CACHE_KEY);
          if (cached) {
            const { data, timestamp } = JSON.parse(cached);
            const now = Date.now();
            
            // Return cached data if still valid
            if (now - timestamp < CACHE_DURATION) {
              console.log('Using cached public holidays data');
              return data;
            }
          }
        } catch (error) {
          console.warn('Error reading cache:', error);
        }

        // Fetch fresh data with retry logic
        const LINK = 'https://data.gov.sg/api/action/datastore_search?resource_id=d_149b61ad0a22f61c09dc80f2df5bbec8';
        const MAX_RETRIES = 3;
        const INITIAL_DELAY = 1000; // 1 second
        
        for (let attempt = 0; attempt <= MAX_RETRIES; attempt++) {
          try {
            const { data } = await axios.get(LINK, { timeout: 8000 });
            const records = data.result.records;  
            console.log(`Fetched public holidays from data.gov.sg`);
            
            // Cache the successful response
            try {
              localStorage.setItem(CACHE_KEY, JSON.stringify({
                data: records,
                timestamp: Date.now()
              }));
            } catch (error) {
              console.warn('Error caching data:', error);
            }
            
            return records;
          } catch (error) {
            // Handle 429 (rate limit) errors
            if (error.response?.status === 429) {
              if (attempt < MAX_RETRIES) {
                // Calculate exponential backoff delay
                const delay = INITIAL_DELAY * Math.pow(2, attempt);
                console.warn(`Rate limit hit. Retrying in ${delay}ms... (Attempt ${attempt + 1}/${MAX_RETRIES})`);
                
                // Wait before retrying
                await new Promise(resolve => setTimeout(resolve, delay));
                continue;
              } else {
                console.error('Max retries reached. Unable to fetch public holidays.');
                throw new Error('Unable to load public holidays - API rate limit exceeded. Please try again later.');
              }
            }
            
            // For other errors, throw immediately
            console.error('Error fetching public holidays:', error);
            throw new Error('Unable to load public holidays from government API. Please check your internet connection and try again.');
          }
        }
        
        throw new Error('Unable to load public holidays. Please try again later.');
      },
      getPublicHolidayCurrentMonth(listPublicHoliday){
        return listPublicHoliday.filter(item => {
          const itemMonth = this.formatDatePublicHoliday(item.date).split('/')[1];
          const currentMonth = (dayjs().month() + 1) + '';
  
          return itemMonth === currentMonth;
        });
  
      },
      formatDatePublicHoliday(date){
        const DATE_FORMAT = 'D/M/YYYY';
        return dayjs(date).format(DATE_FORMAT);
  
      },
      addDSGOffday(){
        // TODO: add date difference, if negative, do guard clause or give error alert
        if(!this.dsgOffDay.date){
          return;
        }
  
        this.dsgOffDay.listDay.push({
          id: Math.floor(Math.random() * Date.now()) + '',
          date: this.dsgOffDay.date,
        });
  
        this.dsgOffDay.date = null;
        this.CIPtotal();
      },
      removeDSGOffDay(id){
        this.dsgOffDay.listDay = this.dsgOffDay.listDay.filter(item => item.id !== id);
        this.CIPtotal();
  
      },
      formatDSFOffDayContent(dateParent){
        const getDayNameBasedOnDate = (dateChild) => {
          const listNameDay = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
          return listNameDay.at(dayjs(dateChild).day());
        }
        return `${this.formatDatePublicHoliday(dateParent)} - ${getDayNameBasedOnDate(dateParent)}`;
      },
      async CIPtotal(){
        let day1count = 0;
        let day2count = 0;

        if (this.firSession) {
            const day1OfWeekToCount = dayjs(this.firSession).day();
            const day2OfWeekToCount = dayjs(this.secSession).day();
            const endoftheMonth = dayjs().endOf('month');

            for (let i = dayjs(this.firSession); i.isSameOrBefore(endoftheMonth, 'day') ; i = i.add(1, 'day')) {
              if (i.day() === day1OfWeekToCount) {
                day1count++;
              }
            }

            for (let i = dayjs(this.secSession); i.isSameOrBefore(endoftheMonth, 'day') ; i = i.add(1, 'day')) {
              if (i.day() === day2OfWeekToCount) {
                day2count++;
              }
            }

            console.log(`There are ${day1count} ${dayjs(this.firSession).format('dddd')}s and ${day2count} ${dayjs(this.secSession).format('dddd')}s`);
          }

          // console.log('public holiday',this.listPublicHolidayCurrentMonth)
          // console.log('dsg off', this.dsgOffDay)

          let offDayList = [];
          if (this.listPublicHolidayCurrentMonth || this.dsgOffDay.listDay.length) {

            for (let index = 0; index < this.dsgOffDay.listDay.length; index++) {
              offDayList.push(dayjs(this.dsgOffDay.listDay[index].date).day())
            }
            // console.log('offDayList',offDayList)
          }

          if (offDayList.length) {
            for (let i = 0; i < offDayList.length; i++) {
            // console.log('offDayList[i]',offDayList[i])
            // console.log('first',dayjs(this.firSession).day())
            // console.log('second',dayjs(this.secSession).day())
            if (offDayList[i] === dayjs(this.firSession).day()) {
              day1count--;
            }
            else if (offDayList[i] === dayjs(this.secSession).day()) {
              day2count--;
            }
          }
          }
          
          const totalDay = day1count + (day2count ? day2count : 0);
          this.totalforCIP = this.fees4val * (totalDay);
          this.CIPdays = totalDay;
          // console.log('day 1, day 2',day1count,day1count)


        // if (this.firSession)  {
        //   let day = 0;   
        //   let day2 = 0;
  
        //   const publicHolidayCount = {
        //     copylistPublicHolidayCurrentMonthOne: this.listPublicHolidayCurrentMonth,
        //     copylistPublicHolidayCurrentMonthTwo: this.listPublicHolidayCurrentMonth,
        //     day1: 0,
        //     day2: 0,
        //   };
  
        //   const dsgOffDayCount = {
        //     copylistDSGOffday: this.dsgOffDay.listDay.map(({date}) => ({date})),
        //     day: 0,
        //   }
  
        //   const setAgainCopylistDSGOffday = () => {
        //     dsgOffDayCount.copylistDSGOffday = this.dsgOffDay.listDay.map(({date}) => ({date}));
        //   }
  
        //   const calculatePublicHoliday = (day, whatDayIndex) => {
        //     if(publicHolidayCount.copylistPublicHolidayCurrentMonthOne && publicHolidayCount.copylistPublicHolidayCurrentMonthTwo){
        //       const listDate = day === '1' ? publicHolidayCount.copylistPublicHolidayCurrentMonthOne : publicHolidayCount.copylistPublicHolidayCurrentMonthTwo;
        //       const dayIncluded = listDate.filter(item => dayjs(item.date).day() === whatDayIndex);
        //       if(dayIncluded.length !== 0){
        //         if(day === '1'){
        //           publicHolidayCount.day1++
        //         }
        //         if(day === '2'){
        //           publicHolidayCount.day2++
        //         }
        //       }
        //       if(day === '1'){
        //         publicHolidayCount.copylistPublicHolidayCurrentMonthOne = listDate.filter(item => item === dayIncluded);
        //       }
        //       if(day === '2'){
        //         publicHolidayCount.copylistPublicHolidayCurrentMonthTwo = listDate.filter(item => item === dayIncluded);
        //       }
        //     }
        //   }
  
        //   const calculateDSGOffday = (whatDayIndex) => {
        //     if(dsgOffDayCount.copylistDSGOffday.length){
        //       if(dsgOffDayCount.copylistDSGOffday.every(item => item.date !== null)){
        //         const listDate = dsgOffDayCount.copylistDSGOffday;
        //         const dayIncluded = listDate.filter(item => dayjs(item.date).day() === whatDayIndex); 
        //         if(dayIncluded.length !== 0){
        //           dsgOffDayCount.day++
        //         }
        //         dsgOffDayCount.copylistDSGOffday = listDate.filter(item => dayjs(item.date).day() !== whatDayIndex);
        //       }
        //     }
        //   }
  
        //   let whatday = dayjs(this.firSession).day();
        //   let whatday2 = dayjs(this.secSession).day();
        //   const startDate = new Date(dayjs(this.firSession).format('MM-DD-YYYY'));
        //   const endDate = new Date(dayjs(this.firSession).endOf('month').format('MM-DD-YYYY'));
        //   let loop = new Date(startDate);
  
        //   while (loop <= endDate) {
        //     if (loop.getDay() === whatday) {
        //       day++;
        //     }
  
        //     calculatePublicHoliday('1', whatday);
        //     calculateDSGOffday(whatday);
  
        //     let newDate = loop.setDate(loop.getDate() + 1);
        //     loop = new Date(newDate);
        //   }
  
        //   setAgainCopylistDSGOffday();
  
        //   const startDate2 = new Date(dayjs(this.secSession).format('MM-DD-YYYY'));
        //   const endDate2 = new Date(dayjs(this.secSession).endOf('month').format('MM-DD-YYYY'))
        //   let loop2 = new Date(startDate2);
  
        //   console.log('loop2:', loop2, 'endDate2:', endDate2)
        //   while (loop2 <= endDate2) {
        //     console.log('inside loop2....');
        //     if (loop2.getDay() === whatday2) {
        //       day2++;
        //     }
  
        //     calculatePublicHoliday('2', whatday2);
        //     calculateDSGOffday(whatday2);
  
        //     let newDate = loop2.setDate(loop2.getDate() + 1);
        //     loop2 = new Date(newDate);
        //   }
  
        //   const totalDay = day + day2 - (publicHolidayCount.day1 || 0) - (publicHolidayCount.day2 || 0) - (dsgOffDayCount.day || 0);
        //   this.totalforCIP = this.fees4val * (totalDay);
        //   this.CIPdays = totalDay;
        // }
      
      },
      filterFees() {
        this.filterTypeValues = [];
        if (this.sessions.length) {
            for (let i = 0 ; i < this.sessions.length; i++){
              if (this.sessions[i].type == 'Group' && this.sessions[i].location=="Center" && this.subs2){
                this.filterTypeValues.push(4)
                return;
              } 
              if (this.sessions[i].type == 'Group' && this.sessions[i].location=="Center"){
                this.filterTypeValues.push(0)
              } 
              else if (this.sessions[i].type == 'Individual' && this.sessions[i].location=="Center"){
                this.filterTypeValues.push(1)
              } 
              else if (this.sessions[i].type == 'Individual' && this.sessions[i].location=="Residence"){
                this.filterTypeValues.push(2)
              } 
              else if (this.sessions[i].type == 'Individual' && this.sessions[i].location=="Video-Call"){
                this.filterTypeValues.push(3)
              } 
            }
        }

        if(this.recommended_session_pick.length){
          for (let i = 0 ; i < this.recommended_session_pick.length; i++){
              // if (this.recommended_session_pick[i].crb5c_sessiontype === 0 && this.subs2){
              //   this.filterTypeValues.push(4)
              //   return;
              // } 
              if (this.recommended_session_pick[i].crb5c_sessiontype === 0){
                this.filterTypeValues.push(0)
              } 
              else if (this.recommended_session_pick[i].crb5c_sessiontype === 1){
                this.filterTypeValues.push(1)
              } 
              else if (this.recommended_session_pick[i].crb5c_sessiontype === 2){
                this.filterTypeValues.push(2)
              } 
              else if (this.recommended_session_pick[i].crb5c_sessiontype === 3){
                this.filterTypeValues.push(3)
              } 
              else if (this.recommended_session_pick[i].crb5c_sessiontype === 4){
                this.filterTypeValues.push(4)
              } 
            }
        }
        
        this.filterTypeValues = [...new Set(this.filterTypeValues)];
      },
      revert() {
        this.subsidy = null;
        this.subs1 = false;
        this.subs2 = null;
        this.subs1val = 0;
  
      },
      runSecondSession(){ 
          let day2 = 0; 
          const start = new Date(dayjs(this.secSession).format('MM-DD-YYYY'));
          const end = new Date(dayjs(this.secSession).endOf('month').format('MM-DD-YYYY'))
          let loop = new Date(start);
          while (loop <= end) {
            if (loop.getDay() == 3) {
                day2++;    
            }
            let newDate = loop.setDate(loop.getDate() + 1);
            loop = new Date(newDate);
        }
        return day2;
      },
      async addmethod(option) {
        if (option == 1) {
          this.$bvModal.show("add-session");
        }
        else{
          let data = await this.getSessionScheduleinform();

          if (!this.cipEligibility) {
            const excludeSessions = [
              "a36cc649-fb7e-ed11-81ad-000d3a856a39",
              "413249eb-381a-ee11-8f6d-002248ecdc58"
            ];
            data = data.filter( session => !excludeSessions.includes(session.crb5c_fow_session_scheduleid));
          }
          this.schedule_info = data;
          this.schedule_info.sort((a, b) => a.crb5c_day - b.crb5c_day)
          // console.log('schedule_info',this.schedule_info)
          this.$bvModal.show("pick-session");
        }
        
      },
      async addNew() {
        let testobj={type: this.typeses,
          day: this.day,
          time: this.time,
          location: this.location,
          name: this.newSessionTitle,
          duration: this.newDuration,
          dementiaLevel: this.newDementiaType,
          sessionType: this.newSessionType,}
        console.log(testobj);
        if(!this.typeses || !this.day || !this.time || !this.location || !this.newSessionTitle || !this.newDuration || this.newSessionType == null || this.newDementiaType==null){
          alert('Please fill up all the inforation for the new session')
          return;
        }
  
         this.sessions.push({
          type: this.typeses,
          day: this.day,
          time: this.time,
          location: this.location,
          name: this.newSessionTitle,
          duration: this.newDuration,
          dementiaLevel: this.newDementiaType,
          sessionType: this.newSessionType,
        });
  
        await this.filterFees();
  
        this.typeses= false;
        this.day=false;
        this.time=false;
        this.location= false;
        this.newSessionTitle = '';
  
        this.$bvModal.hide("add-session");
  
      },
      groupingSessionRecommended(){
        // TODO: grouping session recommended after ended
      },
      async getdatainform(retry = false){
        const clientId = this.$store.state.assessment_client_id;
        
        let paramObj = {
          $select:'crb5c_no,crb5c_nricno,crb5c_partialnric,crb5c_citizenship,crb5c_highqualification,crb5c_postcode,crb5c_admissiondate,crb5c_dob',
          $expand:"crb5c_fow_caregiver_client_crb5c_FOW_Cust($select=crb5c_name,crb5c_contactnumbermobile,crb5c_relationship,crb5c_email),crb5c_CIPPreset($select=crb5c_fow_feeid)",
          $filter: `crb5c_fow_customerid eq '${clientId}'`,
          };
        let params = new URLSearchParams(paramObj);
        let { data: data } = await this.$store.state.axios.get(
          `crb5c_fow_customers/?${params.toString()}`
          );
        // console.log('data',data)

        if (!data.value?.length) {
          if (!retry) {
            console.warn("No data found, retrying once...");
            await this.getdatainform(true);
          } else {
            console.error("No data found even after retry.");
          }
          return;
        }


        
        this.cipPreset = data.value[0]?.crb5c_CIPPreset?.crb5c_fow_feeid;
        this.clientdata = data.value[0];

       
        this.caregiverClientIc = this.clientdata.crb5c_nricno;
        this.caregiverClientName = this.clientdata.crb5c_no;
        this.caregiverDetails = this.clientdata.crb5c_fow_caregiver_client_crb5c_FOW_Cust;
        this.clientPostCode = this.clientdata.crb5c_postcode;
        this.checkTransportClient(this.clientPostCode);
        this.edulev = this.clientdata.crb5c_highqualification;
        let fees = await this.getSubsidyandFee();
        this.cipTemplates = fees.filter(item => item.crb5c_transportfee === false);
        // console.log('cip templates',this.cipTemplates);
        // console.log('formatted templates',this.formattedTemplates);
        // Resolve the ASSIGNED preset from the full fee list (not the filtered picker),
        // so an existing client's stored preset always loads and drives the fee on
        // follow-up phases regardless of the current CIP 2.0 / birth-year filtering.
        if (this.cipPreset && this.cipTemplates.length) {
          const assigned = this.cipTemplates.find(item => item.crb5c_fow_feeid === this.cipPreset);
          if (assigned) {
            this.selectedCipTemplate = this.mapFeeRowToTemplate(assigned);
          }
        }
        // console.log('caregiver data',this.caregiverDetails);
        await this.getProgrammeInfos();

        //public holiday for SG
        let listPublicHoliday = [];
        try {
          listPublicHoliday = await this.getSGPublicHoliday();
        } catch (error) {
          console.error('Failed to load public holidays on first attempt:', error);
          // Silently retry in background every 10 s — do not alert or unblock yet
          this.holidayRetrying = true;
          this._holidayRetryTimer = setInterval(async () => {
            try {
              listPublicHoliday = await this.getSGPublicHoliday();
              clearInterval(this._holidayRetryTimer);
              this._holidayRetryTimer = null;
              this.holidayRetrying = false;
              // Apply substitute holidays and finish loading
              const subs = [];
              for (const h of listPublicHoliday) {
                const hd = dayjs(h.date);
                if (hd.day() === 0) {
                  const ms = hd.add(1, 'day').format('YYYY-MM-DD');
                  if (!listPublicHoliday.some(e => dayjs(e.date).format('YYYY-MM-DD') === ms)) {
                    subs.push({ ...h, date: ms, day: 'Monday', holiday: `${h.holiday} (in lieu)` });
                  }
                }
              }
              this.allHolidays = [...this.allHolidays.filter(h => !h._sgph), ...[...listPublicHoliday, ...subs].map(h => ({ ...h, _sgph: true }))];
              this.holidaysLoaded = true;
            } catch (retryError) {
              console.warn('Holiday retry failed, will try again...', retryError);
            }
          }, 10000);
          // Unblock the form without PH data so staff can still use the form
          this.holidaysLoaded = true;
        }

        // Add substitute public holidays: when a PH falls on Sunday (rest day), the following Monday is observed in lieu
        const substituteHolidays = [];
        for (const h of listPublicHoliday) {
          const holidayDate = dayjs(h.date);
          if (holidayDate.day() === 0) { // Sunday
            const mondayDate = holidayDate.add(1, 'day');
            const mondayStr = mondayDate.format('YYYY-MM-DD');
            const alreadyExists = listPublicHoliday.some(
              existing => dayjs(existing.date).format('YYYY-MM-DD') === mondayStr
            );
            if (!alreadyExists) {
              substituteHolidays.push({
                ...h,
                date: mondayStr,
                day: 'Monday',
                holiday: `${h.holiday} (in lieu)`,
              });
            }
          }
        }
        listPublicHoliday = [...listPublicHoliday, ...substituteHolidays];

        // this.listPublicHolidayCurrentMonth = this.getPublicHolidayCurrentMonth(listPublicHoliday).length === 0 ? null : this.getPublicHolidayCurrentMonth(listPublicHoliday);
        
        //dsg off days 
        let getHolidays = [];
        try {
          getHolidays = await this.getDsgHoliday();
        } catch (error) {
          console.error('Failed to load DSG holidays:', error);
        }
        if (getHolidays.length >  0) {
          getHolidays = getHolidays.map(
          (holiday) => {
            return {
              date: dayjs(holiday.crb5c_date).format('YYYY-MM-DD'),
              day: dayjs(holiday.crb5c_date).format('dddd'),
              holiday: holiday.crb5c_name,
              _id: holiday.crb5c_fowcalendarid
            };
          }
        );
        // console.log('getHolidays',getHolidays)
        // this.listPublicHolidayCurrentMonth.push(...getHolidays);
        }
        // console.log('listPublicHoliday',listPublicHoliday)
        this.allHolidays = [...listPublicHoliday, ...getHolidays];
        this.holidaysLoaded = true;
        // console.log('allHolidays',this.allHolidays)
        // console.log('listPublicHolidayCurrentMonth',this.listPublicHolidayCurrentMonth)

      },
      // Maps a raw crb5c_fow_fees row into the shape the CIP UI/fee calc expects.
      mapFeeRowToTemplate(item){
        return {
          id: item.crb5c_fow_feeid,
          description: item.crb5c_description,
          amt: item.crb5c_amt,
          subsidy_amt: item.crb5c_subsidy,
          Oop: (item.crb5c_amt - item.crb5c_subsidy),
          citizen: item.crb5c_for_citizen,
          pr: item.crb5c_for_pr,
          transport: item.crb5c_transportamt || 0,
          fin_amt: this.roundUp(item.crb5c_amt - item.crb5c_subsidy).toFixed(2)
        };
      },
      async getSubsidyandFee(){
        let paramObj = {
          $select:'crb5c_description,crb5c_amt,crb5c_subsidy,crb5c_type,crb5c_transportfee,crb5c_transportfee,crb5c_for_citizen,crb5c_for_pr,crb5c_for_ltvp,crb5c_subsidypercentage,crb5c_transportamt,crb5c_iscip2,crb5c_born1969orbefore',
          $filter: 'crb5c_feeactive eq true',
        };
        let params = new URLSearchParams(paramObj);
        let { data: data } = await this.$store.state.axios.get(
          `crb5c_fow_fees/?${params.toString()}`
          );
        return data.value;
      },
      async getSessionScheduleinform(){
        let paramObj = {
          $select:'crb5c_session_id,crb5c_sessionreporttype,crb5c_sessiontype,crb5c_day,crb5c_duration,crb5c_time,crb5c_time_hrs,crb5c_time_mins,crb5c_session_time_choice',
          $filter:'crb5c_isactive eq true',
          };
        let params = new URLSearchParams(paramObj);
        let { data: data } = await this.$store.state.axios.get(
          `crb5c_fow_session_schedules/?${params.toString()}`
          );
        return data.value;
      },
      async getProgrammeInfos(){
          let paramObj = {
            $select:'crb5c_programmename,crb5c_price,crb5c_type',
          };
          let params = new URLSearchParams(paramObj);
          try {
            let { data } = await this.$store.state.axios.get(
            `crb5c_fowprogrammes/?${params.toString()}`
            );
            if (data) {
              this.programmeInfos = data.value;
              this.programmeInfos.sort((a, b) => a.crb5c_programmename.localeCompare(b.crb5c_programmename))
            }
            else{
              console.log('No programmes retrieved')
            }
          } catch (error) {
            console.error('Error fetching programme', error)
          }
          
          // console.log('programme data',this.programmeInfos);
    },
    async getImagesInfos(){
          let id = '9d8fc0b8-157f-ee11-8179-002248ecdc58';
          let paramObj = {
            $select:'crb5c_dsgsignature,crb5c_caregiversignature',
            $filter: `crb5c_fowserviceagreementid eq '${id}'`,
          };
          let params = new URLSearchParams(paramObj);
          let { data } = await this.$store.state.axios.get(
            `crb5c_fowserviceagreements/?${params.toString()}`
          );
          this.imagesSign = data.value;
          console.log('this.imagesSign',this.imagesSign)
          
          // console.log('programme data',this.programmeInfos);
        },
    async getDsgHoliday(){
          let paramObj = {
            $select:'crb5c_date,crb5c_name',
          };
          let params = new URLSearchParams(paramObj);
          let { data } = await this.$store.state.axios.get(
            `crb5c_fowcalendars/?${params.toString()}`
          );  
          return data.value;
      },
      clearCanvas(val){
        this.$refs[val].clear();
      },
      // showConfimrationModal(){
      //   // this.$bvModal.show("confrimationModal");
      // },
      async updateClient(){
        let payload = {};
        if (this.phase3CompletionChoice === 'complete') {
          payload = {
              crb5c_client_status : 411620002,
            }
        }else{
            payload = {
              crb5c_client_status : 411620000,
              crb5c_cipmember : this.cipEligibility ? true : false,
              crb5c_newfow: this.cipEligibility ? false : true,
            }
        }
        
        const { data } = await this.$store.state.axios.patch(`/crb5c_fow_customers(${this.$store.state.assessment_client_id})`,payload);
        console.log('Client Status Updated',data.crb5c_no)
      },
      async linkClientProgramme(){
        for(let programme of this.applicableFeeTotal ){
          let payload = { 
            "crb5c_Client@odata.bind": `/crb5c_fow_customers(${this.$store.state.assessment_client_id})`, 
            "crb5c_Programme@odata.bind": `/crb5c_fow_customers(${programme.crb5c_fowprogrammeid})`,
          }
          await this.$store.state.axios.post(`/crb5c_fowclientandprogrammes`,payload);
          // console.log('client and programme linked', data)
        }
      },
      async submitServiceAgreement(){
        if(this.previousAssessment){
          this.loadingSubmission = false;
          this.$bvModal.hide('paymentConfirmation');

          setTimeout(() => {
            this.$bvModal.hide('assessmentSubmission');
            this.sessionAutomation();
          }, 6000);
          return;
        }
        this.caregiverSignatureImg = this.$refs.caregiverSignature.toDataURL().split(',')[1];
        this.staffSignatureImg = this.$refs.staffSignature.toDataURL().split(',')[1];

        const resolvedCaregiverName = typeof this.caregiverPicked === 'object'
          ? (this.caregiverPicked?.crb5c_name || '')
          : (this.caregiverPicked || '');

        const payload1 = { 
          crb5c_caregivername: resolvedCaregiverName,
          crb5c_clientname : this.caregiverClientName,
          crb5c_clientic: this.caregiverClientIc,
          crb5c_relationship: this.clientReationship,
          crb5c_caregiversignature: this.caregiverSignatureImg,
          crb5c_clientid: this.$store.state.assessment_client_id,
       };
        const { data } = await this.$store.state.axios.post(`/crb5c_fowserviceagreements`,payload1);
        // console.log('main',data)
        let id = data.crb5c_fowserviceagreementid

        await this.signatureUploadforStaff(id);
        await this.triggerPDFView();
        // await this.uploadAssessmentFullPDF();
        await this.uploadServiceAgreement();
        console.log('Service agreement uploaded')
        this.loadingSubmission = false;
        this.$bvModal.hide('paymentConfirmation');

        setTimeout(() => {
          this.$bvModal.hide('assessmentSubmission');
          this.sessionAutomation();
        }, 6000);



      },
      triggerPDFView(){
        this.notPDFview = false;
      },
      async signatureUploadforStaff(id){
        const payload2 = { 
          crb5c_dsgsignature: this.staffSignatureImg,
        };
        await this.$store.state.axios.patch(`/crb5c_fowserviceagreements(${id})`,payload2);
      },
      async uploadServiceAgreement(){
        const options = {
          margin: 1, 
        };
        let el = this.$refs.pdfFormView;
        const pdf = await html2pdf().from(el).set(options).outputPdf();
        const base64 = btoa(pdf);
        this.pdfAgreement = base64;
          
        const payloadPdf = {
          documentbody: this.pdfAgreement,
          subject: this.$store.state.assessment_client_id,
          filename: 'Service Agreement (Assessment)',
        }
        await this.$store.state.axios.post(`/annotations`,payloadPdf);
        // console.log('service agreeement',pdfSuccsess)
      },
      async uploadAssessmentFullPDF(){
        const options = {
          margin: 2, 
        };
        let elementPage = this.$refs.pdfWholePage;
        const pdfFull = await html2pdf().from(elementPage).set(options).outputPdf();
        const base64Full = btoa(pdfFull);
        this.pdfFullPage = base64Full;
        // console.log('this.pdfFullPage',this.pdfFullPage)
        const payloadAssessmentPdf = {
        documentbody: this.pdfFullPage,
        subject: this.$store.state.assessment_client_id,
        filename: 'Assessment Full',
        }
        const { pdfSuccsess } = await this.$store.state.axios.post(`/annotations`,payloadAssessmentPdf);
        console.log('Assessment',pdfSuccsess)
      },
      async submitassessment(){
        if (this.isPhase3Completion && !this.phase3CompletionChoice) {
          alert('Please select an option: Complete Program or Switch to FOW')
          return
        }
        
        const isCompleting = this.phase3CompletionChoice === 'complete';
        if (!this.adm && !this.notJoining && !isCompleting) {
          alert('Please fill up the admission date before proceeding!') 
          return
        }

        if (this.isAMT && (this.amtVal === null || this.amtVal === '' || this.amtVal === undefined)) {
          alert('AMT is selected but no score has been entered. Please enter a value or uncheck AMT.')
          return
        }
        if (this.isMOCA && (this.mocaVal === null || this.mocaVal === '' || this.mocaVal === undefined)) {
          alert('MOCA is selected but no score has been entered. Please enter a value or uncheck MOCA.')
          return
        }
        if (this.isMMSE && (this.mmseVal === null || this.mmseVal === '' || this.mmseVal === undefined)) {
          alert('MMSE is selected but no score has been entered. Please enter a value or uncheck MMSE.')
          return
        }

        if(!this.notJoining){
          this.loadingSubmission = true;
          this.$bvModal.show("assessmentSubmission");
        }else{
          this.$bvModal.hide('paymentConfirmation');
          this.submitOnlyAssessment = true;
          this.$bvModal.show("assessmentOnlySubmission");
        }
        
        this.totalscoreMoca = this.totalscore;
        this.totalscoreEq = this.eq5dcounter;
        
        const payload = { 
          crb5c_typeofdementia: this.type,
          crb5c_stageofdementia: this.stageof,
          // crb5c_latestscoreon: this.latestscore,
          // crb5c_latestscorevalue: (this.latestscore == 'MOCA') ? this.totalscoreMoca : this.latest,
          crb5c_datedone: this.date ? this.date : null,
          crb5c_sharedcentreobjectivesprogramme: this.checker ? true : false,
          crb5c_watchedcentrevideo: this.checker2  ? true : false,
          crb5c_playedtabletopgame: this.checker3  ? true : false,
          crb5c_playedneeurofitgame: this.neeuro  ? true : false,
          crb5c_educationlevel: this.edulev,
          crb5c_clientname:this.$store.state.assessment_client_name,
          crb5c_clientid: this.$store.state.assessment_client_id,
          crb5c_alternatetrailmaking: parseInt(this.vis1),
          crb5c_copycube: parseInt(this.vis2),
          crb5c_lion: parseInt(this.vis4),
          crb5c_elephant: parseInt(this.vis5),
          crb5c_camel: parseInt(this.vis6),
          crb5c_repeatforward: parseInt(this.vis7),
          crb5c_repeatbackward: parseInt(this.vis17),
          crb5c_abletotap: parseInt(this.vis8),
          crb5c_serial7subtraction: parseInt(this.vis9),
          crb5c_repeatfirstsentence: parseInt(this.vis10),
          crb5c_repeatsecondsentence: parseInt(this.vis11),
          crb5c_similaritybetweentrainbicycle: parseInt(this.vis13),
          crb5c_similaritybetweenwatchruler: parseInt(this.vis14),
          crb5c_mocatotalscore: this.totalscoreMoca,
          crb5c_eqtotalscore: this.totalscoreEq,
          crb5c_commentsaboutclient: this.checking,
          crb5c_eqmobility: parseInt(this.eq1),
          crb5c_eqselfcare:parseInt(this.eq2),
          crb5c_equsualactivities:parseInt(this.eq3),
          crb5c_eqpaindiscomfort:parseInt(this.eq4),
          crb5c_eqanxietydepression:parseInt(this.eq5),
          crb5c_eqhealthscale: this.healthscale,
          crb5c_neeurofitattentiongame: this.attentionObj.attentiongame,
          crb5c_neeurofitattentionlevel: parseInt(this.attentionObj.attentionlevel),
          crb5c_neeurofitspatialgame: this.spatialObj.spatialgame,
          crb5c_neeurofitspatiallevel: parseInt(this.spatialObj.spatiallevel),
          crb5c_neeurofitdecisiongame: this.decisionObj.decisiongame,
          crb5c_neeurofitdecisionlevel: parseInt(this.decisionObj.decisionlevel),
          crb5c_neeurofitmemorygame: this.memoryObj.memorygame,
          crb5c_neeurofitmemorylevel: parseInt(this.memoryObj.memorylevel),
          crb5c_neeurofitflexibilitygame: this.flexibilityObj.flexibilitygame,
          crb5c_neeurofitflexibilitylevel: parseInt(this.flexibilityObj.Flexibilitylevel),
          crb5c_orientation: this.vis16.length,
          crb5c_delayedrecall: this.delayedrecall,
          crb5c_fluency: this.checkfluency,
          crb5c_drawclock: this.vis3.length,
          crb5c_languageversion: this.language,
          crb5c_modeofpayment: this.modeofpayment,
          crb5c_amountcollected: '$' + this.viewamtcollect.toFixed(2),
          crb5c_educationyear: this.selectedyear,
          crb5c_mocaform: this.checker4 ? true : false,
          crb5c_eq5d5lform: this.checker5 ? true : false,
          crb5c_admissiondate:  this.adm ? dayjs(this.adm).toISOString(): null,
          crb5c_referenceid: this.referenceid,
          crb5c_dateofassessment: dayjs(this.$store.state.assessment_date).toISOString(),
          crb5c_mocascore: (this.isMOCA) ? (Number(this.mocaVal) || 0) : 0,
          crb5c_amtscore: (this.isAMT) ? (Number(this.amtVal) || 0) : 0,
          crb5c_mmsescore: (this.isMMSE) ? (Number(this.mmseVal) || 0) : 0,
          crb5c_cip1stsession:  this.firSession ? dayjs(this.firSession).toISOString(): null,
          crb5c_cip2ndsession: this.secSession ? dayjs(this.secSession).toISOString(): null,
          crb5c_additionalfee: parseInt(this.transport.amountToBePaid) || 0,
          crb5c_refundabledeposit: parseInt(this.refundableDeposit),
          // crb5c_onetimeassessmentother: this.,
          crb5c_neeurofitsubscription: this.neeurofitFeeTotal ? 1 : 0,
          // crb5c_onetimeassessmentpaid: ,
          // crb5c_onetimeassessmentwaived: ,
          crb5c_neeurofitamount: parseInt(this.neeurofitFeeTotal) || 0,
          crb5c_meanstestresult: parseInt(this.subsidyAmount) || 0,
          crb5c_transporttotal: parseFloat((this.transport.fixedFee * (1 - ((this.subsidyAmount ?? 0) / 100))).toFixed(2)) || 0,
          crb5c_transportincluded: this.transport.isIncluded ? 1 : 0,
          crb5c_toteboardincluded: this.subs2 ? 1 : 0,
          crb5c_cip1stsessionformat: this.firstSesFormat,
          crb5c_cip2ndsessionformat: this.secondSesFormat,
          crb5c_recommendedsessions: !this.notJoining ? this.getRecSessions(this.recommended_session_pick) : '',
          crb5c_applicablesessions: !this.notJoining ? this.getApplicable(this.applicableFeeTotal) : '',
          crb5c_notjoining: this.notJoining ? true : false,
          crb5c_cipphase: this.cipPhaseChecker(),
          crb5c_cipphasetimeline: this.getPhaseTimeline(),
          crb5c_fowtimeline: this.getFowTimeline(),
          crb5c_phaseenddate: this.getPhaseEndDate(),
          'crb5c_ClientLookup@odata.bind': `/crb5c_fow_customers(${this.$store.state.assessment_client_id})`,
          // crb5c_feeinfo: this.getFeeInfo(this.selectedProgrammeSummary),
          crb5c_coverpage: JSON.stringify(this.buildCoverPageData()),
          // Mark the draft row as a completed submission
          crb5c_isdraft: false,
          crb5c_draftformdata: null,
        };
          // console.log('payload',payload)
          try {
          // PATCH the existing draft row to finalise it (avoids creating a duplicate record)
          // Fall back to POST if no draft ID exists (e.g. draft creation failed on mount)
          const assessmentFormId = this.draftAssessmentId;
          if (assessmentFormId) {
            await this.$store.state.axios.patch(
              `/crb5c_fowassessmentforms(${assessmentFormId})`, payload);
          } else {
            const { data } = await this.$store.state.axios.post(
              `/crb5c_fowassessmentforms`, payload);
            this.draftAssessmentId = data.crb5c_fowassessmentformid;
          }
          // console.log('Assessment form submitted:', assessmentFormId ?? this.draftAssessmentId)

          // The assessment is finalised — remove any other leftover draft rows
          // for this client (duplicates from concurrent opens) so the client
          // never sees a completed assessment plus a stray draft.
          await this.cleanupStrayDrafts();

          if (this.cipEligibility && this.invoices && this.invoices.length > 0 && !this.notJoining) {
            await this.attachCipInvoiceToAssessment(this.draftAssessmentId);
          }

          if (this.phase3CompletionChoice === 'complete') {
            await this.updateClient();
            this.loadingSubmission = false;
            this.$bvModal.show("assessmentOnlySubmission");
          } else if (!this.notJoining) {
            await this.updateClient();
            await this.linkClientProgramme();
            await this.submitServiceAgreement();
            await this.generateEmail();
          }else{
            this.submitOnlyAssessment = false;
          }
          
          this.formCompleted = true;
          localStorage.removeItem("invoice");
          } catch (err) {
            console.error('Assessment submission failed:', err);
            this.loadingSubmission = false;
            this.submitOnlyAssessment = false;
            alert('Submission failed. Please check your connection and try again.');
          }
        
    },
    async sessionAutomation(){
      this.AutoMatchingSession()
    },
      pick_answer_naming(val){
        if(this[`vis${val}`] == '0'){
            this[`vis${val}`] = '1';
            return;
        }
          this[`vis${val}`] = '0';
      },
      checkDistanceTransport(){
        if(!this.transport.startPostalCode || !this.transport.destinationPostalCode){
          alert('Please specify start and destination postal code');
          return;
        }

        if(this.transport.startPostalCode.length !== 6 || this.transport.destinationPostalCode.length !== 6){
          alert('Please enter valid postal code');
          return;
        }

        console.log(this.transport.startPostalCode);
        console.log(this.transport.destinationPostalCode);

        this.transport.iframeSrc = `https://maps.google.com/maps?saddr=Singapore ${this.transport.startPostalCode}&daddr=Singapore ${this.transport.destinationPostalCode}&ie=UTF8&output=embed&mode=driving`;

      },
      async getAndSetClientTransportPostalCode(){
        try {
          const clientId = this.$store.state.assessment_client_id;
          const paramObj = {
            $select:'crb5c_postcode',
            $filter: `crb5c_fow_customerid eq '${clientId}'`,
          };
          const params = new URLSearchParams(paramObj);

          if(!this.$store.state?.axios?.get){
            return null;
          }

          const { data } = await this.$store.state.axios.get(
            `crb5c_fow_customers/?${params.toString()}`
          );
          const postalCode = data.value[0].crb5c_postcode;
          console.log('Client postal code: ', postalCode);

          return postalCode;
          
        } catch (error) {
          console.error(error);

          return null;
        }

      },
      async attachCipInvoiceToAssessment(assessmentFormId) {
        // console.log('Attaching CIP invoice to assessment form...');
        try {
          if (!assessmentFormId) {
            console.log('No assessment form ID');
            return;
          }

          const cipInvoice = this.invoices.find(invoice => 
            invoice.crb5c_id && invoice.crb5c_id.includes('CIP-INV')
          );
          
          if (!cipInvoice) {
            console.log('No CIP invoice found in invoices array');
            return;
          }

          // console.log('Attaching CIP invoice to assessment form:', {
          //   assessmentFormId,
          //   invoiceId: cipInvoice.crb5c_fowinvoiceid,
          //   invoiceNumber: cipInvoice.crb5c_id
          // });

          const updatePayload = {
            'crb5c_InvoiceLookup@odata.bind': `/crb5c_fowinvoices(${cipInvoice.crb5c_fowinvoiceid})`
          };

          await this.$store.state.axios.patch(
            `/crb5c_fowassessmentforms(${assessmentFormId})`,
            updatePayload
          );

          console.log('CIP invoice successfully attached');
          
        } catch (error) {
          console.error('Error attaching CIP invoice to assessment form:', error);
        }
      },
      /**
       * Toggle manual CIP eligibility override
       * This allows staff to manually mark a client as CIP eligible 
       * even if their MOCA score doesn't meet the criteria (10-25)
       */
      toggleManualCipEligibility() {
        try {
          // If currently forcing eligibility, reset to auto
          if (this.manualCipEligibility === true) {
            this.manualCipEligibility = null;
            console.log('Manual CIP eligibility override removed - using automatic scoring');
          } 
          // Otherwise, force eligibility
          else {
            // Validate that client has cipPreset configured
            if (!this.cipPreset) {
              alert('Error: Client does not have a CIP preset configured. Cannot manually set CIP eligibility.');
              return;
            }
            
            // Validate that client is not set to "not joining"
            if (this.notJoining) {
              alert('Error: Cannot set CIP eligibility for clients marked as "Not Joining".');
              return;
            }
            
            this.manualCipEligibility = true;
            console.log('Manual CIP eligibility override activated - client marked as eligible regardless of score');
            
            // Log the override for audit purposes
            console.warn('AUDIT: Manual CIP eligibility override activated', {
              timestamp: new Date().toISOString(),
              clientId: this.$store.state.assessment_client_id,
              mocaScore: this.totalscore,
              scoreInRange: this.totalscore >= 10 && this.totalscore <= 25
            });
          }
        } catch (error) {
          console.error('Error toggling manual CIP eligibility:', error);
          alert('An error occurred while toggling CIP eligibility. Please try again.');
        }
      },
      
      /**
       * Toggle programme type override between CIP and FOW
       * This allows staff to switch a client between CIP and FOW programmes
       * independent of their cipPreset configuration
       */
      toggleProgrammeOverride() {
        try {
          // Validate that client is not set to "not joining"
          if (this.notJoining) {
            alert('Error: Cannot change programme for clients marked as "Not Joining".');
            return;
          }
          
          // Determine current effective programme based on cipEligibility
          const currentlyOnCip = this.cipEligibility;
          
          // If currently on CIP, switch to FOW
          if (currentlyOnCip) {
            this.programmeOverride = 'FOW';
            console.log('Programme override activated - forcing FOW instead of CIP');
            
            // Clear CIP-specific data when switching to FOW
            this.selectedCipTemplate = [];
            this.cipAdm = '';
            
            // Log the override
            console.warn('AUDIT: Programme override to FOW activated', {
              timestamp: new Date().toISOString(),
              clientId: this.$store.state.assessment_client_id,
              hadCipPreset: !!this.cipPreset,
              hadManualEligibility: this.manualCipEligibility
            });
          } 
          // If currently on FOW, switch to CIP
          else {
            // Validate that switching to CIP is possible
            if (!this.cipPreset && !this.manualCipEligibility) {
              const confirm = window.confirm(
                'Warning: Client does not have a CIP preset configured and is not manually eligible. ' +
                'Do you want to force CIP programme anyway? You may need to manually set eligibility.'
              );
              if (!confirm) return;
            }
            
            this.programmeOverride = 'CIP';
            console.log('Programme override activated - forcing CIP instead of FOW');
            
            // Log the override
            console.warn('AUDIT: Programme override to CIP activated', {
              timestamp: new Date().toISOString(),
              clientId: this.$store.state.assessment_client_id,
              mocaScore: this.totalscore,
              hadCipPreset: !!this.cipPreset
            });
          }
        } catch (error) {
          console.error('Error toggling programme override:', error);
          alert('An error occurred while toggling programme type. Please try again.');
        }
      },
      
      /**
       * Reset both override flags to automatic mode
       */
      resetAllOverrides() {
        this.manualCipEligibility = null;
        this.programmeOverride = null;
        console.log('All overrides reset to automatic mode');
      },
      async saveDraft() {
        if (this.formCompleted || !this.draftAssessmentId || this.draftSaving) return;
        // Cancel any pending auto-save timer
        clearTimeout(this._draftSaveTimer);
        this.draftSaving = true;
        this.draftSaveStatus = null;
        try {
          const staffName = this.$store.state.msalAccount?.[0]?.name ?? '';
          await axios.put(`/api/draft?draft_id=${this.draftAssessmentId}`, {
            draft: this.$store.state.assessmentData,
            staff_name: staffName,
          });
          this.draftLastModifiedBy = staffName || this.draftLastModifiedBy;
          this.draftSaveStatus = 'saved';
          setTimeout(() => { this.draftSaveStatus = null; }, 3000);
        } catch (e) {
          console.error('Manual save draft failed', e);
          this.draftSaveStatus = 'error';
          alert('Could not save draft. Please check your connection and try again.');
        } finally {
          this.draftSaving = false;
        }
      },
      handleCompleteProgram() {
        const result = confirm("Submit Assessment and Discharge Client?");
        if (!result) {
          return;
        }
        this.phase3CompletionChoice = 'complete';
        this.submitassessment();
      },
      handleSwitchToFow() {
        this.phase3CompletionChoice = 'switch-to-fow';
        this.$nextTick(() => {
          if (this.$refs.fowSessionSection) {
            this.$refs.fowSessionSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }
    },
    watch: {
    // Cloud draft auto-save: debounce so rapid field changes only fire one API call
    '$store.state.assessmentData': {
      deep: true,
      handler() {
        if (this.formCompleted || !this.draftAssessmentId) return;
        clearTimeout(this._draftSaveTimer);
        this.autoSaveStatus = null;
        this.$store.commit('autoSaveStatus', null);
        this._draftSaveTimer = setTimeout(async () => {
          if (this.formCompleted || !this.draftAssessmentId) return;
          this.autoSaveStatus = 'saving';
          this.$store.commit('autoSaveStatus', 'saving');
          try {
            const staffName = this.$store.state.msalAccount?.[0]?.name ?? '';
            await axios.put(`/api/draft?draft_id=${this.draftAssessmentId}`, {
              draft: this.$store.state.assessmentData,
              staff_name: staffName,
            });
            this.draftLastModifiedBy = staffName || this.draftLastModifiedBy;
            this.autoSaveStatus = 'saved';
            this.$store.commit('autoSaveStatus', 'saved');
            setTimeout(() => {
              if (this.autoSaveStatus === 'saved') {
                this.autoSaveStatus = null;
                this.$store.commit('autoSaveStatus', null);
              }
            }, 3000);
          } catch (e) {
            console.warn('Auto-save draft failed', e);
            this.autoSaveStatus = 'error';
            this.$store.commit('autoSaveStatus', 'error');
          }
        }, 1500);
      },
    },
    async cipEligibility(val){
      if (val) {
        await this.updateCIPSessions();
      }
    },
    cipAdm(val){
        if (val) {
          this.adm = dayjs(val).format("YYYY-MM-DD");
        }
  },
      //------------------ SAVE TO LOCAL STORAGE ------------------//
      type(val){
        this.assessmentDataChange({
          typeOfDementia: val,
        });
      },
      stageof(val){
        this.assessmentDataChange({
          stageOfDementia: val,
        });
      },
      isAMT(val){
        this.assessmentDataChange({
          isAMT: val,
        });
      },
      amtVal(val){
        this.assessmentDataChange({
          amtVal: val,
        });
      },
      isMOCA(val){
        this.assessmentDataChange({
          isMOCA: val,
        });
      },
      mocaVal(val){
        this.assessmentDataChange({
          mocaVal: val,
        });
      },
      isMMSE(val){
        this.assessmentDataChange({
          isMMSE: val,
        });
      },
      mmseVal(val){
        this.assessmentDataChange({
          mmseVal: val,
        });
      },
      date(val){
        this.assessmentDataChange({
          dateDoneInHospital: val,
        });
      },
      //-- general
      checker(val){
        this.assessmentDataChange({
          generalCheckerOne: val,
        });
      },
      checker2(val){
        this.assessmentDataChange({
          generalCheckerTwo: val,
        });
      },
      checker3(val){
        this.assessmentDataChange({
          generalCheckerThree: val,
        });
      },
      //-- general
      //-- games & surveys
      //-- Neeurofit
      neeuro(val){
        this.assessmentDataChange({
          isNeeuroFitBrainTrainingGame: val,
        });
      },
      transportInclude(val){
        this.assessmentDataChange({
          transportInclude: val,
        })
      },
      cipAdditionalTransport(val){
        this.assessmentDataChange({
          cipAdditionalTransport: val,
        })
      },
      atten(val){
        this.assessmentDataChange({
          atten: val,
        });
      },
      attentionObj: {
        handler(val){
          this.assessmentDataChange({
            attentionObj: val,
          });
        },
        deep: true,
      },
      spatial(val){
        this.assessmentDataChange({
          spatial: val,
        });
      },
      spatialObj: {
        handler(val){
          this.assessmentDataChange({
            spatialObj: {
              ...val
            },
          });
        },
        deep: true,
      },
      decision(val){
        this.assessmentDataChange({
          decision: val,
        });
      },
      decisionObj:{
        handler(val){
          this.assessmentDataChange({
            decisionObj: val,
          });
        },
        deep: true,
      },
      memory(val){
        this.assessmentDataChange({
          memory: val,
        });
      },
      memoryObj: {
        handler(val){
          this.assessmentDataChange({
            memoryObj: val,
          });
        },
        deep: true,
      },
      flexibility(val){
        this.assessmentDataChange({
          flexibility: val,
        });
      },
      flexibilityObj: {
        handler(val){
          this.assessmentDataChange({
            flexibilityObj: val,
          });
        },
        value: true,
      },
      // transportInclude(){
      //   this.selectedCipTemplate = [];
      // },
      //-- Neeurofit
      //-- MOCA Form
      language(val){
        this.assessmentDataChange({
          language: val,
        });
      },
      // edulev(val){
      //   this.assessmentDataChange({
      //     edulev: val,
      //   });
      // },
      // unyearSelected(val){
      //   this.assessmentDataChange({
      //     unyearSelected: val,
      //   });
      // },
      // ovyearSelected(val){
      //   this.assessmentDataChange({
      //     ovyearSelected: val,
      //   });
      // },
      vis1(val){
        this.assessmentDataChange({
          vis1: val,
        });
      },
      vis2(val){
        this.assessmentDataChange({
          vis2: val,
        });
      },
      vis3(val){
        this.assessmentDataChange({
          vis3: val,
        });
      },
      vis4(val){
        this.assessmentDataChange({
          vis4: val,
        });
      },
      vis5(val){
        this.assessmentDataChange({
          vis5: val,
        });
      },
      vis6(val){
        this.assessmentDataChange({
          vis6: val,
        });
      },
      vis7(val){
        this.assessmentDataChange({
          vis7: val,
        });
      },
      vis8(val){
        this.assessmentDataChange({
          vis8: val,
        });
      },
      vis9(val){
        this.assessmentDataChange({
          vis9: val,
        });
      },
      vis10(val){
        this.assessmentDataChange({
          vis10: val,
        });
      },
      vis11(val){
        this.assessmentDataChange({
          vis11: val,
        });
      },
      vis18(val){
        this.assessmentDataChange({
          vis18: val,
        });
      },
      vis13(val){
        this.assessmentDataChange({
          vis13: val,
        });
      },
      vis14(val){
        this.assessmentDataChange({
          vis14: val,
        });
      },
      vis15(val){
        this.assessmentDataChange({
          vis15: val,
        });
      },
      vis16(val){
        this.assessmentDataChange({
          vis16: val,
        });
      },
      vis17(val){
        this.assessmentDataChange({
          vis17: val,
        });
      },
      //-- MOCA Form
      //-- EQ5D5L Form
      checker5(val){
        this.assessmentDataChange({
          isEQ5D5Lform: val,
        });
      },
      eq1(val){
        this.assessmentDataChange({
          eq1: val,
        });
      },
      eq2(val){
        this.assessmentDataChange({
          eq2: val,
        });
      },
      eq3(val){
        this.assessmentDataChange({
          eq3: val,
        });
      },
      eq4(val){
        this.assessmentDataChange({
          eq4: val,
        });
      },
      eq5(val){
        this.assessmentDataChange({
          eq5: val,
        });
      },
      healthscale(val){
        this.assessmentDataChange({
          healthscale: val,
        });
      },
      //-- EQ5D5L Form
      //-- games & surveys
      
      checking(val){
        this.assessmentDataChange({
          checking: val,
        });
      },

      //-- fee & payment
      subsidy(val){
        this.assessmentDataChange({
          subsidy: val,
        });
      },
      //-- DSG
      subs1(val){
        this.assessmentDataChange({
          subs1: val,
        });
      },
      subs1val(val){
        this.assessmentDataChange({
          subs1val: val,
        });
      },
      dsgsubsidy(val){
        this.assessmentDataChange({
          dsgsubsidy: val,
        });
      },
      //-- DSG
      //-- Toteboard
      // subs2(val){
      //   this.assessmentDataChange({
      //     subs2: val,
      //   });
      // },
      // subsidyAmount(val){
      //   this.assessmentDataChange({
      //     subsidyAmount: val,
      //   });
      // },
      //-- Toteboard
      //-- fee & payment

      //-- Transport Included
      // transport: {
      //   handler(val){
      //     this.assessmentDataChange({
      //       transport: {
      //         ...val
      //       },
      //     });
      //   },
      //   deep: true,
      // },
      //-- Transport Included


      recommended_session_pick(val){
        this.assessmentDataChange({
          recommended_session_pick: val,
        });
      },
      applicableFeeTotal(val){
        this.assessmentDataChange({
          applicableFeeTotal: val,
        });
      },
      dsgOffDay: {
        handler(val){
          this.assessmentDataChange({
            dsgOffDay: {
              ...val,
            },
          });
        },
        deep: true,
      },
      adHocFeeTotal(val){
        this.assessmentDataChange({
          adHocFeeTotal: val,
        });
      },

      // //---- Service Agreement Form
      // clientReationship(val){
      //   this.assessmentDataChange({
      //     clientReationship: val,
      //   });
      // },
      // caregiverClientName(val){
      //   this.assessmentDataChange({
      //     caregiverClientName: val,
      //   });
      // },
      // caregiverClientIc(val){
      //   this.assessmentDataChange({
      //     caregiverClientIc: val,
      //   });
      // },
      // serviceAgreementContact(val){
      //   this.assessmentDataChange({
      //     serviceAgreementContact: val,
      //   });
      // },
      // serviceAgreementDate(val){
      //   this.assessmentDataChange({
      //     serviceAgreementDate: val,
      //   });
      // },
      // //---- Service Agreement Form

      //------------------ SAVE TO LOCAL STORAGE ------------------//
        secSession(val){
          if(val){
            this.CIPtotal();
          }

          this.assessmentDataChange({
            secSession: val,
          });
        },
        caregiverPicked(val) {
          const caregiver = this.caregiverDetails.find(c => c.crb5c_fow_caregiverid === val.crb5c_fow_caregiverid);
          if (caregiver) {
            // console.log('caregiver',caregiver)
            this.clientReationship = caregiver.crb5c_relationship || '';
            this.serviceAgreementContact = caregiver.crb5c_contactnumbermobile || '';
            this.serviceAgreementEmail = caregiver.crb5c_email || '';
            this.serviceAgreementName = caregiver.crb5c_name || '';
          } else {
            this.clientReationship = '';
            this.serviceAgreementContact = '';
          }
          // this.assessmentDataChange({
          //   caregiverPicked: val,
          // });
        },
      newSessionType(val){
        switch (val) {
          case 0:
            this.location =  'Center'
            break;
          case 1:
            this.location = 'Center'
            break;
          case 2:  
            this.location = 'Residence'
            break;
          case 3:
            this.location = 'Video-Call'
            break;
        }
      },
      firSession(val){
        if (val) {
          this.adm = val;
          this.CIPtotal();
        }

        this.assessmentDataChange({
          firSession: val,
        });
      },
      checker4(val){
        if (!this.previousAssessment && val) {
          this.additionalFeeTotal.push(this.additionalFees.one_time.price)
        }
        this.assessmentDataChange({
          isMocaForm: val,
        });
      },
      // isCipSelected:{
      //   deep: true,
      //   handler: function (val) {
      //     if(!val){
      //     this.totalforCIP = 0;
      //     this.CIPday = 0;
      //   }
      //   }
      // },
      // totalscore(value){
      //   if (value >= 18 && this.ovyearSelected) {
      //     console.log('moca:',this.totalscoreMoca,this.ovyearSelected )
      //     // this.neeurofitFeeTotal = this.neeuroFitFees;
      //     // this.neeuroFitAuto = true;
      //   }
        
      // },
      gp(value) {
        if( value === true) {
          this.ind = false;
        }
      },
      ind(value) {
        if( value === true) {
          this.gp = false;
        }
      },
      subsidyAmount(value){
        if(value === true){
          this.discount = this.subsidyAmount ? this.subsidyAmount/100 : 0;
        }

        this.assessmentDataChange({
          subsidyAmount: value,
        });
      },
      cn(value) {
        if (value === true) {
          this.en = false;
          this.language = 0;
        }
      },
      en(value) {
        if (value === true) {
          this.cn = false;
          this.language = 1;
        }
      },
      edulev(value){
        if(value === "Primary" || value === "No Education"){
          // checked
          this.unyearSelected = true;
          // checked
          // unchecked
          this.ovyearSelected = false;
          // unchecked
          this.un = true;
          this.ov = false;
          this.unpoint = 1;
          this.selectedyear = 0;
        }
        else {
          // unchecked
          this.unyearSelected = false;
          // unchecked
          // checked
          this.ovyearSelected = true;
          // checked
          this.un = false;
          this.ov = true;
          this.unpoint = 0;
          this.selectedyear = 1;
        }

        this.assessmentDataChange({
          edulev: value,
        });
      },
      unyearSelected(value) {
        if (value === true) {
          this.ovyearSelected = false;
          this.unpoint = 1;
        } else {
          this.unpoint = 0;
        }

        this.assessmentDataChange({
          unyearSelected: value,
        });
      },
      ovyearSelected(value) {
        if (value === true) {
          this.unyearSelected = false;
        }

        this.assessmentDataChange({
          ovyearSelected: value,
        });
      },

      typeses(value){
        if(value == 'Group'){
          this.location = 'Center';
        }
      },
      subs2(value){
        if(!value){
          this.subsidyAmount = null;
          this.transport.isIncluded = false;
          this.filterFees();
        }
        else{
          this.filterTypeValues = [];
          this.filterTypeValues.push(4)
        }

        this.assessmentDataChange({
          subs2: value,
        });
      },
      // isCIP(value){
      //   if(!value){
      //     this.totalGST = this.totalGST.filter(item => item !== '240');
      //   }else{
      //     this.totalGST.push('240');
      //   }
      // },
      transport: {
        async handler(value){
          if(value.isIncluded){
            if(!value.startPostalCode){
              this.transport.startPostalCode = await this.getAndSetClientTransportPostalCode();
              return;
            }
          }

          if(!value.isIncluded){
            this.transport.amountToBePaid = null;
          }

          this.assessmentDataChange({
            transport: {
              ...value,
            },
          });

        },
        deep: true,
      },
      
      // Watch override flags and save to localStorage
      manualCipEligibility(val) {
        this.assessmentDataChange({
          manualCipEligibility: val,
        });
      },
      
      programmeOverride(val) {
        this.assessmentDataChange({
          programmeOverride: val,
        });
      },

    },
    computed: {
      isPhase3Completion(){
        return this.previousAssessment?.crb5c_cipphase === 3;
      },
      cipEligibility(){
        // Phase 3 clients are no longer CIP eligible - they must complete or switch to FOW
        if (this.isPhase3Completion) {
          return false;
        }
        
        // Priority 1: Check if programmeOverride is forcing FOW
        if (this.programmeOverride === 'FOW') {
          return false;
        }
        
        // Priority 2: Check if programmeOverride is forcing CIP
        if (this.programmeOverride === 'CIP') {
          return true;
        }
        
        // Priority 3: Check manual eligibility override
        if (this.manualCipEligibility === true) {
          // Still need cipPreset and not notJoining for manual override to work
          if (!this.cipPreset || this.notJoining) {
            return false;
          }
          return true;
        }
        
        if (this.manualCipEligibility === false) {
          return false;
        }
        
        // Default: Use automatic logic based on cipPreset and score
        if (this.cipPreset && !this.notJoining) {
          if (this.totalscore >= 10 && this.totalscore <= 25) {
            return true;
          } else {
            return false;
          }
        }
        return false
      },
      fowDescription(){
        if (!this.adm || !dayjs(this.adm).isValid()) return '';
        if (!this.fowSessionDates.sessions || !this.fowSessionDates.sessions.length) return '';

        const groupedSessions = this.fowSessionDates.sessions.reduce((acc, dateStr) => {
          const month = dayjs(dateStr, 'ddd, DD MMM YYYY').format('MMMM YYYY');
          if (!acc[month]) acc[month] = [];
          acc[month].push(dateStr);
          return acc;
        }, {});

        const description = Object.keys(groupedSessions)
          .sort((a, b) => dayjs(a, 'MMMM YYYY').toDate() - dayjs(b, 'MMMM YYYY').toDate())
          .map(month => {
            const dates = groupedSessions[month]
              .map(dateStr => dayjs(dateStr, 'ddd, DD MMM YYYY').format('DD/MM/YYYY'))
              .map(d => `<li>${d}</li>`)
              .join('');
            return `
              <p>FOW ${month} Program Fee - [$${this.totalOfApplicable}] per session</p>
                <ul>
                  ${dates}
                </ul>
              </li>
            `;
          })
          .join('');

        return description;
        
      },
      cipDescription() {
          if (!this.cipAdm) return '';
          if (!this.recommended_session_pick || !Array.isArray(this.recommended_session_pick)) return '';
          if (!this.allHolidays || !Array.isArray(this.allHolidays)) return '';
          
          const start = dayjs(this.cipAdm);
          if (!start.isValid()) return '';

          const  sessions  = this.cipSessionDates.sessions;
          if (!sessions.length) return '';

          const firstDate = dayjs(sessions[0], "ddd, DD MMM YYYY");
          const lastDate = dayjs(sessions[sessions.length - 1], "ddd, DD MMM YYYY");

          if (firstDate.format("MMMM YYYY") === lastDate.format("MMMM YYYY")) {
            return `In ${firstDate.format("MMMM YYYY")}`;
          }
          
          return `From ${firstDate.format("DD MMMM YYYY")} to ${lastDate.format("DD MMMM YYYY")}`;

          // const allowedDays = this.recommended_session_pick.map(s => s.crb5c_day);
          // const sessions = [];
          // let current = start;

          // while (sessions.length < this.cipPhase) {
          //   if (allowedDays.includes(current.day())) {
          //     sessions.push(current);
          //   }
          //   current = current.add(1, 'day');
          // }

          // const firstDate = sessions[0].format('D-MMMM-YYYY');
          // const lastDate = sessions[sessions.length - 1].format('D-MMMM-YYYY');

          // return firstDate === lastDate
          //   ? `In ${firstDate}`
          //   : `From ${firstDate} to ${lastDate}`;
        },
        isAdmissionNextMonth() {
          if (this.cipEligibility) return false;
          if (!this.adm || !dayjs(this.adm).isValid()) return false;
          return dayjs(this.adm).startOf('month').isAfter(dayjs().endOf('month'));
        },
        fowSessionDates() {
          if (this.cipEligibility) return { sessions: [], skipped: [] };
          if (!this.adm || !dayjs(this.adm).isValid()) return { sessions: [], skipped: [] };
          if (!this.recommended_session_pick || !Array.isArray(this.recommended_session_pick)) return { sessions: [], skipped: [] };
          if (!this.allHolidays || !Array.isArray(this.allHolidays)) return { sessions: [], skipped: [] };

          const allowedDays = this.recommended_session_pick.map(s => s.crb5c_day);
          if (allowedDays.length === 0) { return { sessions: [], skipped: [] }; }

          const start = dayjs(this.adm);
          const endOfMonth = start.endOf("month");

          const holidayMap = new Map(this.allHolidays.map(h => [dayjs(h.date).format("YYYY-MM-DD"), h.holiday]));

          const sessions = [];
          const skipped = [];
          let current = start.startOf("day");

          while (current.isBefore(endOfMonth) || current.isSame(endOfMonth, "day")) {
            const formattedDate = current.format("YYYY-MM-DD");
            if (allowedDays.includes(current.day())) {
              if (holidayMap.has(formattedDate)) {
                skipped.push(`${current.format("ddd, DD MMM YYYY")} (${holidayMap.get(formattedDate)})`);
              } else {
                sessions.push(current.format("ddd, DD MMM YYYY"));
              }
            }
            current = current.add(1, "day");
          }

          console.log("FOW Skipped Holidays:", skipped);
          return { sessions, skipped };
        },

        cipSessionDates() {
          if (!this.cipAdm || !dayjs(this.cipAdm).isValid()) return { sessions: [], skipped: [] };
          if (!this.recommended_session_pick || !Array.isArray(this.recommended_session_pick)) return { sessions: [], skipped: [] };
          if (!this.allHolidays || !Array.isArray(this.allHolidays)) return { sessions: [], skipped: [] };
          if (this.recommended_session_pick.length === 0) return { sessions: [], skipped: [] };

          const allowedDays = this.recommended_session_pick.map(s => s.crb5c_day).filter(day => day != null);

          if (allowedDays.length === 0) {
            return { sessions: [], skipped: [] };
          }

          const holidayMap = new Map(this.allHolidays.map(h => [dayjs(h.date).format("YYYY-MM-DD"), h.holiday]));

          const start = dayjs(this.cipAdm);
          const sessions = [];
          const skipped = [];
          let current = start;

          while (sessions.length < this.cipPhase) {
            const formattedDate = current.format("YYYY-MM-DD");
            if (allowedDays.includes(current.day())) {
              if (holidayMap.has(formattedDate)) {
                skipped.push(`${current.format("ddd, DD MMM YYYY")} (${holidayMap.get(formattedDate)})`);
              } else {
                sessions.push(current.format("ddd, DD MMM YYYY"));
              }
            }
            current = current.add(1, "day");
          }

          // console.log("CIP Skipped Holidays:", skipped);
          return { sessions, skipped };
        },
        sessionsThisMonth() {
          const currentMonth = dayjs().month();
          const currentYear = dayjs().year();

          return this.cipSessionDates.sessions.filter(dateStr => {
            const date = dayjs(dateStr, 'ddd, DD MMM YYYY');
            return date.month() === currentMonth && date.year() === currentYear;
          }).length;
        },
      formattedTemplates(){
        if(!this.cipTemplates) return [];
        const isCip2 = this.isCip2Client;
        const bornBefore = this.clientBornBefore1970;
        const isSg = this.checknationality; // true = SG citizen, false = PR/LTVP
        return this.cipTemplates
          .filter(item => {
            // Fee generation gate: CIP 2.0 clients (admitted 1-Jul-2026 onwards) see only
            // the new rows; everyone else keeps the pre-CIP-2.0 rows. Old clients doing a
            // follow-up phase after the cutoff stay on the old structure.
            if (isCip2 ? item.crb5c_iscip2 !== true : item.crb5c_iscip2 === true) return false;
            if (isSg) {
              if (item.crb5c_for_citizen !== true) return false;
              // SG CIP 2.0 splits into "born 1969 or before" vs "born after 1969".
              if (isCip2 && item.crb5c_born1969orbefore !== bornBefore) return false;
              return true;
            }
            return item.crb5c_for_pr === true;
          })
          .map(item => this.mapFeeRowToTemplate(item));
      },
      // axiosReady(){
      //   if (this.$store.state.axios) {
      //     return true;
      //   }
      //   else{
      //     return false;
      //   }
      // },
      CipPrgrammeSummary(){
        let programmeName = [];

        if (this.CIPdays) {
          for( let programme of this.applicableFeeTotal ){
          if(programme.crb5c_type === 4){
            programmeName.push({name: programme.crb5c_programmename, quantity: this.CIPdays, cost: programme.crb5c_price, isCip: true})
          }
        }
        }
        if(this.transport.isIncluded){
          programmeName.push({name: 'Transport Fee', quantity: this.CIPdays, cost: (this.transport.fixedFee * (1 - ((this.subsidyAmount ?? 0) / 100))).toFixed(2) })
        }
        if(this.transport.amountToBePaid){
          programmeName.push({name: 'Additional Transport Fee', quantity: this.CIPdays, cost: this.transport.amountToBePaid })
        }
        
        return  programmeName;
      },
      selectedProgrammeSummary(){
        let programmeName = [];
        // if (this.applicableFeeTotal.length) {
        //   for( let programme of this.applicableFeeTotal ){
        //   if(programme.crb5c_type === !4){
        //     programmeName.push({name: programme.crb5c_programmename, quantity: 1, cost: programme.crb5c_price, isCip: false})
        //   }
        // }
        // }
        if(this.neeurofitFeeTotal){
          if (this.neeuroFitAuto) {
            programmeName.push({name: 'NeeuroFIT 6 months subcription', quantity: 1, cost:'Included'})
          }
          else{
            programmeName.push({name: 'NeeuroFIT 6 months subcription', quantity: 1, cost:this.neeurofitFeeTotal, type: 2})
          }
        }

        if (this.additionalFeeTotal.length) {
          programmeName.push({name: 'One-time Assessment', quantity: 1, cost:this.additionalFeeTotal[0], type: 0})
        }

         if (this.refundableFeeTotal) {
          programmeName.push({name: 'Refundable Deposit (No GST)', quantity: 1, cost:this.refundableDeposit, noGst: true, type: 'depo'})
        }

        if (this.subs1 && this.subs1val && this.dsgsubsidy) {
          if(this.subs1 && this.subs1val && this.dsgsubsidy == '$'){
            programmeName.push({name: 'DSG Subsidy DEDUCTED', quantity: 1, cost: '- $' + this.subs1val})
          }
        if (this.subs1 && this.subs1val && this.dsgsubsidy == '%') {
            programmeName.push({name: 'DSG Subsidy DEDUCTED', quantity: 1, cost: '- ' + this.subs1val+ ' %' })

          }
        } 
        if (this.adHocFeeTotal.length) {
          for( let adhoc of this.adHocFeeTotal){
            programmeName.push({name: adhoc.remark, quantity: 1, cost: adhoc.total, type: 2 })
          }
        }
        // console.log('programmeName',programmeName)
        return programmeName;
      },
      // clientReationship(){
      //   let val = '';
      //   if(this.caregiverPicked){
      //     val = this.caregiverDetails.find(c => c.crb5c_fow_caregiverid === this.caregiverPicked)?.crb5c_relationship;
      //   }
      //   return val; 
      // },
      // autoSelectNeeuroFIt(){
      //   if (this.mocaVal) {
      //     if (this.mocaVal >= 18 && this.ovyearSelected) {
      //       this.neeurofitFeeTotal = this.neeuroFitFees;
      //     }
      //   }
      // },
      isAddButtonDisabled() {
        return this.pick_sessions.length === 0;
      },
      filteredChoice() {
        return this.schedule_info.filter(
          (option2) => !this.recommended_session_pick.some((option1) => option1.crb5c_fow_session_scheduleid === option2.crb5c_fow_session_scheduleid)
        );
      },
      transportTotalView(){
        if(this.transport.isIncluded){
          let total_amount = 0;
          total_amount = (this.transport.fixedFee * (1 - (this.subsidyAmount ?? 0) / 100)) + (this.transport.amountToBePaid ? + this.transport.amountToBePaid : 0);
          return total_amount;
        }
        return 0;
      },
      //get list of newly created invoices
      invoicesList(){
        if (!this.invoices?.length) return '';
        let baseRef = this.invoices.length > 1
          ? this.invoices.map(invoice => invoice.crb5c_id).join(',')
          : this.invoices[0].crb5c_id;
        if (this.depositPaid && this.refundableFeeTotal) {
          baseRef = baseRef + "+DEPOSIT";
        }
        return baseRef;
      },
      depositOnlyRef() {
        const partialNric = (this.clientdata?.crb5c_partialnric || '').toUpperCase();
        const name = (this.clientdata?.crb5c_no || '');
        const type = this.cipEligibility ? 'CIP' : 'FOW';
        return `${type}-DP-${partialNric.padStart(4, '~')}-${name.toUpperCase().replace(/[^A-Z]/gi, '').substring(0, 10)}`;
      },
      depositOnlyPaynowString() {
        if (!this.depositOnlyAmount || this.depositOnlyAmount <= 0) return '';
        const qrcode = new PaynowQR({
          uen: '202111519KDSG',
          amount: parseFloat(this.depositOnlyAmount).toFixed(2),
          refNumber: this.depositOnlyRef,
          company: 'Dementia Singapore Ltd. - Acc 1',
        });
        return qrcode.output();
      },
      paynowString(){
          if (!this.invoices?.length) return '';
          let refNumber = this.invoices[0].crb5c_id;
          if (this.depositPaid && this.refundableFeeTotal) {
            refNumber = refNumber + "+DEPOSIT";
          }
          let qrcode = new PaynowQR({
              uen:'202111519KDSG',
              amount : this.toPayAmount.toFixed(2),
              refNumber: refNumber,
              company:  'Dementia Singapore Ltd. - Acc 1',               
            });
            return qrcode.output();
      },
      qroptions(){
          return{
              errorCorrectionLevel:"H",
              color:{
                  dark:"#7C1978"
              }
          }
      },
      is1stAM(){
        return this.firstSesFormat == 0 ? 'AM' : 'PM';
      },
      is2ndAM(){
        return this.secondSesFormat == 0 ? 'AM' : 'PM';
      },
      // isCipSelected(){
      //   if(this.applicableFeeTotal.length) {
      //     for(let totalApplicable of this.applicableFeeTotal){
      //       if (totalApplicable.crb5c_type === 4) {
      //         return true;
      //       }
      //       return false
      //     }
      //   }
      //   return false
      // },
      totalOfAdditional(){
        if (this.additionalFeeTotal.length) {
            let total_amount = 0;
            for(let totalAdditional of this.additionalFeeTotal){
                total_amount = total_amount + parseInt(totalAdditional);
              }
          return total_amount;
          }
          return 0;
      },
      totalOfNeeurofit(){          
          if(this.neeurofitFeeTotal){
            let total_amount = 0;
            total_amount = total_amount + this.neeuroFitFees ;
            return total_amount;
            
          }

          return 0;
      },
      totalofAddhoc(){
        if(this.adHocFeeTotal.length){
          let total_amount = 0;
          for(let adhoc of this.adHocFeeTotal){
            if (adhoc.isIncludeInFee) {
              total_amount = total_amount + parseInt(adhoc.total) ;
            }

          }
          return total_amount;
        }return 0;
      },
      totalOfApplicable(){
        if(this.applicableFeeTotal.length && this.applicableFeeTotal.length ) {
          let total_amount = 0;
          for(let totalApplicable of this.applicableFeeTotal){
            if(totalApplicable.crb5c_type !== 4){
              total_amount = total_amount + totalApplicable.crb5c_price;
            }
          }
        return total_amount;
        }
        return 0;    
      },
      totalOfApplicableForDeposit(){
        if(this.applicableFeeTotal.length && this.applicableFeeTotal.length ) {
          let total_amount = 0;
          for(let totalApplicable of this.applicableFeeTotal){
            total_amount = total_amount + totalApplicable.crb5c_price;
          }
        return total_amount;
        }
        return 0;    
      },
      calculateCipCost(){
        return this.totalforCIP ? (this.totalforCIP)*1.09 : 0;
      },
      calculateCipCostNoGST(){
        return this.totalforCIP ? (this.totalforCIP) : 0;
      },
      filteredProgrammeInfos(){
        let filteredProgramme = []

        for (let type of this.filterTypeValues){
          filteredProgramme.push(...this.programmeInfos.filter((item) => {
          return item.crb5c_type === type;
          }))
        }
        return filteredProgramme;
      },
      viewamtcollectNoGST(){   
        let refundable = this.refundableFeeTotal ? this.refundableDeposit : 0;
        let GSTtotal = (this.totalOfAdditional + this.totalOfNeeurofit);
        let additionalTransport = this.cipAdditionalTransport * this.cipPhase;
        let addHocAdditional = this.totalofAddhoc ? (this.totalofAddhoc) : 0;
        // let cipFees = this.selectedCipTemplate ? this.selectedCipTemplate.Oop : 0;

        if (this.cipEligibility) {
          const feePerSession = this.cipEstimatedFee;
          const totalCip = feePerSession * this.cipPhase;
          return (parseFloat(GSTtotal.toFixed(2)) + addHocAdditional + totalCip + additionalTransport);
        }
        else{
          const fowMonthlyFee = this.isAdmissionNextMonth ? 0 : (this.fowSessionDates?.sessions?.length * this.totalOfApplicable);
          return (parseFloat(GSTtotal.toFixed(2))  + addHocAdditional + refundable + additionalTransport + fowMonthlyFee) ;
        }
        // let dsgsubsidiyval = this.checkdsgsubsidy((refundable + this.totalOfNeeurofit));
        // let cipCost = this.calculateCipCostNoGST;
        // let CIPAdditional = this.totalOfAdditional ? (this.totalOfAdditional) : 0;
        // const transportFee = this.transport.isIncluded ? (this.transport.fixedFee * (1 - (this.subsidyAmount ?? 0) / 100)) : 0;
        // const transportAdditionalFee = this.transport.amountToBePaid ? +this.transport.amountToBePaid : 0;
        // const totalTransportFeeWithGST = (transportFee + transportAdditionalFee);
      },
      toPayAmount(){
        if(this.depositPaid){
          return this.viewamtcollect;
        }
        else{
          return (this.viewamtcollect - (this.refundableFeeTotal ? this.refundableDeposit : 0));
        }
        
      },
      viewamtcollect(){    
        let refundable = this.refundableFeeTotal ? this.refundableDeposit : 0;
        let GSTtotal = (this.totalOfAdditional + this.totalOfNeeurofit) * this.GST;
        let additionalTransport = (this.cipAdditionalTransport * this.GST) * this.cipPhase;
        // let cipFees = this.selectedCipTemplate ? this.selectedCipTemplate.Oop : 0;
        let addHocAdditional = this.totalofAddhoc ? (this.totalofAddhoc * this.GST) : 0;

        if (this.cipEligibility) {
          const feePerSession = this.cipEstimatedFee;
          const totalCip = (feePerSession * this.cipPhase) * 1.09;
          return (parseFloat(GSTtotal.toFixed(2)) + addHocAdditional + totalCip + additionalTransport);
        }
        else{
          const fowMonthlyFee = this.isAdmissionNextMonth ? 0 : (this.fowSessionDates?.sessions?.length * this.totalOfApplicable) * this.GST;
          return (parseFloat(GSTtotal.toFixed(2)) + addHocAdditional + refundable + additionalTransport + fowMonthlyFee) ;
        }

        // let dsgsubsidiyval = this.checkdsgsubsidy((refundable + this.totalOfNeeurofit * this.GST));
        // let cipCost = this.calculateCipCost;
        // let CIPAdditional = this.totalOfAdditional ? (this.totalOfAdditional*this.GST) : 0;
        // const transportFee = this.transport.isIncluded ? (this.transport.fixedFee * (1 - (this.subsidyAmount ?? 0) / 100)) : 0;
        // const transportAdditionalFee = this.transport.amountToBePaid ? +this.transport.amountToBePaid : 0;
        // const totalTransportFeeWithGST = (transportFee + transportAdditionalFee) * this.GST;
        // if (this.isCipSelected) {
        //   return (GSTtotal + cipCost + CIPAdditional + addHocAdditional) + (totalTransportFeeWithGST * this.CIPdays);
        // }
        // else{
        //   return (GSTtotal + cipCost + addHocAdditional + refundable - dsgsubsidiyval ) + (totalTransportFeeWithGST *  this.CIPdays);
        // } 

      },
      cipEstimatedFee(){
        if (this.selectedCipTemplate && this.cipEligibility) {
          if (this.transportInclude) {
            return this.roundUp(this.selectedCipTemplate.Oop + this.selectedCipTemplate.transport);
          }
          return this.roundUp(this.selectedCipTemplate.Oop);
        }
        return 0;
      },
      checknationality(){
        if (this.clientdata.crb5c_citizenship == 1 || this.clientdata.crb5c_citizenship == 2) {
          return false;
        }
        else{
          return true;
        }
      },

      isCip2Client(){
        const adm = this.clientdata?.crb5c_admissiondate;
        if (!adm) return true;
        return !dayjs(adm).isBefore(dayjs('2026-07-01'), 'day');
      },

      clientBornBefore1970(){
        const dob = this.clientdata?.crb5c_dob;
        return !!dob && dayjs(dob).year() <= 1969;
      },

      cipPricingSetLabel(){
        const gen = this.isCip2Client ? 'CIP 2.0 (admitted on/after 1 Jul 2026)' : 'Pre-CIP 2.0';
        if (this.checknationality && this.isCip2Client) {
          return `${gen} · SG · ${this.clientBornBefore1970 ? 'born 1969 or before' : 'born after 1969'}`;
        }
        return `${gen} · ${this.checknationality ? 'Singapore Citizen' : 'PR/LTVP'}`;
      },
      prORsg(){
        if(this.clientdata.crb5c_citizenship == 0){
          return 'SG';
        }
        else if(this.clientdata.crb5c_citizenship == 1){
          return 'PR';
        }
        else{
          return 'SG or PR';
        }
      },
      refundableDeposit(){
        // Use totalOfApplicableForDeposit to include type 4 programmes
        if (this.totalOfApplicableForDeposit) {
          return this.totalOfApplicableForDeposit * 4;
        }
        return 0;
        
      },
      oneTimeOtherValue(){
        if(this.one_time_other_value){
          return this.one_time_other_value
        }
        return 0;
      },
      fees4val(){
        if(this.subsidyAmount){
          return 83 - (this.normcost * (parseInt(this.subsidyAmount)/100));
        }
        return 83;
      },
      checkfluency(){
        return (this.vis18 == '11' || this.vis18 == 'more than 11') ? 1 : 0;
      },
      delayedrecall(){
        return (this.vis15.includes("Cannot Recall(0 point)"))? 0: this.vis15.length;
      },
      fluencyPoints(){
        return (this.vis18 == '11' || this.vis18 == 'more than 11') ? 1 : 0;
      },
      totalscore: function () {
        let length1 = this.vis3.length;
        let length3 = this.vis16.length;
        let vis18_point = (this.vis18 == '11' || this.vis18 == 'more than 11') ? 1 : 0;
        let vis15_point =  (this.vis15.includes("Cannot Recall(0 point)"))? 0: this.vis15.length;
        return (
          parseInt(this.vis1) +
          parseInt(this.vis2) +
          length1 +
          parseInt(this.vis4) +
          parseInt(this.vis5) +
          parseInt(this.vis6) +
          parseInt(this.vis7) +
          parseInt(this.vis8) +
          parseInt(this.vis9) +
          parseInt(this.vis10) +
          parseInt(this.vis11) +
          parseInt(this.vis12) +
          parseInt(this.vis13) +
          parseInt(this.vis14) +
          vis15_point +
          length3 +
          parseInt(this.vis17) +
          vis18_point +
          this.unpoint
        );
      },
      eq5dcounter: function () {
        return (
          parseInt(this.eq1) +
          parseInt(this.eq2) +
          parseInt(this.eq3) +
          parseInt(this.eq4) +
          parseInt(this.eq5)
        );
      },
      
      // Helper computed properties for override buttons
      manualEligibilityButtonText() {
        if (this.manualCipEligibility === true) {
          return 'Remove Manual Override';
        }
        return 'Set CIP Eligible';
      },
      
      manualEligibilityButtonVariant() {
        if (this.manualCipEligibility === true) {
          return 'warning';
        }
        return 'info';
      },
      
      programmeOverrideButtonText() {
        const currentlyOnCip = this.cipEligibility;
        if (this.programmeOverride) {
          return `Switch to ${currentlyOnCip ? 'FOW' : 'CIP'} (Override Active)`;
        }
        return `Switch to ${currentlyOnCip ? 'FOW' : 'CIP'}`;
      },
      
      programmeOverrideButtonVariant() {
        if (this.programmeOverride) {
          return 'warning';
        }
        return 'secondary';
      },
      
      showEligibilityControls() {
        // Show controls if client has cipPreset or if manual override is active
        return (this.cipPreset || this.manualCipEligibility) && !this.notJoining;
      }
  }}
  
  //font: roboto
  </script>
  
  <style lang="scss" scoped>
  $base-color-purple :#50276B;
  
  * {
    // font-family: 'Montserrat';
  }

  // Remove input number Arrows/Spinners css
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  .container {
    border-radius: 10px;
    border: 1px solid rgb(142, 142, 142);
    background:#ffffff;
    padding: 2rem;
    margin: auto;
    display: block;
    justify-content: center;
    text-align: left;
  }
  
  .submitbtn{
    text-align: center;
    margin: 70px 0px 28px; 
  }

  .invalid{
    border: 1px solid red !important;
    background-color: #ffeaea;
  }

  .moca-point-selected {
    ::v-deep .vs__dropdown-toggle {
      background-color: #e8ffee !important;
      // border-color: #000000 !important;
    }
  }

  .generateInvoice{
    text-align:left;
    margin-top: 60px;  
  }
  
  .sm-container {
    border-radius: 16px;
    border: 1px solid #ccc;
    padding: 1rem;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    // position: relative;
    // left: 30%;
    width: 160px;
    height: 8rem;
  }
  
  label.common {
    font-weight: bold;
    display: flex;
    margin-bottom: 0.5rem;
    margin-left: 0;
    // width: 35.5vw;
  }

.cip-template-card {
  transition: all 0.2s ease-in-out;
  border: 1px solid #e1e1e1;;
}
.cip-template-card:hover {
  border-color: #8a0dd7;
  box-shadow: 0 0 10px rgba(171, 113, 236, 0.2);
}
.cip-template-card.selected {
  border-color: #8a0dd7;
  background-color: #e9f5ff;
}
  
  p.common {
    font-weight: bold;
    display: flex;
    margin-bottom: 0.5rem;
  }
  
  label.inside {
    display: flex;
    margin-bottom: 0.5rem;
    // max-width: 15vw;
  }
  
  @media screen and (max-width: 411px) {
    .text-small {
      // display: none;
      // background-color: red;
      margin: 0;
      font-size: 3vw;
    }
  }
  
  .long {
    font-size: 15px;
  }
  
  input.common {
    display: flex;
    width: 100%;
    height: 1.5rem;
    font: inherit;
    padding: 0.2rem;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .dates_list{
    background-color: #f6f5f5;
    border-radius: 5px;
  }
  
  textarea {
    display: flex;
    width: 70%;
    height: 5.5rem;
    font: inherit;
    padding: 0.2rem;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  .numbers {
    display: flex;
    width: 100%;
    height: 2rem;
    font: inherit;
    padding: 0.2rem;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  .checkbox {
    display: flex;
    height: 2rem;
    width: 125px;
    font: inherit;
    margin-bottom: 10px;
    padding: 0.2rem;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  
  
  .amountjustify{
    justify-content: right;
    margin-right: 30px;
  }

  .numberslider{
    text-align: center;
    display: flex;
    width: 50%;
    height: 2rem;
    font: inherit;
    padding: 0.2rem;
    border: 1px solid rgb(228, 228, 228);
    border-radius: 5px;
  }
  
  .numbers-half {
    display: flex;
    width: 50%;
    height: 2rem;
    font: inherit;
    padding: 0.2rem;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .numbers-full{
    display: flex;
    width: 100%;
    height: 2rem;
    font: inherit;
    padding: 0.2rem;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  .small-input-width {
    display: flex;
    width: 20%;
    height: 2rem;
    font: inherit;
    padding: 0.2rem;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  .payment-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
}

.qr-code-container {
  margin: 20px 0;
}

.background-container {
  background: linear-gradient(135deg, #ec3965, #972887);
  padding: 20px;
  border-radius: 10px;
  display: inline-block;
}
.logo-background {
  background-color: #ffffff;
  padding: 5px;
  border-radius: 5px;
  display: inline-block;
}
.paynow-logo-container {
  margin-top: 20px;
}
  select.common {
    display: flex;
    width: 100%;
    height: 2rem;
    font: inherit;
    padding: 0.2rem;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  select.inside {
    display: flex;
    width: 100%;
    height: 2rem;
    font: inherit;
    padding: 0.2rem;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  input:focus,
  textarea:focus {
    outline: none;
    // border-color: $tq;
    border-color: #3a0061;
    background-color: #f7ebff;
  }
  .formed {
    position: relative;
    /* padding-left: 90px; */
    /* margin-right: 3rem; */
  }
  
  .gap {
    margin-top: 2rem;
    margin-bottom: 10px
  }
  .gap-twice {
    margin-top: 2rem;
  }
  .gapped {
    margin-left: 1rem;
  }
  .gapbot {
    margin-bottom: 2rem;
  }
  .left {
    text-align: left;
  }
  
  hr {

    border-width: 2px;
    border-color: #00000059;
    display: block;
    // max-width: 100%;
  }
  .moca {
    font-weight: bold;
  }
  
  .image_container_number{
      display: block;
      width: 315px;
      height: 220px;
      margin: auto;
      object-fit: contain;
  }

  .timeEdit{
  background: rgba(255, 255, 255, 0);
  border: none;
  color: rgb(140, 63, 211);
}
  
  .image_container_lion{
      width: 265px;
      margin: auto;
      -moz-transform: scale(-1, -1);
      -o-transform: scale(-1, -1);
      -webkit-transform: scale(-1, -1);
      transform: scale(-1, 1);
  }
  
  .image_container_elephant{
      width: 260px;
      margin: auto;
  }
  
  .image_container_camel{
      width: 230px;
      margin: auto;
  }
  
  .image_container_cube{
      display: block;
      width: 286px;
      height: 220px;
      margin: auto;
      object-fit: contain;
  }
  
  .center_items_row{
    justify-content: center;
  }
  
  .center{
    gap: 60px;
  }

  .delete_icon{
    font-size: 25px;
    margin-left: 15px;
    color: #e33838;
  }

  .large_icon{
    font-size: 150px;
    margin: 20px;
    color: #393939;
  }

  .text-background{
    background-color: #e9e9e9;
    border-radius: 5px;
    padding: 10px;
    font-weight: bold;
  }

  .sig-canvas {
        width: 80vh;
        height: 30vh;
        border-style: dotted;
        background-color: rgba(203, 203, 203, 0);
        border: solid 1px dotted rgb(172, 172, 172);
        border-radius: 5px;
    }
  
  .font_bold{
    font-weight: bold;
  }

  .addtional_fee{
    border: 1px Solid #e2e2e2;
    padding: 2vh;
    width: 100vh;
  }

  .modified_remark_input{
    border: 1px Solid #b5b5b5;
    width: 40vh;
  }

  .qr_code{
    width: 250px;
  }

  .checkboxSelection{
    border: 1.5px solid #d3d3d3;
    border-radius: 5px;
    padding: 25px;
    margin: 5px;
    height: 100px;
    width: 450px;
  }
  
  .checkboxSelectionSelected{
    border: 3px solid #b183d7;
    border-radius: 5px;
    padding: 25px;
    margin: 5px;
    height: 100px;
    width: 450px;
  }
  
  .checkboxImg{
    width: 50px;
  }

  .payment-method-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
    justify-content: center;
  }

  .payment-method-tile {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 150px;
    height: 110px;
    border: 2px solid #d3d3d3;
    border-radius: 12px;
    background: #fff;
    cursor: pointer;
    transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
    user-select: none;
    margin: 0;
    padding: 12px 8px;
    &:hover {
      border-color: #b183d7;
      box-shadow: 0 2px 8px rgba(145,112,147,0.18);
    }
  }

  .payment-method-tile--selected {
    border-color: #917093;
    border-width: 2.5px;
    background: #f8f2fb;
    box-shadow: 0 2px 10px rgba(145,112,147,0.22);
  }

  .payment-method-tile__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 52px;
    margin-bottom: 8px;
  }

  .payment-method-tile__label {
    font-size: 13px;
    font-weight: 600;
    color: #50276B;
    text-align: center;
    letter-spacing: 0.02em;
  }
  
  .header_title{
    background: #502b73;
    padding: 10px;
    text-align: center;
    color: white;
    font-size: 20px;
    font-weight: 600;
  }
  .centerCheckbox{
    font-size: 16px;
    display: inline-flex;
  }
  
  .progressbarstyle{
    background: rgb(118, 80, 137); 
  }
  .signatureView{
        width: 80vh;
        background-color: rgba(203, 203, 203, 0);
        border: solid 1px rgb(172, 172, 172);
        border-radius: 5px;
  }

  .text-center{
    text-align: center;
  }

  .confimrationBtn{
    width: 20vh;
  }
  .checkbox_circle{
    border-radius: 50%;
    height: 20px;
    width: 20px;  
    margin: auto;   
    border-color: transparent !important;   
    opacity: 0.65;
    transition: all 0.5s;
  }

  .btn-transparent{
    border: none;
    background: rgba(253, 253, 253, 0);
    color: black;
  }

  .icon-loader{
    font-size: 20vh;
  }

  .input-border-light{
    border: 1px Solid rgb(210, 210, 210);
  }

  .main-container{
    border: 1px Solid rgb(255, 255, 255);
  }


  </style>
  